import styled, { css, keyframes } from "styled-components";
import { lightTheme } from "../theme/lightTheme";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useContext } from "react";
import { DarkModeContext } from "../../../contexts/darkMode";

export const slideIn = keyframes`
  from{
    opacity: 0;
  }
  to{
    opacity: 1;
  }
`;

export const ContainerPoupop = styled.div`
    display: ${({ theme }) => theme.display.flex};
    align-items: ${({ theme }) => theme.align_items.center};
    width: ${props => props.min_width !== '' ? props.min_width : '220px' };
    border: ${({ theme }) => theme.border.very_small_gray5};
    border-radius:  ${({ theme }) => theme.border_radius.small};
    height:  ${props => props.height  ?? props.theme.height._48};

    .my-css{
      outline: none;
      box-shadow: none;   
      display: ${({ theme }) => theme.display.flex};
      align-items: ${({ theme }) => theme.align_items.center};
      justify-content: ${({ theme }) => theme.justify_content.space_between};
      width: 100%;
    }

    .dropdown{
        width: ${props => props.min_width !== '' ? props.min_width : '220px' }; 
    }

    .dropdown  button{
      display: -webkit-box;
      width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      font-weight: ${({ theme }) => theme.font_weight.medium};
      font-size: 14px;
      line-height: 18px;
      color: ${({ theme }) => theme.colors.black};
    }
    
    .dropdown-menu {
      display: flex;
      flex-direction: column;
      overflow-y: auto;
      min-width: ${props => props.min_width !== '' ? props.min_width : '220px' };
      border: ${({ theme }) => theme.border.very_small_gray5};
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      border-radius: ${({ theme }) => theme.border_radius.medium};
      font-size: ${({ theme }) => theme.font_size.small};
      line-height: ${({ theme }) => theme.lines_height.medium};
      height: 182px;
      transform: translate(0, 40px) !important;
      width: 100%;
      background-color: ${({ theme }) => theme.backgrounds.white};
    }

      .dropdown button {
        padding: 0;
      }

      .dropdown button input {
        border: none;
      }

    .dropdown-item {
      color: ${({ theme }) => theme.colors.black};
      padding: 12px 10px;
    }

    .dropdown-item:hover, :focus{
      background-color: ${props => props.theme.backgrounds.gray7};
    }
    
`;

export const Hr = styled.hr`
  width: 100%;
  border-bottom: ${({theme}) => theme.border.very_small_gray};
  margin: 12px 0 0 0;
`;

export const Fieldset = styled.fieldset`
  border: ${({ theme }) => theme.border.small};
  border-radius: ${({ theme }) => theme.border_radius.small};
  width: 100%;
  padding: ${({ theme }) => theme.paddings.medium};
  margin-top: 12px;
`;

export const Legend = styled.legend`
  text-align: left;
  width: auto;
  font-weight: ${({ theme }) => theme.font_weight.large};
  font-size: ${({ theme }) => theme.font_size.medium};
  line-height: ${({ theme }) => theme.lines_height.large};
  color: ${({ theme }) => theme.colors.gray};
`;


export const P = styled.p`
  font-weight: ${({ theme }) => theme.font_weight.large};
  font-size: ${(props) => props?.font_size ?? props.theme.font_size.medium}!important;
  line-height: ${({ theme }) => theme.lines_height.large};
  color: ${({ theme }) => theme.colors.gray}!important;
  padding: ${props => props?.padding ?? ''}!important; 
`;

export const Input = styled.input`
  border: ${({ theme }) => theme.border.small};
  border-radius: ${({ theme }) => theme.border_radius.small};
  width:  ${({ theme }) => theme.width._100_percent};
  height:  ${(props) => props?.height ?? props.theme.height._42};
  padding: ${({ theme }) => theme.paddings.medium};
  font-style: ${({ theme }) => theme.font_style.normal};
  font-weight: ${({ theme }) => theme.font_weight.medium};
  font-size: ${({ theme }) => theme.font_size.medium}!important;
  line-height: ${({ theme }) => theme.lines_height.medium};
  color: ${({ theme }) => theme.colors.gray};
`;
  
export const SearchWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap:${({ theme }) => theme.gaps.more_less_big};
    position:relative;
    margin-top: 12px;
`;

export const ContainerGenericModal = styled.div`
  position: fixed;
  z-index: 3001;
  height: 100%;
  width: 100%;
  left: 0px;
  top: 0px;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  text-align: center;
  color: rgb(194, 201, 214);
  background-color: rgba(0, 0, 0, 0.3);
`;

export const WrapperBodyModalGeneric = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    overflow-y:auto;
`;

export const WrapperModalGeneriCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
  
`;

export const WrapperGenericModal = styled.div`
  display: flex;
  width: ${props => props.width ?? '80%' };
  height: ${props => props.width ?? '80%'};
  background: ${({theme}) => theme.backgrounds.white};
  border-radius: 8px;
  flex-direction: column;
`;

export const IconCloseModal = styled.div`
    cursor: pointer;
    height: 100%;
`;

export const ContainerHeader = styled.div`
    display: flex;
    width: 100%;
    padding: ${({ theme }) => theme.paddings.large};
    border-bottom: ${({ theme }) => theme.border.very_small_gray5}
`

export const ContainerFooter = styled(ContainerHeader)`
    justify-content: ${props => props.flex_direction ?? 'none'};
    gap: ${props => props.gap ?? 'none'};
    border-top: ${({ theme }) => theme.border.very_small_gray5};
    border-bottom:none;

`;

export const HeaderModal = styled.header`
    display: flex;
    width: 100%;
    justify-content: space-between;
    overflow: hidden;

    h1{
        font-weight: ${({ theme }) => theme.font_weight.large};
        font-size: 24px;
        line-height: 30px;
        color: ${({ theme }) => theme.colors.black};
    }
`;

export const Footer = styled.footer`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    

    h1{
        font-weight: ${({ theme }) => theme.font_weight.large};
        font-size: 24px;
        line-height: 30px;
        color: ${({ theme }) => theme.colors.white};
    }
`;


export const Container = styled.div`
  display: flex;
  height: 100%;
  display: flex;
  overflow:hidden;  
  background-color: ${({ theme }) => theme.backgrounds.white};
  animation: ${slideIn} 400ms ease-in-out;
`;

export const CardTip = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 35px;
  width: 100%;
  max-width: 190px;
  height: 225px;
  flex: none;
  flex-grow: 0;

  .header{
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0px;
      gap: ${({ theme }) => theme.gaps.more_less_big};
      width: 100%;
      max-width: 147px;
      flex: none;
      flex-grow: 0;
  }

  .text-header{
      display: flex;
      align-items: flex-start;
      padding: 4px 10px;
      gap: ${({ theme }) => theme.gaps.small};
      max-width: 147px;
      border-radius: 4px;
      flex-grow: 0;   
      text-align: left;

      p{
          font-weight: ${({ theme }) => theme.font_weight.large};
          font-size: ${({ theme }) => theme.font_size.small};
          line-height: ${({ theme }) => theme.lines_height.medium};
          color: ${({ theme }) => theme.colors.gray} ;
      }
  }

  .text-format{
    display: flex;
    align-items: flex-start;
    padding: 4px 10px;
    gap: ${({ theme }) => theme.gaps.small};
    max-width: 190px;
    border-radius: 4px;
    flex: none;
    flex-grow: 0;
    flex-wrap: wrap;
    .name-text{
        font-weight: ${({ theme }) => theme.font_weight.medium};
        font-size: ${({ theme }) => theme.font_size.very_small};
        line-height: ${({ theme }) => theme.lines_height.small};
        color: ${({ theme }) => theme.colors.gray2};
    }

    .text{
        font-weight: ${({ theme }) => theme.font_weight.large};
        font-size: ${({ theme }) => theme.font_size.very_small};
        line-height: ${({ theme }) => theme.lines_height.small} ;
        color: ${({ theme }) => theme.colors.gray};
    }

  }

`;

export const FormatImg = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    width: 190px;
    height: 69px;
    flex: none;
    flex-grow: 0;
    padding-top: ${({ theme }) => theme.paddings.medium};
`;

export const ContentContainer = styled.div`
    display: flex;
    width: 100%;
    height:100%;
    position: relative;
    overflow-y: hidden;
    overflow-x: hidden;
    animation: ${slideIn} 400ms ease-in-out;
    background-color: ${({ theme }) => theme.backgrounds.white};

`;
export const MainContent = styled.div`
    display: flex;
    position: ${props => props.position === undefined ? props.position : 'relative' };
    padding-top:56px;
    width: ${props => props.width !== undefined ? props.width : '60%'};
    height: 100%;
    align-items: center;
    flex-direction: column;

    @media(max-width:1550px){
      width: 100%;
    }
`;

export const SideBoxInfoWrapper = styled.div.attrs(props => ({
  className: props.className,
}))`

  &.isNotModal{
    width: 40%;
    max-width: 40%;
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  &.modal{
    width: 100%;
    max-width: 100%;
    position: absolute;
    height: 100%;
    display: flex;
    top: 0px;
    bottom: 0px;
    right: 0px;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    z-index: 2000;
    background-color: ${props => props.background ? props.background : props.theme.backgrounds.gray6};
    animation: ${slideIn} 400ms ease-in-out
  }

  .welcome-quote {
    font-size: 24px;
  }

  .welcome-quote, p {
    color:red;
  }


  .WrapperLogo {
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: scroll;
  }

  .WrapperLogo svg{
    width: 100%;
    height: 278px;
  }

  @media(max-width:1550px){
    &.isNotModal{
      display: none;
    }
  }

  @media(min-width:1550px){
    &.isNotModal{
      display: flex;
      
    }
  }

  @media(min-width:1550px) {
    &.modal{
      display: none;
    }
  }
`;

export const SideBoxInfo = styled.div`
  background-color: ${({ theme }) => theme.backgrounds.white}; 
  padding-top:56px;
  width: 100%;
  max-width: ${props => props.max_width ?? '100%'};
  height: 100%;
  position: relative; 
  overflow-y: ${props => props.overflow !== undefined ? props.overflow : 'auto'};
  border: ${({theme}) => theme.border.very_small};

  @media(max-width:1550px){
    width: 100%;
    max-width: 560px;
  }

  @media(max-width:768px){
    width: 100%;
    max-width: 100%;
  }

`;

export const TestContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: auto;

  @media(min-width:1550px){
    .close-button{
      display:none;
    }

  }
`;

export const OrderClientInfo = styled.div`
  margin: 12px;
  display: flex;

`;

export const ClientInfo = styled.div`
    display: flex;
    flex-direction: column;
    font-weight: ${({ theme }) => theme.font_weight.more_less_big};
    font-size: ${({ theme }) => theme.font_size.medium};
    line-height: ${({ theme }) => theme.lines_height.large};
    color: ${({ theme }) => theme.colors.gray};
    gap:${({ theme }) => theme.gaps.very_small} ;
    
    .name{
      font-weight: 700;
      font-size: 24px;
      line-height: 29px;
      color: ${({ theme }) => theme.colors.gray};
    }
`;

export const CloseButton = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    outline: none;
    border: ${({ theme }) => theme.border.very_small_red2};
    border-radius: ${({ theme }) => theme.border_radius.small};
    background: transparent;
    width: 132px;
    height: 48px;
    font-weight: ${({ theme }) => theme.font_weight.large};
    font-size: ${({ theme }) => theme.font_size.medium};
    line-height: ${({ theme }) => theme.lines_height.medium};
    color: ${({ theme }) => theme.colors.red2};
`;

export const SaveButton = styled.button`
    width: 132px;
    height: 48px;
    font-weight: ${({ theme }) => theme.font_weight.large};
    font-size: ${({ theme }) => theme.font_size.medium};
    line-height: ${({ theme }) => theme.lines_height.medium};
    background: ${({ theme }) => theme.backgrounds.red2};
    color: ${({ theme }) => theme.colors.white};
    border: ${({ theme }) => theme.border.very_small_red2};
    border-radius: ${({ theme }) => theme.border_radius.small};
`;

export const OrderId = styled.div`
  width: 100%;
  display: flex;
  gap: 6px;

  p{
    color: ${({ theme }) => theme.colors.gray};
  }

  b{
    margin-right: ${({ theme }) => theme.margins.small} ;

  }
`;

export const OrderInfoStatus = styled(OrderClientInfo)`
  padding:${({ theme }) => theme.paddings.more_less_big};
  border-radius: ${({ theme }) => theme.border_radius.medium};
  border: ${({ theme }) => theme.border.very_small_gray5};
  flex-direction: column;
  font-weight: ${({ theme }) => theme.font_weight.medium};
  font-size: ${({ theme }) => theme.font_size.very_small};
  line-height: ${({ theme }) => theme.lines_height.medium};
  color: ${({ theme }) => theme.colors.gray} ;
  gap:${({ theme }) => theme.gaps.small};

  p {color: ${({ theme }) => theme.colors.gray}}

`;

export const ProductlistWrapper = styled.div`
  margin: 0 12px 0 12px;
`;

export const Withdraw = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0 12px 12px 12px;
    border: ${props => props.themeColor ? props.themeColor :  '1px solid #e6e3e3'};
    border-radius: ${({ theme }) => theme.border_radius.medium};
    padding: ${({ theme }) => theme.paddings.more_less_big};
    gap: ${({ theme }) => theme.gaps.very_small};
    font-weight: ${({ theme }) => theme.font_weight.medium};
    font-size: ${({ theme }) => theme.font_size.medium};
    line-height: 24px;
    color: ${({ theme }) => theme.colors.gray} ;
    p{
      color: ${({ theme }) => theme.colors.gray};
    }
`;

export const PaymentWrapper = styled.div`
  padding: ${({ theme }) => theme.paddings.more_less_big};  
  gap: ${({ theme }) => theme.gaps.more_less_big};
  display: flex;
  border: ${props => props.themeColor ? props.themeColor :  '1px solid #e6e3e3'};
  border-radius: ${({ theme }) => theme.border_radius.medium};
  margin: 0 12px 230px 12px;
`;

export const PaymentInfo = styled.div`
  display: flex;
  font-weight: ${({ theme }) => theme.font_weight.medium};
  font-size: ${({ theme }) => theme.font_size.very_small};
  line-height: ${({ theme }) => theme.lines_height.medium};
  color: ${({ theme }) => theme.colors.gray};
  width: 100%;
  flex-direction: column;
  gap: ${({ theme }) => theme.gaps.very_small};

    p{
      color: ${({ theme }) => theme.colors.gray};
  }
`;

export const PaymentForm = styled.div`
  width: 100%;
  font-weight: 700;
  align-items: center;
  font-size: ${({ theme }) => theme.font_size.medium};
  min-height: 32px;
  line-height: ${({ theme }) => theme.lines_height.medium};
  color: ${({ theme }) => theme.colors.gray};
  display: flex;
  justify-content: space-between;
`;

export const Tag = styled.div`
  width: 140px;
  display: flex;
  align-items: center;
  border-radius: 45px;
  background: ${({ theme }) => theme.backgrounds.gray7};
  padding: 6px 12px;
  gap: ${({ theme }) => theme.gaps.small};
  font-weight: ${({ theme }) => theme.font_weight.large};
  font-size: ${({ theme }) => theme.font_size.small} ;
  line-height: ${({ theme }) => theme.lines_height.medium};
  color: ${({ theme }) => theme.colors.gray3};
  margin-top: 8px;

    p{
      color: ${({ theme }) => theme.colors.gray};
    }
`;

export const Icon = styled.img`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
`;

export const Status = styled.div`
  justify-content: space-between;
  display: flex;
  font-weight: ${({ theme }) => theme.font_weight.large};
  font-size: ${({ theme }) => theme.font_size.medium};
  line-height: ${({ theme }) => theme.lines_height.medium};
  color: #ED825C;
`;

export const StatusTimer = styled.div`
  font-weight: ${({ theme }) => theme.font_weight.large};
  gap:${({ theme }) => theme.gaps.very_small} ;
  font-size: ${({ theme }) => theme.font_size.small};
  line-height: ${({ theme }) => theme.lines_height.medium};
  color:${props=>props.isLate ? props.theme.colors.red2 : props.theme.colors.gray3};
  display: flex;
`;

export const LastOrderTimer = styled.div`
  display: flex;
`;

export const ProductsList = styled.div`
  display: flex;
  flex-direction: column;
  font-size: ${({ theme }) => theme.font_size.small};
  padding: 16px 16px 24px;
  border: ${({ theme }) => theme.border.very_small_gray5};
  border-radius: ${({ theme }) => theme.border_radius.medium} ;
  margin-bottom: 12px;
  color: ${({ theme }) => theme.colors.black};
`;

export const ProductNameWrapper = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.gaps.small} ;
  align-items: center;
  width: 60%;

  p{
      color: ${({ theme }) => theme.colors.gray};
  }
`;

export const QtdWrapper = styled.div`
  display: flex;
  min-width: 28px;
  height: 28px;
  border-radius: 14px;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.backgrounds.gray5};
  p{
    color: ${({ theme }) => theme.colors.gray}
  };
`;

export const Product = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.margins.small};
  gap: 8px;

    p{
      color: ${({ theme }) => theme.colors.gray};
    }
`;

export const BoxForm = styled.div`
  padding: 5px 15px;
  background: #fafafa;
  border-top: solid 3px #c7d6fc;
  border-radius: ${({ theme }) => theme.border_radius.medium};
  align-items: center;
  overflow-y: hidden;
  background-color: ${({ theme }) => theme.backgrounds.white};
  color: ${({ theme }) => theme.colors.black};


  .form-control{
    background-color:${({ theme }) => theme.backgrounds.white};
  }

  .wrapper-passaword{
    display: flex;
    position: relative;
    width: 100%;


    input, .form-group{
      color: ${({ theme }) => theme.colors.black};
      width: 100% !important;
    }


    input{
      background-color: ${({ theme }) => theme.backgrounds.white}!important ;
      font-size: ${({ theme }) => theme.font_size.medium};
    }
  } 
`;


export const RowSpinner = styled.div`
  display: flex;
  justify-content: center;
  width: ${props => props?.width ?? '100%'} ;
  align-items: center;
  color:${props => props.theme.colors.black};
  height: ${props => props?.height ?? '100%'} ;
  margin: ${props => props?.margin ?? ''} ;
  padding: ${props => props?.padding ?? ''} ;


`;

export const ContainerRelative = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  flex-direction: column;
`;


export const StyledAutocomplete = styled(Autocomplete)`
  width: 100%;

  .MuiInputBase-root {
    color: ${props => props.theme.colors.black};
    font-size: 16px;
    border-radius: 8px;
    font-weight: 400;
    height: 46px;
  }

  .MuiAutocomplete-root {
    height: 42px!important;

  }
  
  .MuiOutlinedInput-notchedOutline {
    border: ${props => props.theme.border.small};
  }

  &:hover .MuiOutlinedInput-notchedOutline {
    border: ${props => props.theme.border.small};
  }

  .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border: ${props => props.theme.border.small}; 
  }


  &.Mui-focused .MuiOutlinedInput-notchedOutline {
    border: ${props => props.theme.border.small};
  }

  
  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border: ${props => props.theme.border.small};
  }

  .MuiInputLabel-root {
    color: ${props => props.theme.colors.black};
    top: 50%;
    transform: translate(14px, -50%) scale(1);
  }

   .MuiInputLabel-root.Mui-focused {
    color: ${props => props.theme.colors.black};
  }

  /* Input */
.MuiOutlinedInput-root {
  height: 48px;
  padding: 0;
}

/* Texto digitado */
.MuiOutlinedInput-input {
  padding: 14px;
}


.MuiInputLabel-root.Mui-focused,
.MuiInputLabel-root.MuiInputLabel-shrink {
  top: 0;
  transform: translate(14px, -6px) scale(0.75);
}
  
.MuiSvgIcon-root{
  fiLl: ${() => {
    const {darkModeButton, selectedTheme, verifySisteShop} = useContext(DarkModeContext)
    return darkModeButton  ? verifySisteShop() : selectedTheme.backgrounds.red2
  }};
}

`


export const BoxRow = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.backgrounds.white};
  display: flex;
  margin: ${props => props.margin ?? 0};
  min-width: 0;
  gap: ${props => props?.gap ?? '4px'};
  align-items: center;
  position:relative;

  .spinner {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #row {
    margin: 0px;
  }

  textarea {
    font-size: ${({theme}) => theme.font_size.medium};
    border-radius: ${({ theme }) => theme.border_radius.medium};
    resize: none;
    background-color: transparent;
  }

  #RowCadastro {
    margin: 0px;
    min-height: calc(100vh - 55px);
    align-items: center;
  }

  #RowQR {
    margin: 0;
    padding: 0;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    overflow-y: hidden;
    min-height: calc(100vh - 55px);
  }

  #col {
    background-color: #084bdd;
    border-color: #084bdd;
    box-shadow: none;
  }

  .rowsdash {
    margin: 0px;
    padding: ${({ theme }) => theme.paddings.small};
    color: black;
  }

  .RowCadastrar {
    margin: 0;
    margin-bottom: 5px;
    align-items: center;
  }

  .icon{
    display:flex;
    align-items: center;
    position: absolute;
    right: 0;
    margin: 0 10px;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }

  @media(max-width: 520px){
    flex-wrap: wrap;
  }
`;

export const Header = styled.div`
    width: 100%;
    min-height: 55px;
    background-color: #03134F;
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.colors.white};
    padding: 16px 12px;
    position: ${props => props.position ?? 'none'};
    top:0;

    P{
      color: ${({theme}) => theme.colors.white};    
    }

    svg{
      margin-right: 15px;
    }
`;

export const FooterActions = styled.div`
  display: flex;
  position: relative;
  width: 100%; 
  height: 88px;
  bottom:0;
`;

export const BoxGrid = styled.div`
  display: flex;
  margin: 0px;
  width: 100%;
  color: #3b4758;
  margin-top: 10px;
  padding: ${props => props.padding !== undefined ? props.padding : props.theme.paddings.medium} ;
  overflow: auto; 
  font-weight: ${({ theme }) => theme.font_weight.medium};
  font-size: ${({ theme }) => theme.font_size.small};
  line-height: 130%;
  border-radius: ${props => props.border_radius};
  border: ${props => props.border ? `1px solid ${props.theme.backgrounds.gray4}` : ''};
  height: ${props => props.height ?? 'auto'};
  margin: ${props => props.margin ?? ''};
  flex-direction: ${props => props?.flex_direction ?? 'row'};
  justify-content: ${props => props?.justify_content ?? 'left'};

  .class-red{
    border: 1px solid red;
  }
  
  .class-green{
    border: 1px solid rgb(80, 167, 115);
  }

  .colors{
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }
  .TableRed{
    background-color: ${({ theme }) => theme.colors.red};
  }

  .TableGreen{
    background-color: rgb(80, 167, 115);
  }

  .TableBlue{
    background-color: ${({ theme }) => theme.colors.blue2};
  }

  .TableSilver{
    opacity: 0.5;
    cursor: not-allowed;
    user-select: none
  }

  thead{
    font-weight: ${props => props.theme.font_weight.large};
    line-height: 130%;
    border-bottom: ${props => props.theme.border.very_small_gray5};
    position: sticky;
    top:${props => props.padding !== undefined ? `-${props.padding}` : `-${props.theme.paddings.large}`} ;
    background-color: ${props => props.theme.backgrounds.white};
    color: ${props => props.theme.colors.black};
  }

  tbody{
    cursor: pointer;
    color: ${props => props.theme.colors.black};
    text-align: left;
  }

  tbody tr:hover{
    background: ${props => props.theme.backgrounds.gray7} ;
  }

  .TableSilver:hover{
    background: none;
  }

  tr, td{
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    -webkit-box-orient: horizontal; 
    max-width:350px ;
    vertical-align: middle;
  }
  
`;

export const BoxLateralSale = styled.div`
    width: 100%;
    position: fixed;
    inset: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    overflow:auto;
    text-align: center;
    animation: ${slideIn} 400ms ease-in-out;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 3000;
    cursor: not-allowed;

    *{
      cursor: auto;
    }
    
    #dropdown-listbox > li, span {
      cursor: pointer;
    }
`;

export const BoxLateral = styled.div.attrs(props => ({
  className:props.className,
}))`

  &.isNotModal{
    width: ${props => props.width !== undefined ? '100%' : '40%'};
    max-width:  ${props => props.width !== undefined ? props.width : '40%'};
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow:auto;
    text-align: center;
    animation: ${slideIn} 400ms ease-in-out;
  }

  &.modal{
    position:absolute;
    width: 100%;
    height: 100%;
    display: flex;
    z-index: 2000;
    justify-content: flex-end;
    text-align: center;
    background-color: ${({ theme }) => theme.backgrounds.gray6};
    animation: ${slideIn} 400ms ease-in-out;
  }


    .text-info{
      display: flex;
      justify-content: center;
      align-items: center;
      padding: ${({ theme }) => theme.paddings.more_less_big};
      gap: ${({ theme }) => theme.gaps.large};
      width: 362px;
      height: 60px;
      width: 100% ;
      margin-bottom: ${({ theme }) => theme.margins.medium};
      border-radius: 13px;
    
    }

    #edit, #delete{
      color:${({ theme }) => theme.colors.red2};

    }

    .paragraph-wrapper{
      display: flex;
      flex-direction: column;
      color: ${({ theme }) => theme.colors.black};
    }

    .welcome-quote{
        display: flex;
        justify-content: center;
        font-size: 24px;
        max-width: 249px;
        width: 100%;

        img{
          width: 100%;
  
        }
    }

    .WrapperLogo{
        display:flex;
        width: 100%;
        height:100%;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        overflow:auto ;
    }

    .WrapperLogo svg{
      width: 100%;
      height: 278px;
    }


    @media(max-width:1550px){ 
      &.isNotModal{
        display: none;
      }
    }
`;

export const ContainerEditOrAdd = styled.div`
  width:  ${props => props.max_width ?? '100%'};
  max-width: ${props => props.max_width ?? '100%'};
  position:relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center ;
  border-left: ${({ theme }) => theme.border.large};
  background: ${({ theme }) => theme.backgrounds.white};

  @media(max-width:1550px){
    align-items: center;
    max-width: 560px;
    width:560px;
  }
  
  @media(max-width:768px){
    align-items: center;
    max-width: 100%;
    width:100%;
  }

`;

export const ContainerEditOrAddProduct = styled(ContainerEditOrAdd)`
  @media(max-width:1550px){
    align-items: center;
    max-width: 700px;
    width:700px;
  }
  
  @media(max-width:768px){
    align-items: center;
    max-width: 100%;
    width:100%;
  }
    
`

export const BoxLogoSisteFoodLateral = styled.img`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 278px;
`;

export const IconRegistrations = styled.img`
  width: 20px;
  height: 20px;
  margin-right: ${({ theme }) => theme.margins.small};
`;

export const Message = styled.div`
    margin-top: 16px;
    display: flex;
    width: 100%;
    justify-content: center;
    outline: none;
`;

export const Mandatory = styled.div`
    display: flex;
    width: 100%;
    gap: 4px;
    align-items: center;
    
    .mandatory{
      color: ${({ theme }) => theme.colors.gray2} !important;
      font-weight: ${({ theme }) => theme.font_weight.medium} !important;
      font-size: ${({ theme }) => theme.font_size.small} !important;
      line-height: ${({ theme }) => theme.lines_height.medium} !important;
    }

`;

export const Icons = styled.img`
  width: 20px;
  height:20px;
  cursor: pointer;
`;

export const ContainerWrapper = styled.div`
    display: ${({ theme }) => theme.display.flex};
    align-items: ${({ theme }) => theme.align_items.flex_start};
    padding: 0px;
    width: ${({ theme }) => theme.width._100_percent};
    max-width: ${props => props.width !== '' ? props.width :  props.theme.width.max_width_560};
    position: absolute;
    height: ${({ theme }) => theme.height._100_percent};
    background:${({ theme }) => theme.backgrounds.white};
    border-left: ${({ theme }) => theme.border.small};
`;

export const OpacityContainerWrapper = styled.div`
    position: fixed;
    display: ${({ theme }) => theme.display.flex};
    justify-content: ${({ theme }) => theme.justify_content.flex_end};
    background-color: ${({ theme }) => theme.backgrounds.gray6};
    left: 0;
    right: 0;
    bottom: 0;
    top:0;
    z-index: 2000;  
`;


export const ContainerSideBox = styled.div`
    width: ${({ theme }) => theme.width._100_percent};
    max-width: ${props => (props.width) !== '' ? props.width :  props.theme.width.max_width_560};
    position: absolute;
    margin-top:${({ margin_top ,theme }) => margin_top ?? theme.margins.large};
    top:0;
    bottom:0;
    right:0;
    left:0;
    width: 100%;
    margin-bottom: ${({ theme }) => theme.margins.very_large};
    overflow-y: auto;
    overflow-x: hidden;
    animation: ${slideIn} 400ms ease-in-out;

    #password{
        width: 244.5px;
    }
`;

export const Details = styled.div`
  display: ${({ theme }) => theme.display.flex};
  flex-direction: ${({ theme }) => theme.flex_direction.column};
  align-items: ${({ theme }) => theme.align_items.flex_start};
  padding: ${props => props.padding ?? '12px'};
  width: ${({ theme }) => theme.width._100_percent};
  max-width: ${props => props.width !== '' ? props.width :  props.theme.width.max_width_560};
  position: relative;
  margin:  ${props => props.margin};
  gap:  ${props => props?.gap ?? ''};

  
  form{
      width:${({ theme }) => theme.width._100_percent} ;
  }    

  .wrapper-passaword{
        display: flex;
        position: relative;
        max-width: 342px;
        width: 100%;

        input{
          width: 100%;
          font-size: ${({ theme }) => theme.font_size.medium};
        }
    } 
`;

export const Line = styled.hr`
  width: 100%;
  padding: 12px 0;
  border-bottom: 1px solid ${({ theme }) => theme.backgrounds.gray4};
`;

export const ContainerDinamicHeight = styled.div`
  display: ${({ theme }) => theme.display.flex};
  width: ${props => props.width};
  height: ${props => props.height};
  gap: ${({ theme }) => theme.paddings.medium};
  flex-direction: ${({ theme }) => theme.flex_direction.column};
  align-items: ${({ theme }) => theme.align_items.flex_start};
  padding-top: ${({ theme }) => theme.paddings.medium};


  p{
    font-weight: ${({ theme }) => theme.font_weight.large};
    font-size: ${({ theme }) => theme.font_size.medium};
    line-height: ${({ theme }) => theme.lines_height.large};
    color: ${({ theme }) => theme.colors.gray}
  }
`;

export const Column = styled.div`
    display: ${({ theme }) => theme.display.flex};
    flex-direction: ${({ theme }) => theme.flex_direction.column};
    align-items: ${({ theme }) => theme.align_items.flex_start};
    padding: ${props => props.padding ? props.padding : '0'};
    width:  ${props => props.width ?? props.theme.width._100_percent};
    height: ${props => props.height ? props.height : props.theme.height._98};
    gap: ${props => props.gap ?? props.theme.paddings.medium};

    select{
      background-color: red;
    }

    p{
      font-weight: ${({ theme }) => theme.font_weight.large};
      font-size: ${({ theme }) => theme.font_size.medium};
      line-height: ${({ theme }) => theme.lines_height.large};
      color: ${props => props.isloading ? 'rgb(242, 242, 242)' : props.theme.colors.gray};
      animation: ${props => props.isloading ? css`${slideIn} 800ms linear infinite`: ''};
    }

    input{
        border: ${({ theme }) => theme.border.small};
        border-radius: ${({ theme }) => theme.border_radius.small};
        width:  ${({ theme }) => theme.width._100_percent};
        height:  ${({ theme }) => theme.height._42};
        padding: ${({ theme }) => theme.paddings.medium};
        font-style: ${({ theme }) => theme.font_style.normal};
        font-weight: ${({ theme }) => theme.font_weight.medium};
        font-size: ${({ theme }) => theme.font_size.medium};
        line-height: ${({ theme }) => theme.lines_height.medium};
        color: ${({ theme }) => theme.colors.gray};
        background-color: ${props => props.isloading ? 'rgb(242, 242, 242)' : 'transparent'};
        animation: ${props => props.isloading ? css`${slideIn} 800ms linear infinite`: ''};
    }  
    
    #subtitle{
      font-weight: ${({ theme }) => theme.font_weight.medium};
      font-size: ${({ theme }) => theme.font_size.small};
      line-height: ${({ theme }) => theme.lines_height.medium};
      color: ${({ theme }) => theme.colors.gray2};
    }

    .subtitle{
      font-weight: ${({ theme }) => theme.font_weight.medium};
      font-size: ${({ theme }) => theme.font_size.small};
      line-height: ${({ theme }) => theme.lines_height.medium};
      color: ${({ theme }) => theme.colors.gray2};
    }


    #id{
      width: 148px;
      background: ${({ theme }) => theme.backgrounds.gray7};
    }

    .readOnly {
      background: ${({ theme }) => theme.backgrounds.gray7};
    }

    #remove-discount{
      font-weight: ${({ theme }) => theme.font_weight.large};
      font-size: ${({ theme }) => theme.font_size.medium} ;
      line-height: ${({ theme }) => theme.lines_height.large};
      text-decoration-line: underline;
      color: ${({ theme }) => theme.colors.red2};
      cursor: pointer;
    }

    #current-price{
      background: ${({ theme }) => theme.backgrounds.gray7};   
    }
    span{
      text-align:left;
    }
  
`;

export const BoxTextArea = styled.div`
  display:grid;
  justify-items : left;
  width:  ${({ theme }) => theme.width._100_percent};
  gap: ${({ theme }) => theme.paddings.medium};
  font-weight: ${({ theme }) => theme.font_weight.large};
  font-size: ${({ theme }) => theme.font_size.medium};
  line-height: ${({ theme }) => theme.lines_height.large};
  color: ${({ theme }) => theme.colors.gray};
  margin:  ${props => props.margin};
  
  textarea{
    outline: none;
    resize: none;
    width: 100%;
    overflow: auto;
    min-height: 139px;
    border: ${({theme}) => theme.border.very_small_gray};
    font-size: ${({theme}) => theme.font_size.medium};
    border-radius: 10px;
    color:  ${({ theme }) => theme.colors.black};
    padding: 1em;
  }

`;

export const FooterContainer = styled.div`
    display: ${({ theme }) => theme.display.flex};
    width:  ${({ theme }) => theme.width._100_percent};
    max-width: ${props => props.width !== '' ? props.width :  props.theme.width.max_width_560};
    height:  ${(props) => props.height ?? props.theme.height._84};
    border-top: ${({ theme }) => theme.border.very_small};
    gap:${({ theme }) => theme.gaps.large};
    position: absolute;
    bottom:0;
    flex-direction: ${({ theme }) => theme.flex_direction.column};
    background-color: ${({ theme }) => theme.backgrounds.white};
    padding: ${props => (props.theme.paddings.medium_16_24)};
`;


export const ButtonFooter = styled.div`
    display: ${({ theme }) => theme.display.flex};
    align-items: ${({ theme }) => theme.align_items.flex_start};
    justify-content : ${({ theme }) => theme.align_items.flex_end};

    #button-footer{
      display: ${({ theme }) => theme.display.flex};
      align-items: ${({ theme }) => theme.align_items.flex_start};
      gap: ${({ theme }) => theme.gaps.large};
      height: ${({ theme }) => theme.height._48};
    }

    #cancel{
      display: ${({ theme }) => theme.display.flex};
      justify-content: ${({ theme }) => theme.justify_content.center};
      align-items: ${({ theme }) => theme.align_items.center};
      cursor: ${({ theme }) => theme.cursors.pointer};
      border: ${({ theme }) => theme.border.very_small_red2};
      border-radius: ${({ theme }) => theme.border_radius.small};
    }

    button{
      border: ${({ theme }) => theme.border.very_small_red2};
      border-radius: ${({ theme }) => theme.border_radius.small};
    }

    #trash{
      width: ${({ theme }) => theme.width._51_31};
      height: ${({ theme }) => theme.height._48};
    }

    #cancel, #save, #payment{
      width:${({ theme }) => theme.width._132};
      height: ${({ theme }) => theme.height._48};
      font-weight: ${({ theme }) => theme.font_weight.large};
      font-size: ${({ theme }) => theme.font_size.medium};
      line-height: ${({ theme }) => theme.lines_height.medium};
      color: ${({ theme }) => theme.colors.red2};
    }

    #payment{
      width: 200px;
      height: ${({ theme }) => theme.height._48};
      font-weight: ${({ theme }) => theme.font_weight.large};
      font-size: ${({ theme }) => theme.font_size.medium};
      line-height: ${({ theme }) => theme.lines_height.medium};
      background: ${({ theme }) => theme.backgrounds.red2};
      color: ${({ theme }) => theme.colors.white};

    }

    #save{
      background: ${({ theme }) => theme.backgrounds.red2};
      color: ${({ theme }) => theme.colors.white};
    }
`;

export const WrapperTitleAddress = styled.div`
    display: ${({ theme }) => theme.display.flex};
    align-items: ${({ theme }) => theme.align_items.center};
    padding: ${({ theme }) => theme.paddings._12_24};
    margin-top:${({ theme }) => theme.margins.medium};
    width: ${({ theme }) => theme.width._100_percent};
    height:  ${({ theme }) => theme.height._55};
    background: ${({ theme }) => theme.backgrounds.gray4};

    p{
        font-weight: ${({ theme }) => theme.font_weight.large};
        color: ${({ theme }) => theme.colors.gray}

    }
`;

export const TableStandard = styled.div`
    display: ${({ theme }) => theme.display.flex};
    align-items: ${({ theme }) => theme.align_items.center};
    gap: ${({ theme }) => theme.gaps.small};
    width:${({ theme }) => theme.width._100_percent};
    margin: 12px 0 12px 0;
    align-self: stretch;
    flex-grow: 0;

    p{
        font-weight: ${({ theme }) => theme.font_weight.large};
        font-size: ${({ theme }) => theme.font_size.large};
        line-height: 23px;
        color: ${({ theme }) => theme.colors.gray}
    }
`;

export const ButtonFooterTrash = styled.div`
  display: ${({ theme }) => theme.display.flex};
  align-items: ${({ theme }) => theme.align_items.flex_start};
  justify-content :${({ theme }) => theme.justify_content.flex_start} ;
  padding: 0px;
  gap: ${({ theme }) => theme.gaps.large};
  width: ${({ theme }) => theme.width._100_percent};
  height: ${({ theme }) => theme.height._48};

  #trash{
    display:flex;
    justify-content: ${({ theme }) => theme.justify_content.center};
    align-items: ${({ theme }) => theme.align_items.center};
    width: ${({ theme }) => theme.width._51_3};
    height:  ${({ theme }) => theme.height._48};
    cursor: ${({ theme }) => theme.cursors.pointer};
    outline: none;
    border: ${({ theme }) => theme.border.very_small_red2};
    border-radius: ${({ theme }) => theme.border_radius.small};
    background:transparent;

  }
`;

export const ContainerUserPermission = styled.div`
  display: ${({ theme }) => theme.display.flex};
  align-items: ${({ theme }) => theme.align_items.flex_start};
  padding: 0 0 12px 0;
  gap: ${({ theme }) => theme.gaps.small};
  width: ${({ theme }) => theme.width._100_percent};

  P{
      font-weight: ${({ theme }) => theme.font_weight.large};
      font-size: ${({ theme }) => theme.font_size.large};
      line-height: 23px;
      color: ${({ theme }) => theme.colors.gray}
  }
`;

export const Toggle = styled.div`
  display: flex;
  align-items: center;
  width: 46px;
`;

export const ContainerButtons = styled.div`
    display: flex;
    width: 100%;
    align-items: flex-end;
    justify-content: flex-end;
    flex-direction:column;
    flex-wrap: wrap;
`;

export const WrapperButtons = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: ${({ theme }) => theme.gaps.more_less_big};
    align-self: stretch;
    padding: ${({ theme }) => theme.paddings.medium};
    font-size: ${({ theme }) => theme.font_size.medium};
    font-weight: ${({ theme }) => theme.font_weight.large};
    line-height: ${({ theme }) => theme.lines_height.medium};
`;

export const WrapperToggle = styled.div`
    display: flex;
    align-items: center;
    justify-items: center;
    gap: 10px;
    padding: 12px;  
    width: ${props => props.width !== '' ? props.width : 'auto'};
    
    input {
      color: ${props => props.theme.colors.black};
      font-size: ${({ theme }) => theme.font_size.medium};
    }

    p{
      width: ${props => props.width !== '' ? props.width : '100px'};
      text-align: center;
      color: ${({ theme }) => theme.colors.black};
      font-size: 14px;
      font-weight: ${({ theme }) => theme.font_weight.medium};
    }

    #order{
      width: 70px;
      border: ${({ theme }) => theme.border.small_red2};
      border-radius: ${({ theme }) => theme.border_radius.small};
      height: 42px;
      padding: 12px;
    }
`;

export const IconDashboardMoney = ({fillBottom, fill}) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="8" fill={fillBottom}/>
      <path d="M25.4097 9.00391C24.1979 8.43967 22.9861 8.22266 21.7743 8.22266C17.9271 8.22266 14.0729 10.3886 10.2257 10.3886C9.26076 10.3886 8.29618 10.2497 7.33125 9.9112C7.22257 9.87196 7.11319 9.8546 7.00799 9.8546C6.46875 9.8546 6 10.3192 6 10.9588V21.9796C6 22.4178 6.22656 22.8303 6.58993 22.9997C7.80069 23.5629 9.01562 23.7782 10.2257 23.7782C14.0729 23.7782 17.9236 21.6122 21.7743 21.6122C22.7392 21.6122 23.7038 21.7511 24.6688 22.0897C24.7781 22.1287 24.8875 22.1461 24.993 22.1461C25.5312 22.1463 26 21.681 26 21.0386V10.024C26 9.5855 25.7743 9.17335 25.4097 9.00391ZM24.3333 12.3615C23.2396 12.2227 22.3889 11.299 22.3889 10.1671C22.3889 10.0904 22.4045 10.0191 22.4123 9.94477C23.0833 10.0011 23.7326 10.1171 24.3333 10.3543V12.3615ZM13.2222 16.0004C13.2222 14.1595 14.466 12.6671 15.9688 12.6671C17.4715 12.6671 18.7153 14.1595 18.7153 16.0004C18.7153 17.8414 17.4715 19.3338 15.9688 19.3338C14.466 19.3338 13.2222 17.8407 13.2222 16.0004ZM7.66667 11.7504C8.36285 11.924 9.08542 11.9761 9.83333 12.0317C9.61806 13.0317 8.73021 13.7782 7.66667 13.7782V11.7504ZM7.66667 19.6393C8.76146 19.7782 9.61111 20.7018 9.61111 21.8338C9.61111 21.9104 9.59553 21.9818 9.58767 22.0561C8.91493 22.0004 8.2691 21.8824 7.66667 21.6463V19.6393ZM24.3333 20.2504C23.6372 20.0761 22.9149 19.9935 22.1653 19.9678C22.3819 18.9692 23.2708 18.2227 24.3333 18.2227V20.2504Z" fill={fill}/>
  </svg>
);

export const IconDashboardCard = ({fillBottom, fill}) => (
  <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" width="32" height="32" rx="8" fill={fillBottom}/>
      <path fillRule="evenodd" clipRule="evenodd" d="M24.5 8H8.5C7.39 8 6.51 8.89 6.51 10L6.5 22C6.5 23.11 7.39 24 8.5 24H24.5C25.61 24 26.5 23.11 26.5 22V10C26.5 8.89 25.61 8 24.5 8ZM23.502 22.0013H9.50195C8.95195 22.0013 8.50195 21.5513 8.50195 21.0013V16.0013H24.502V21.0013C24.502 21.5513 24.052 22.0013 23.502 22.0013ZM8.50195 12.002H24.502V10.002H8.50195V12.002Z" fill={fill}/>
  </svg>
);

export const IconDashboardPix = ({fillBottom, fill}) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="8" fill={fillBottom}/>
      <path d="M15.4812 17.4526C15.6925 17.2414 16.0562 17.2414 16.2674 17.4526L19.2792 20.4644C19.8346 21.0198 20.5739 21.3249 21.3562 21.3249H21.9468L18.1488 25.1229C16.9637 26.2767 15.0393 26.2767 13.8541 25.1229L10.0405 21.3131H10.4042C11.1865 21.3131 11.9258 21.008 12.4812 20.4526L15.4812 17.4526ZM16.2674 14.5738C16.0171 14.7889 15.6964 14.7928 15.4812 14.5738L12.4812 11.5737C11.9258 10.9831 11.1865 10.7132 10.4042 10.7132H10.0405L13.8502 6.90194C15.0393 5.71498 16.9637 5.71498 18.1488 6.90194L21.9507 10.7015H21.3562C20.5739 10.7015 19.8346 11.0066 19.2792 11.562L16.2674 14.5738ZM10.4042 11.5933C10.944 11.5933 11.4408 11.8123 11.8554 12.1956L14.8554 15.1957C15.137 15.4421 15.5047 15.6181 15.8763 15.6181C16.244 15.6181 16.6116 15.4421 16.8933 15.1957L19.905 12.1839C20.2884 11.8045 20.8164 11.5855 21.3562 11.5855H22.8308L25.1111 13.8658C26.2963 15.051 26.2963 16.9754 25.1111 18.1605L22.8308 20.4409H21.3562C20.8164 20.4409 20.2884 20.2219 19.905 19.8385L16.8933 16.8267C16.3496 16.2831 15.3991 16.2831 14.8554 16.8307L11.8554 19.8268C11.4408 20.2101 10.944 20.4292 10.4042 20.4292H9.15962L6.89022 18.1605C5.70326 16.9754 5.70326 15.051 6.89022 13.8658L9.15962 11.5933H10.4042Z" fill={fill}/>
  </svg>
);

export const IconDashboardOthers = ({fillBottom, fill}) => (
  <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" width="32" height="32" rx="8" fill={fillBottom}/>
      <circle cx="9.19138" cy="16" r="2.22654" fill={fill}/>
      <circle cx="16.5" cy="16" r="2.22654" fill={fill}/>
      <circle cx="23.8086" cy="16" r="2.22654" fill={fill}/>
  </svg>
);

export const IconDashboardTimer = ({fillBottom, stroke, size}) => (
  <svg width={size !== undefined ? size : '32'} height={size !== undefined ? size : '32'} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="8" fill={fillBottom}/>
    <circle cx="16" cy="16" r="9.06026" stroke={stroke} strokeWidth="1.87948"/>
    <path d="M16 6V10" stroke={stroke} strokeWidth="1.87948"/>
    <path d="M16 22V26" stroke={stroke} strokeWidth="1.87948"/>
    <path d="M6 16L10 16" stroke={stroke} strokeWidth="1.87948"/>
    <path d="M22 16L26 16" stroke={stroke} strokeWidth="1.87948"/>
    <path d="M16 12V16L20 20" stroke={stroke} strokeWidth="1.87948"/>
  </svg>
);

export const IconDashboardCurrency = ({fillBottom, fill}) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="8" fill={fillBottom}/>
    <path d="M16.0744 22.6835C15.0198 22.6835 14.1228 22.5138 13.3835 22.1744C12.6441 21.8228 12.0804 21.3319 11.6925 20.7016C11.452 20.2904 11.2885 19.8346 11.2019 19.334C11.1181 18.8491 11.5278 18.4471 12.0198 18.4471C12.5119 18.4471 12.9026 18.8554 13.0617 19.321C13.1008 19.4353 13.1474 19.55 13.2016 19.6653C13.3956 20.0653 13.7228 20.4047 14.1835 20.6835C14.6562 20.9501 15.2865 21.0835 16.0744 21.0835C17.1289 21.0835 17.9168 20.8653 18.438 20.4289C18.9592 19.9804 19.2198 19.4653 19.2198 18.8835C19.2198 18.3259 18.9895 17.8653 18.5289 17.5016C18.0683 17.1259 17.3895 16.8956 16.4925 16.8107L15.3471 16.7016C14.1592 16.5925 13.2138 16.235 12.5107 15.6289C11.8077 15.0228 11.4562 14.1622 11.4562 13.0471C11.4562 12.2713 11.6441 11.6168 12.0198 11.0835C12.3956 10.538 12.9168 10.1198 13.5835 9.82891C14.2622 9.538 15.0622 9.39254 15.9835 9.39254C16.9168 9.39254 17.7168 9.55618 18.3835 9.88345C19.0501 10.1986 19.5653 10.6653 19.9289 11.2835C20.1622 11.6722 20.3206 12.1159 20.4043 12.6144C20.4857 13.0997 20.0755 13.5016 19.5835 13.5016C19.0914 13.5016 18.7086 13.0912 18.5434 12.6277C18.504 12.5171 18.4567 12.4084 18.4016 12.3016C18.2198 11.9138 17.9289 11.5986 17.5289 11.3562C17.141 11.1138 16.6259 10.9925 15.9835 10.9925C15.4138 10.9925 14.9289 11.0835 14.5289 11.2653C14.1289 11.4471 13.8198 11.6956 13.6016 12.0107C13.3835 12.3138 13.2744 12.6592 13.2744 13.0471C13.2744 13.5562 13.4562 13.9986 13.8198 14.3744C14.1835 14.738 14.741 14.9562 15.4925 15.0289L16.6562 15.1198C17.9774 15.241 19.0319 15.6228 19.8198 16.2653C20.6198 16.9077 21.0198 17.7804 21.0198 18.8835C21.0198 19.6471 20.8198 20.3138 20.4198 20.8835C20.0198 21.4531 19.4501 21.8956 18.7107 22.2107C17.9835 22.5259 17.1047 22.6835 16.0744 22.6835ZM16.0744 25.0107C15.6125 25.0107 15.238 24.6363 15.238 24.1744V22.3562H16.9107V24.1744C16.9107 24.6363 16.5363 25.0107 16.0744 25.0107ZM15.1653 10.2835V8.46527C15.1653 8.00336 15.5397 7.62891 16.0016 7.62891C16.4635 7.62891 16.838 8.00336 16.838 8.46527V10.2835H15.1653Z" fill={fill}/>
  </svg>
);

export const IconAttendentComission = ({fillBottom, stroke, fill}) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="8" fill={fillBottom}/>
    <ellipse cx="15.9993" cy="12.6654" rx="5.83333" ry="5.83333" stroke={stroke} strokeWidth="1.5"/>
    <path d="M11 24.2948V20.1715C11 19.7926 11.405 19.5514 11.7381 19.7319L16.1852 22.1407L20.2481 19.7707C20.5814 19.5762 21 19.8167 21 20.2025V23.9092C21 24.2881 20.595 24.5293 20.2619 24.3489L16.1852 22.1407L11.7519 24.7267C11.4186 24.9212 11 24.6807 11 24.2948Z" fill={fill} stroke={stroke}/>
  </svg>
);

export const IconHome = ({stroke}) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.00375 17.3325V12.329H11.9892V17.3325C11.9892 17.8829 12.4376 18.3332 12.9856 18.3332H15.9747C16.5227 18.3332 16.9711 17.8829 16.9711 17.3325V10.3276H18.6649C19.1232 10.3276 19.3424 9.75717 18.9937 9.45696L10.6641 1.92168C10.2854 1.58144 9.70754 1.58144 9.32892 1.92168L0.999274 9.45696C0.660508 9.75717 0.869746 10.3276 1.32808 10.3276H3.0219V17.3325C3.0219 17.8829 3.47027 18.3332 4.01827 18.3332H7.00738C7.55538 18.3332 8.00375 17.8829 8.00375 17.3325Z" stroke={stroke ?? "#03134F"} strokeWidth="1.5"/>
  </svg>

);

export const IconItems = ({fill}) => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M14.401 5.73422H17.2679C17.7016 5.73422 18.0397 6.10912 17.9956 6.54283L16.8636 17.8854C16.7901 18.4882 16.2829 18.966 15.6654 18.966H14.4157L14.401 13.0852C14.401 9.97575 12.1222 8.05714 9.41702 7.4323L9.32881 6.54283C9.29205 6.10912 9.6302 5.73422 10.0639 5.73422H12.9308V3.52892C12.9308 3.12462 13.2616 2.79382 13.6659 2.79382C14.0702 2.79382 14.401 3.12462 14.401 3.52892V5.73422ZM12.1957 17.4958C12.6 17.4958 12.9308 17.8266 12.9308 18.2309C12.9308 18.6352 12.6 18.966 12.1957 18.966H2.6394C2.23509 18.966 1.9043 18.6352 1.9043 18.2309C1.9043 17.8266 2.23509 17.4958 2.6394 17.4958H12.1957ZM2.71291 13.0852H12.1222C12.5779 13.0852 12.9381 12.6736 12.8499 12.2325C12.3721 9.85814 9.89483 8.66727 7.41755 8.66727C4.94026 8.66727 2.47032 9.85814 1.98516 12.2325C1.89695 12.6736 2.2645 13.0852 2.71291 13.0852ZM2.6394 14.5554H12.1957C12.6 14.5554 12.9308 14.8862 12.9308 15.2905C12.9308 15.6948 12.6 16.0256 12.1957 16.0256H2.6394C2.23509 16.0256 1.9043 15.6948 1.9043 15.2905C1.9043 14.8862 2.23509 14.5554 2.6394 14.5554Z" fill={fill ?? "#03134F"}/>
  </svg>
);

export const IconSettings = ({fill}) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M16.2523 9.99984C16.2523 10.2832 16.2273 10.5498 16.194 10.8165L17.9523 12.1915C18.1106 12.3165 18.1523 12.5415 18.0523 12.7248L16.3856 15.6082C16.2856 15.7915 16.069 15.8665 15.8773 15.7915L13.8023 14.9582C13.369 15.2832 12.9023 15.5665 12.394 15.7748L12.0773 17.9832C12.0523 18.1832 11.8773 18.3332 11.669 18.3332H8.33564C8.12731 18.3332 7.95231 18.1832 7.92731 17.9832L7.61064 15.7748C7.10231 15.5665 6.63564 15.2915 6.20231 14.9582L4.12731 15.7915C3.94397 15.8582 3.71897 15.7915 3.61897 15.6082L1.95231 12.7248C1.85231 12.5415 1.89397 12.3165 2.05231 12.1915L3.81064 10.8165C3.77731 10.5498 3.75231 10.2748 3.75231 9.99984C3.75231 9.72484 3.77731 9.44984 3.81064 9.18317L2.05231 7.80817C1.89397 7.68317 1.84397 7.45817 1.95231 7.27484L3.61897 4.3915C3.71897 4.20817 3.93564 4.13317 4.12731 4.20817L6.20231 5.0415C6.63564 4.7165 7.10231 4.43317 7.61064 4.22484L7.92731 2.0165C7.95231 1.8165 8.12731 1.6665 8.33564 1.6665H11.669C11.8773 1.6665 12.0523 1.8165 12.0773 2.0165L12.394 4.22484C12.9023 4.43317 13.369 4.70817 13.8023 5.0415L15.8773 4.20817C16.0606 4.1415 16.2856 4.20817 16.3856 4.3915L18.0523 7.27484C18.1523 7.45817 18.1106 7.68317 17.9523 7.80817L16.194 9.18317C16.2273 9.44984 16.2523 9.7165 16.2523 9.99984ZM7.08564 9.99984C7.08564 11.6082 8.39397 12.9165 10.0023 12.9165C11.6106 12.9165 12.919 11.6082 12.919 9.99984C12.919 8.3915 11.6106 7.08317 10.0023 7.08317C8.39397 7.08317 7.08564 8.3915 7.08564 9.99984Z" fill={fill ?? "#03134F"}/>
  </svg>
);

export const IconUserRouter = ({fill, stroke}) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="path-1-inside-1_2064_76490" fill="white">
    <path fillRule="evenodd" clipRule="evenodd" d="M3.51128 17.6092C4.99433 15.6447 7.34888 14.375 10 14.375C12.6511 14.375 15.0057 15.6447 16.4887 17.6092C18.6376 15.7751 20 13.0466 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 13.0466 1.36244 15.7751 3.51128 17.6092ZM14.5 8.5C14.5 10.9853 12.4853 13 10 13C7.51472 13 5.5 10.9853 5.5 8.5C5.5 6.01472 7.51472 4 10 4C12.4853 4 14.5 6.01472 14.5 8.5Z"/>
    </mask>
    <path fillRule="evenodd" clipRule="evenodd" d="M3.51128 17.6092C4.99433 15.6447 7.34888 14.375 10 14.375C12.6511 14.375 15.0057 15.6447 16.4887 17.6092C18.6376 15.7751 20 13.0466 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 13.0466 1.36244 15.7751 3.51128 17.6092ZM14.5 8.5C14.5 10.9853 12.4853 13 10 13C7.51472 13 5.5 10.9853 5.5 8.5C5.5 6.01472 7.51472 4 10 4C12.4853 4 14.5 6.01472 14.5 8.5Z" fill={fill ?? "#03134F"}/>
    <path d="M3.51128 17.6092L2.86206 18.3698L3.66965 19.0592L4.30939 18.2117L3.51128 17.6092ZM16.4887 17.6092L15.6906 18.2117L16.3303 19.0592L17.1379 18.3698L16.4887 17.6092ZM4.30939 18.2117C5.6116 16.4868 7.67581 15.375 10 15.375V13.375C7.02196 13.375 4.37705 14.8027 2.71317 17.0067L4.30939 18.2117ZM10 15.375C12.3242 15.375 14.3884 16.4868 15.6906 18.2117L17.2868 17.0067C15.6229 14.8027 12.978 13.375 10 13.375V15.375ZM17.1379 18.3698C19.4999 16.3538 21 13.3516 21 10H19C19 12.7417 17.7753 15.1963 15.8395 16.8486L17.1379 18.3698ZM21 10C21 3.92487 16.0751 -1 10 -1V1C14.9706 1 19 5.02944 19 10H21ZM10 -1C3.92487 -1 -1 3.92487 -1 10H1C1 5.02944 5.02944 1 10 1V-1ZM-1 10C-1 13.3516 0.500135 16.3538 2.86206 18.3698L4.1605 16.8486C2.22475 15.1963 1 12.7417 1 10H-1ZM10 14C13.0376 14 15.5 11.5376 15.5 8.5H13.5C13.5 10.433 11.933 12 10 12V14ZM4.5 8.5C4.5 11.5376 6.96243 14 10 14V12C8.067 12 6.5 10.433 6.5 8.5H4.5ZM10 3C6.96243 3 4.5 5.46243 4.5 8.5H6.5C6.5 6.567 8.067 5 10 5V3ZM15.5 8.5C15.5 5.46243 13.0376 3 10 3V5C11.933 5 13.5 6.567 13.5 8.5H15.5Z" fill={fill ?? "#03134F"} mask="url(#path-1-inside-1_2064_76490)"/>
    <circle cx="10" cy="10" r="9.25" stroke={stroke ?? "#03134F"} strokeWidth="1.5"/>
  </svg>
);

export const IconTable = ({stroke}) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.9987 9.16667C15.0613 9.16667 19.1654 7.67428 19.1654 5.83333C19.1654 3.99238 15.0613 2.5 9.9987 2.5C4.9361 2.5 0.832031 3.99238 0.832031 5.83333C0.832031 7.67428 4.9361 9.16667 9.9987 9.16667Z" stroke={stroke ?? "#03134F"} strokeWidth="1.5" strokeMiterlimit="10"/>
  <path fillRule="evenodd" clipRule="evenodd" d="M10.9978 9.56172V8.56172H8.99784V9.56172V13.1619C7.02589 13.5344 5.38672 14.986 5.38672 16.9494V17.171C5.38672 17.7233 5.83443 18.171 6.38672 18.171C6.939 18.171 7.38672 17.7233 7.38672 17.171V16.9494C7.38672 16.3135 7.94823 15.5243 8.99784 15.2084V16.8755C8.99784 17.4278 9.44555 17.8755 9.99784 17.8755C10.5501 17.8755 10.9978 17.4278 10.9978 16.8755V15.1929C12.1629 15.5039 12.7941 16.3426 12.7941 17.0971V17.171C12.7941 17.7233 13.2418 18.171 13.7941 18.171C14.3464 18.171 14.7941 17.7233 14.7941 17.171V17.0971C14.7941 14.9831 13.0547 13.5179 10.9978 13.1556V9.56172Z" fill={stroke ?? "#03134F"}/>
  </svg>
);

export const IconDelivery = ({stroke}) => (
  <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.58203 9.25016C1.58203 4.60177 5.3503 0.833496 9.9987 0.833496C14.6471 0.833496 18.4154 4.60177 18.4154 9.25016C18.4154 11.5765 17.4724 13.6816 15.946 15.2058H4.0514C2.52496 13.6816 1.58203 11.5765 1.58203 9.25016Z" stroke={stroke ?? "#03134F"} strokeWidth="1.5"/>
    <path d="M17.5 5.0835H9.7106C8.52713 5.0835 7.57028 6.11794 7.87338 7.26193C8.87674 11.0489 11.6207 12.2676 18.3333 12.5835" stroke={stroke ?? "#03134F"} strokeWidth="1.5"/>
  </svg>
);

export const IconSale = ({fill}) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="shopping_cart_24px">
    <path id="icon/action/shopping_cart_24px" fillRule="evenodd" clipRule="evenodd" d="M1.66406 2.5013C1.66406 2.95964 2.03906 3.33464 2.4974 3.33464H3.33073L6.33073 9.65964L5.20573 11.693C4.5974 12.8096 5.3974 14.168 6.66406 14.168H15.8307C16.2891 14.168 16.6641 13.793 16.6641 13.3346C16.6641 12.8763 16.2891 12.5013 15.8307 12.5013H6.66406L7.58073 10.8346H13.7891C14.4141 10.8346 14.9641 10.493 15.2474 9.9763L18.2307 4.56797C18.5391 4.01797 18.1391 3.33464 17.5057 3.33464H5.1724L4.61406 2.14297C4.48073 1.8513 4.18073 1.66797 3.86406 1.66797H2.4974C2.03906 1.66797 1.66406 2.04297 1.66406 2.5013ZM6.66406 15.0013C5.7474 15.0013 5.00573 15.7513 5.00573 16.668C5.00573 17.5846 5.7474 18.3346 6.66406 18.3346C7.58073 18.3346 8.33073 17.5846 8.33073 16.668C8.33073 15.7513 7.58073 15.0013 6.66406 15.0013ZM13.3391 16.668C13.3391 15.7513 14.0807 15.0013 14.9974 15.0013C15.9141 15.0013 16.6641 15.7513 16.6641 16.668C16.6641 17.5846 15.9141 18.3346 14.9974 18.3346C14.0807 18.3346 13.3391 17.5846 13.3391 16.668Z" fill={fill ?? "#03134F"}/>
    </g>
  </svg>
);

export const IconDeliveryMan = ({fill}) => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="path-1-inside-1_2064_21688" fill="white">
    <path fillRule="evenodd" clipRule="evenodd" d="M0.833984 12.1299C0.833984 7.06731 4.93804 2.96326 10.0007 2.96326C13.2186 2.96326 16.0493 4.62141 17.6849 7.12991H10.2197C8.63638 7.12991 7.20617 8.54537 7.65185 10.2559C8.23981 12.5125 9.39318 14.0743 11.4462 15.0749C13.075 15.8687 15.239 16.2926 18.0534 16.5132C17.5794 17.3821 16.9689 18.1659 16.2507 18.8356H3.75065C1.95611 17.1623 0.833984 14.7771 0.833984 12.1299ZM18.6906 15.0555C18.9998 14.1367 19.1673 13.1529 19.1673 12.1299C19.1673 10.8904 18.9213 9.70834 18.4754 8.62991H10.2197C9.43007 8.62991 8.95075 9.29189 9.10339 9.87771C9.59593 11.7681 10.4947 12.9425 12.1034 13.7265C13.5754 14.4439 15.6748 14.8511 18.6906 15.0555Z"/>
    </mask>
    <path fillRule="evenodd" clipRule="evenodd" d="M0.833984 12.1299C0.833984 7.06731 4.93804 2.96326 10.0007 2.96326C13.2186 2.96326 16.0493 4.62141 17.6849 7.12991H10.2197C8.63638 7.12991 7.20617 8.54537 7.65185 10.2559C8.23981 12.5125 9.39318 14.0743 11.4462 15.0749C13.075 15.8687 15.239 16.2926 18.0534 16.5132C17.5794 17.3821 16.9689 18.1659 16.2507 18.8356H3.75065C1.95611 17.1623 0.833984 14.7771 0.833984 12.1299ZM18.6906 15.0555C18.9998 14.1367 19.1673 13.1529 19.1673 12.1299C19.1673 10.8904 18.9213 9.70834 18.4754 8.62991H10.2197C9.43007 8.62991 8.95075 9.29189 9.10339 9.87771C9.59593 11.7681 10.4947 12.9425 12.1034 13.7265C13.5754 14.4439 15.6748 14.8511 18.6906 15.0555Z" fill={fill ?? "#03134F"}/>
    <path d="M17.6849 7.12991V8.62991H20.4536L18.9414 6.31065L17.6849 7.12991ZM7.65185 10.2559L9.10339 9.87771V9.87771L7.65185 10.2559ZM11.4462 15.0749L12.1034 13.7265H12.1034L11.4462 15.0749ZM18.0534 16.5132L19.3702 17.2314L20.4791 15.1986L18.1706 15.0177L18.0534 16.5132ZM16.2507 18.8356V20.3356H16.8415L17.2736 19.9327L16.2507 18.8356ZM3.75065 18.8356L2.72769 19.9327L3.15981 20.3356H3.75065V18.8356ZM18.6906 15.0555L18.5892 16.552L19.7433 16.6302L20.1122 15.5339L18.6906 15.0555ZM18.4754 8.62991L19.8616 8.05679L19.4784 7.12991H18.4754V8.62991ZM9.10339 9.87771L10.5549 9.4995V9.4995L9.10339 9.87771ZM12.1034 13.7265L11.4462 15.0749V15.0749L12.1034 13.7265ZM10.0007 1.46326C4.10961 1.46326 -0.666016 6.23889 -0.666016 12.1299H2.33398C2.33398 7.89574 5.76647 4.46326 10.0007 4.46326V1.46326ZM18.9414 6.31065C17.0406 3.3955 13.7467 1.46326 10.0007 1.46326V4.46326C12.6905 4.46326 15.0579 5.84732 16.4284 7.94918L18.9414 6.31065ZM10.2197 8.62991H17.6849V5.62991H10.2197V8.62991ZM9.10339 9.87771C9.01664 9.54477 9.10191 9.26851 9.30077 9.04263C9.52041 8.79314 9.866 8.62991 10.2197 8.62991V5.62991C7.86841 5.62991 5.45567 7.77618 6.20031 10.6341L9.10339 9.87771ZM12.1034 13.7265C10.4951 12.9426 9.59605 11.7685 9.10339 9.87771L6.20031 10.6341C6.88356 13.2564 8.29129 15.2059 10.789 16.4232L12.1034 13.7265ZM18.1706 15.0177C15.4117 14.8016 13.4748 14.3949 12.1034 13.7265L10.789 16.4232C12.6751 17.3425 15.0662 17.7837 17.9362 18.0086L18.1706 15.0177ZM17.2736 19.9327C18.1085 19.1542 18.8186 18.2428 19.3702 17.2314L16.7366 15.7949C16.3403 16.5214 15.8293 17.1776 15.2277 17.7385L17.2736 19.9327ZM3.75065 20.3356H16.2507V17.3356H3.75065V20.3356ZM-0.666016 12.1299C-0.666016 15.2103 0.641618 17.9875 2.72769 19.9327L4.77361 17.7385C3.2706 16.337 2.33398 14.344 2.33398 12.1299H-0.666016ZM20.1122 15.5339C20.4726 14.463 20.6673 13.3176 20.6673 12.1299H17.6673C17.6673 12.9881 17.5269 13.8105 17.2689 14.577L20.1122 15.5339ZM20.6673 12.1299C20.6673 10.6903 20.3813 9.31378 19.8616 8.05679L17.0892 9.20303C17.4613 10.1029 17.6673 11.0905 17.6673 12.1299H20.6673ZM18.4754 7.12991H10.2197V10.1299H18.4754V7.12991ZM10.2197 7.12991C8.57443 7.12991 7.22069 8.6011 7.65185 10.2559L10.5549 9.4995C10.6808 9.98268 10.2857 10.1299 10.2197 10.1299V7.12991ZM7.65185 10.2559C7.93507 11.3429 8.35727 12.3088 8.99986 13.1367C9.64788 13.9716 10.4667 14.5975 11.4462 15.0749L12.7605 12.3781C12.1313 12.0715 11.6964 11.7181 11.3698 11.2973C11.0377 10.8694 10.7642 10.3029 10.5549 9.4995L7.65185 10.2559ZM11.4462 15.0749C13.1893 15.9244 15.5298 16.3447 18.5892 16.552L18.792 13.5589C15.8198 13.3575 13.9615 12.9634 12.7605 12.3781L11.4462 15.0749Z" fill={fill ?? "#03134F"} mask="url(#path-1-inside-1_2064_21688)"/>
  </svg>

);

export const IconNFE = ({fill}) => (
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
  width="20px" height="20px" viewBox="0 0 512.000000 512.000000"
  preserveAspectRatio="xMidYMid meet">

  <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
  fill={fill ?? "#03134F"} stroke="none">
  <path d="M547 4989 c67 -26 137 -94 171 -167 l27 -57 -3 -2005 c-3 -1977 1
  -2343 29 -2454 14 -57 76 -123 154 -164 43 -23 62 -27 140 -27 75 0 98 4 139
  24 66 33 122 91 155 160 l26 56 3 303 4 302 1489 0 1489 0 0 104 0 105 -55 16
  c-34 10 -67 28 -87 48 -21 21 -99 163 -210 384 l-178 351 0 1194 c0 1002 3
  1202 15 1247 52 196 217 347 418 382 40 7 73 13 75 15 2 1 -6 19 -16 41 -26
  48 -84 104 -142 134 l-45 24 -1825 2 -1825 2 52 -20z m914 -348 c16 -16 29
  -38 29 -49 0 -14 17 -30 53 -50 84 -47 136 -121 158 -222 14 -65 -1 -114 -45
  -141 -38 -23 -67 -24 -107 -3 -32 16 -59 66 -59 109 0 16 -12 38 -29 56 -72
  71 -196 6 -177 -93 10 -53 43 -78 121 -89 131 -18 221 -82 270 -190 24 -55 27
  -70 23 -143 -7 -121 -64 -214 -163 -267 -26 -14 -45 -31 -45 -41 0 -26 -48
  -76 -79 -83 -47 -10 -99 18 -120 65 -12 28 -31 48 -57 62 -92 48 -153 141
  -162 244 -6 75 10 108 65 130 28 12 42 13 70 3 38 -12 73 -59 73 -97 0 -69 72
  -123 136 -102 87 29 101 149 22 191 -11 6 -49 15 -84 20 -114 16 -203 78 -251
  177 -24 49 -28 69 -28 142 0 72 4 92 27 135 28 54 96 123 146 149 17 9 32 27
  36 42 19 75 121 101 177 45z m2104 -67 c31 -14 65 -64 65 -94 0 -7 -7 -27 -16
  -45 -32 -67 -5 -65 -783 -65 -754 0 -749 0 -785 51 -21 30 -21 88 0 118 36 51
  28 50 782 51 621 0 708 -2 737 -16z m6 -430 c42 -21 64 -75 49 -120 -6 -18
  -23 -43 -37 -54 -25 -20 -39 -20 -760 -20 l-735 0 -29 29 c-47 47 -37 129 19
  164 25 15 94 16 745 17 633 0 722 -2 748 -16z m12 -434 c38 -30 52 -80 33
  -123 -29 -70 5 -67 -791 -67 -651 0 -720 2 -745 17 -58 34 -68 116 -21 164
  l29 29 735 0 c721 0 735 0 760 -20z m-12 -526 c60 -30 59 -21 59 -729 0 -694
  0 -693 -51 -729 -21 -15 -122 -16 -1121 -16 -787 0 -1104 3 -1122 11 -13 6
  -32 25 -41 43 -14 28 -16 95 -13 702 3 656 3 672 23 694 11 12 29 26 40 31 11
  4 510 8 1108 8 969 1 1091 -1 1118 -15z m-107 -1705 c60 -28 71 -122 20 -170
  l-26 -24 -418 0 -418 0 -26 24 c-50 47 -40 141 17 169 31 15 818 16 851 1z"/>
  <path d="M1494 2977 c-3 -8 -3 -56 -2 -108 l3 -94 213 -3 212 -2 0 110 0 110
  -210 0 c-166 0 -212 -3 -216 -13z"/>
  <path d="M2134 2977 c-3 -8 -3 -56 -2 -108 l3 -94 638 -3 637 -2 0 110 0 110
  -635 0 c-519 0 -637 -2 -641 -13z"/>
  <path d="M1490 2455 l0 -105 215 0 215 0 0 105 0 105 -215 0 -215 0 0 -105z"/>
  <path d="M2130 2455 l0 -105 640 0 640 0 0 105 0 105 -640 0 -640 0 0 -105z"/>
  <path d="M1490 2025 l0 -105 215 0 215 0 0 105 0 105 -215 0 -215 0 0 -105z"/>
  <path d="M2130 2025 l0 -105 640 0 640 0 0 105 0 105 -640 0 -640 0 0 -105z"/>
  <path d="M270 4901 c-74 -24 -119 -63 -145 -123 -13 -32 -15 -109 -15 -543 l0
  -505 210 0 210 0 0 505 c0 545 0 547 -53 603 -47 51 -149 82 -207 63z"/>
  <path d="M4312 4579 c-102 -17 -185 -77 -228 -164 -21 -43 -27 -74 -31 -154
  l-6 -101 322 0 321 0 0 90 c0 187 -86 298 -254 329 -33 6 -62 10 -65 10 -3 -1
  -30 -5 -59 -10z"/>
  <path d="M4057 3944 c-4 -4 -7 -389 -7 -856 l0 -848 320 0 320 0 0 745 0 745
  25 0 c63 0 132 -47 168 -115 21 -39 22 -54 27 -468 l5 -429 28 -24 c50 -43
  131 -28 162 30 15 28 16 75 13 461 -3 425 -3 431 -27 488 -44 112 -143 207
  -258 250 -55 20 -77 22 -413 25 -196 2 -359 0 -363 -4z"/>
  <path d="M4060 2020 c0 -6 70 -151 156 -322 l157 -313 158 315 c87 173 158
  318 158 323 1 4 -141 7 -314 7 -205 0 -315 -4 -315 -10z"/>
  <path d="M1598 533 c-5 -235 -14 -278 -74 -380 l-25 -43 1643 2 1643 3 45 24
  c61 32 116 86 148 146 26 49 27 55 30 258 l3 207 -1704 0 -1705 0 -4 -217z"/>
  </g>
  </svg>

);

export const IconAttendant = ({stroke, fill}) => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="9.99935" cy="7.54659" rx="5.83333" ry="5.83333" stroke={stroke ?? "#03134F"} strokeWidth="1.5"/>
    <path d="M5 19.1761V15.0527C5 14.6738 5.40499 14.4326 5.73814 14.6131L10.1852 17.0219L14.2481 14.6519C14.5814 14.4574 15 14.6979 15 15.0838V18.7905C15 19.1693 14.595 19.4106 14.2619 19.2301L10.1852 17.0219L5.75194 19.608C5.41861 19.8024 5 19.562 5 19.1761Z" fill={fill ?? "#03134F"} stroke={stroke ?? "#03134F"}/>
  </svg>

);

export const IconAPP = ({fill}) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M5 2.8335C5 1.72893 5.89543 0.833496 7 0.833496H13C14.1046 0.833496 15 1.72893 15 2.8335V17.1668C15 18.2714 14.1046 19.1668 13 19.1668H7C5.89543 19.1668 5 18.2714 5 17.1668V2.8335ZM6 3.00015H14V16.0002H6V3.00015ZM10 18.3335C10.4602 18.3335 10.8333 17.9604 10.8333 17.5002C10.8333 17.0399 10.4602 16.6668 10 16.6668C9.53976 16.6668 9.16667 17.0399 9.16667 17.5002C9.16667 17.9604 9.53976 18.3335 10 18.3335Z" fill={fill ?? "#03134F"}/>
  </svg>
);

export const IconConsultSale = ({fill}) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M18.4398 1.00927C18.4428 1.00921 18.4459 1.00918 18.4489 1.00918H18.4398V1.00927ZM18.4398 1.00927C18.3235 1.01157 18.2081 1.05746 18.1275 1.14694L17.402 1.87245C17.2183 2.05612 16.9336 2.05612 16.75 1.87245L16.0245 1.14694C15.8408 0.963265 15.5561 0.963265 15.3724 1.14694L14.6469 1.87245C14.4632 2.05612 14.1785 2.05612 13.9949 1.87245L13.2694 1.14694C13.0857 0.963265 12.801 0.963265 12.6173 1.14694L11.8918 1.87245C11.7081 2.05612 11.4234 2.05612 11.2398 1.87245L10.5143 1.14694C10.3306 0.963265 10.0459 0.963265 9.86221 1.14694L9.1367 1.87245C8.95303 2.05612 8.66833 2.05612 8.48466 1.87245L7.74997 1.13776C7.56629 0.954082 7.2816 0.954082 7.09793 1.13776L6.37242 1.87245C6.18874 2.05612 5.90405 2.05612 5.72038 1.87245L4.99487 1.13776C4.81119 0.954082 4.5265 0.954082 4.34282 1.13776L3.61731 1.87245C3.43364 2.05612 3.14895 2.05612 2.96527 1.87245L2.23976 1.13776C2.15711 1.0551 2.03772 1.00918 1.91833 1.00918V19C2.03772 19 2.15711 18.9541 2.23976 18.8622L2.96527 18.1367C3.14895 17.9531 3.43364 17.9531 3.61731 18.1367L4.34282 18.8622C4.5265 19.0459 4.81119 19.0459 4.99487 18.8622L5.72038 18.1367C5.90405 17.9531 6.18874 17.9531 6.37242 18.1367L7.09793 18.8622C7.2816 19.0459 7.56629 19.0459 7.74997 18.8622L8.47548 18.1367C8.65915 17.9531 8.94384 17.9531 9.12752 18.1367L9.85303 18.8622C10.0367 19.0459 10.3214 19.0459 10.5051 18.8622L11.2306 18.1367C11.4143 17.9531 11.6989 17.9531 11.8826 18.1367L12.6081 18.8622C12.7918 19.0459 13.0765 19.0459 13.2602 18.8622L13.9857 18.1367C14.1694 17.9531 14.454 17.9531 14.6377 18.1367L15.3632 18.8622C15.5469 19.0459 15.8316 19.0459 16.0153 18.8622L16.7408 18.1367C16.9245 17.9531 17.2092 17.9531 17.3928 18.1367L18.1183 18.8622C18.2102 18.9541 18.3296 19 18.4398 19V1.00927ZM5.5 5.25C5.08579 5.25 4.75 5.58579 4.75 6C4.75 6.41421 5.08579 6.75 5.5 6.75H14.5C14.9142 6.75 15.25 6.41421 15.25 6C15.25 5.58579 14.9142 5.25 14.5 5.25H5.5ZM5.5 9.25C5.08579 9.25 4.75 9.58579 4.75 10C4.75 10.4142 5.08579 10.75 5.5 10.75H14.5C14.9142 10.75 15.25 10.4142 15.25 10C15.25 9.58579 14.9142 9.25 14.5 9.25H5.5ZM5.5 13.25C5.08579 13.25 4.75 13.5858 4.75 14C4.75 14.4142 5.08579 14.75 5.5 14.75H14.5C14.9142 14.75 15.25 14.4142 15.25 14C15.25 13.5858 14.9142 13.25 14.5 13.25H5.5Z" fill={fill ?? "black"}/>
  </svg>
);

export const IconCurrency = ({fill}) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="icon/action/money">
      <path id="$" d="M10.0744 16.6849C9.01982 16.6849 8.12285 16.5152 7.38345 16.1758C6.64406 15.8243 6.08042 15.3334 5.69254 14.7031C5.45203 14.2919 5.28849 13.836 5.20193 13.3354C5.11808 12.8506 5.52778 12.4486 6.01982 12.4486C6.51185 12.4486 6.90255 12.8569 7.0617 13.3225C7.10076 13.4367 7.14741 13.5515 7.20163 13.6667C7.39557 14.0667 7.72285 14.4061 8.18345 14.6849C8.65618 14.9516 9.28648 15.0849 10.0744 15.0849C11.1289 15.0849 11.9168 14.8667 12.438 14.4304C12.9592 13.9819 13.2198 13.4667 13.2198 12.8849C13.2198 12.3273 12.9895 11.8667 12.5289 11.5031C12.0683 11.1273 11.3895 10.897 10.4925 10.8122L9.34709 10.7031C8.15921 10.594 7.21375 10.2364 6.51072 9.63037C5.80769 9.02431 5.45618 8.1637 5.45618 7.04855C5.45618 6.27279 5.64406 5.61825 6.01982 5.08492C6.39557 4.53946 6.91678 4.12128 7.58345 3.83037C8.26224 3.53946 9.06224 3.39401 9.98345 3.39401C10.9168 3.39401 11.7168 3.55764 12.3835 3.88492C13.0501 4.20007 13.5653 4.66673 13.9289 5.28492C14.1622 5.67371 14.3206 6.11737 14.4043 6.6159C14.4857 7.10115 14.0755 7.5031 13.5835 7.5031C13.0914 7.5031 12.7086 7.09268 12.5434 6.62921C12.504 6.51855 12.4567 6.40984 12.4016 6.3031C12.2198 5.91522 11.9289 5.60007 11.5289 5.35764C11.141 5.11522 10.6259 4.99401 9.98345 4.99401C9.41375 4.99401 8.92891 5.08492 8.52891 5.26673C8.12891 5.44855 7.81982 5.69704 7.60163 6.01219C7.38345 6.31522 7.27436 6.66067 7.27436 7.04855C7.27436 7.55764 7.45618 8.00007 7.81982 8.37583C8.18345 8.73946 8.74103 8.95764 9.49254 9.03037L10.6562 9.12128C11.9774 9.24249 13.0319 9.62431 13.8198 10.2667C14.6198 10.9092 15.0198 11.7819 15.0198 12.8849C15.0198 13.6486 14.8198 14.3152 14.4198 14.8849C14.0198 15.4546 13.4501 15.897 12.7107 16.2122C11.9835 16.5273 11.1047 16.6849 10.0744 16.6849ZM10.0744 19.0122C9.61245 19.0122 9.238 18.6377 9.238 18.1758V16.3576H10.9107V18.1758C10.9107 18.6377 10.5363 19.0122 10.0744 19.0122ZM9.16527 4.28492V2.46673C9.16527 2.00482 9.53972 1.63037 10.0016 1.63037C10.4635 1.63037 10.838 2.00482 10.838 2.46673V4.28492H9.16527Z" fill={fill ?? "#03134F"}/>
    </g>
  </svg>
);

export const IconWorthExchange = ({fill}) => (
  <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="20px" height="20px" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">

    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill={fill} stroke="none">
      <path d="M2741 4778 c-78 -40 -86 -58 -89 -223 l-3 -144 -62 -5 c-336 -27 -427 -43 -636 -112 -567 -186 -1003 -609 -1149 -1113 -20 -69 -25 -116 -29 -243 -3 -87 -3 -158 0 -158 3 0 42 36 87 80 396 391 957 625 1553 647 l167 6 0 -159 c0 -87 5 -175 10 -194 19 -69 112 -129 176 -114 53 12 1478 626 1510 650 79 59 98 192 38 276 -20 28 -54 55 -109 85 -44 25 -206 113 -360 198 -154 84 -437 240 -630 345 -244 134 -362 194 -390 197 -29 3 -52 -2 -84 -19z"/>
      <path d="M1350 3045 c-139 -86 -281 -207 -423 -358 l-108 -116 45 -101 c54 -123 157 -279 244 -371 55 -59 69 -69 98 -69 37 0 73 28 75 58 1 9 1 42 0 72 -8 222 69 732 134 887 9 20 14 38 12 39 -2 2 -36 -17 -77 -41z"/>
      <path d="M3860 3070 c-11 -11 -20 -26 -20 -32 -7 -318 -22 -479 -66 -698 -21 -105 -58 -244 -81 -299 -7 -18 65 23 156 87 113 79 233 186 344 305 l108 116 -45 101 c-54 123 -157 279 -244 371 -55 59 -69 69 -98 69 -21 0 -42 -8 -54 -20z"/>
      <path d="M4260 2261 c-371 -381 -959 -626 -1552 -648 l-168 -6 0 159 c0 87 -5 175 -10 194 -19 69 -112 129 -176 114 -49 -11 -1457 -616 -1498 -643 -59 -39 -88 -101 -84 -178 7 -121 -29 -96 772 -535 500 -274 722 -390 750 -394 49 -6 119 26 150 69 18 25 21 46 24 172 l3 143 37 6 c20 3 65 6 99 6 83 0 265 26 388 55 573 136 1055 516 1260 992 68 158 87 243 93 416 2 86 0 157 -4 156 -5 -1 -43 -36 -84 -78z"/>
    </g>
  </svg>
);

export const IconSisteShop = ({fill}) => (
  <svg width="72" height="89" viewBox="0 0 72 89" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Group 3465036">
    <g id="Group">
    <path id="Vector" d="M45.2783 52.7567C44.4898 52.7164 43.7358 53.1365 43.4019 53.856C42.1011 56.6591 39.2865 58.6103 36 58.6103C32.2703 58.6103 29.1506 56.095 28.1606 52.6818C30.1579 51.8012 31.5681 49.8327 31.6141 47.5247C31.6832 44.405 29.1334 41.7171 26.0137 41.625C22.7445 41.5271 20.0565 44.1575 20.0565 47.398C20.0565 49.9881 21.7775 52.158 24.1316 52.889C25.2828 58.3858 30.1637 62.5299 36 62.5299C40.8233 62.5299 44.9905 59.7039 46.9475 55.6173C47.5633 54.328 46.7057 52.8257 45.2783 52.7509V52.7567ZM25.8353 45.5447C26.8598 45.5447 27.6887 46.3735 27.6887 47.398C27.6887 48.4226 26.8541 49.2514 25.8353 49.2514C24.8165 49.2514 23.982 48.4226 23.982 47.398C23.982 46.3735 24.8108 45.5447 25.8353 45.5447Z" fill={fill ?? "#0B02C1"}/>
    <path id="Vector_2" d="M56.9798 88.5H15.026C10.8127 88.5 6.79522 86.7214 4.00367 83.6191C1.28695 80.6031 -0.031132 76.574 0.389039 72.568L4.90732 29.676C5.60377 23.0626 10.7667 17.7903 17.4722 16.8637C19.078 16.6392 20.5688 17.7673 20.7875 19.3732C21.012 20.9848 19.8896 22.4698 18.278 22.6942C14.2662 23.2526 11.1754 26.3779 10.7609 30.2976L6.24267 73.1896C5.98941 75.5725 6.74917 77.8806 8.3723 79.6821C10.053 81.547 12.4762 82.6176 15.026 82.6176H56.9798C59.5238 82.6176 61.9413 81.5528 63.6219 79.6994C65.2451 77.9036 66.0048 75.6071 65.7689 73.2299L61.4635 30.3379C61.0664 26.3607 57.8086 23.1374 53.722 22.6655C52.1047 22.4813 50.9477 21.0193 51.1319 19.4077C51.3161 17.7961 52.7435 16.6277 54.3897 16.8176C61.2045 17.6004 66.6437 23.0338 67.3114 29.7451L71.6167 72.6371C72.0196 76.6316 70.6958 80.6434 67.9791 83.6421C65.1875 86.7272 61.1758 88.4942 56.974 88.4942L56.9798 88.5Z" fill={fill ?? "#0B02C1"}/>
    <path id="Vector_3" d="M45.2092 24.4325C43.5861 24.4325 42.268 23.1144 42.268 21.4913V12.6504C42.268 9.19697 39.4592 6.3824 36 6.3824C32.5408 6.3824 29.7319 9.19121 29.7319 12.6504V21.4913C29.7319 23.1144 28.4139 24.4325 26.7907 24.4325C25.1676 24.4325 23.8495 23.1144 23.8495 21.4913V12.6504C23.8495 5.95072 29.3003 0.5 36 0.5C42.6997 0.5 48.1504 5.95072 48.1504 12.6504V21.4913C48.1504 23.1144 46.8323 24.4325 45.2092 24.4325Z" fill={fill ?? "#0B02C1"}/>
    <path id="Vector_4" d="M47.6094 49.5564C48.8015 49.5564 49.7678 48.5901 49.7678 47.398C49.7678 46.2059 48.8015 45.2396 47.6094 45.2396C46.4173 45.2396 45.451 46.2059 45.451 47.398C45.451 48.5901 46.4173 49.5564 47.6094 49.5564Z" fill={fill ?? "#0B02C1"}/>
    </g>
    </g>
  </svg>
);

export const IconSisteFood = ({fill, fill2, stroke}) => (
  <svg width="307" height="279" viewBox="0 0 307 279" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M223.682 97.8465C223.682 97.8465 231.482 98.0465 227.382 100.847C223.282 103.647 196.682 104.247 191.782 104.547C189.382 104.747 147.382 106.447 121.382 123.047C83.5816 147.347 83.5816 173.447 83.5816 173.447C83.5816 173.447 82.1816 182.447 87.7816 193.047C93.3816 203.647 101.682 198.647 101.682 198.647C101.682 198.647 109.982 191.247 94.7816 181.047C80.1816 171.147 45.4816 172.047 44.1816 172.047C43.7816 172.047 40.6816 172.747 38.5816 174.147C35.3816 176.247 32.1816 179.147 26.5816 178.247C17.6816 176.747 6.18164 168.047 1.78164 164.747C0.881639 164.047 0.681638 162.647 1.48164 161.747C2.08164 161.047 3.18164 160.847 3.98164 161.347C10.1816 165.447 16.3816 168.647 22.5816 170.847C23.6816 171.447 25.0816 170.947 25.5816 169.747C25.9816 168.747 25.5816 167.547 24.4816 167.047L4.38164 157.047C3.28164 156.547 2.88164 155.247 3.58164 154.247C4.08164 153.447 5.08164 153.147 5.88164 153.547L26.2816 161.447C27.4816 161.947 28.8816 161.247 29.2816 159.947C29.6816 158.747 28.9816 157.447 27.8816 157.047L6.88164 149.747C5.88164 149.347 5.38164 148.147 5.88164 147.147C6.28164 146.347 7.18164 145.947 7.98164 146.147C10.6816 146.847 16.5816 148.447 23.2816 150.347C27.2816 151.547 31.7816 152.047 35.5816 153.847C39.3816 155.647 40.3816 159.747 42.6816 162.147C45.5816 165.147 48.8816 166.247 49.5816 166.247C50.2816 166.247 77.9816 164.847 93.3816 172.747C114.982 183.847 111.882 202.847 105.882 208.647C100.682 213.647 91.9816 213.947 91.7816 213.947C91.6816 213.947 75.2816 212.847 68.9816 200.647C64.9816 192.847 62.8816 182.447 61.8816 173.447C60.6816 162.747 60.8816 153.947 60.9816 153.847C61.3816 153.747 83.6816 150.747 83.6816 150.747L83.3816 132.447L104.082 130.047L101.382 112.447C101.382 112.447 138.782 104.847 173.182 100.647C197.882 97.6465 222.382 97.7465 223.682 97.8465Z" fill={fill ?? "#C51F2A"}/>
    <path d="M169.081 165.747C167.681 162.647 168.881 152.247 152.681 148.247C145.181 146.447 135.481 147.647 133.281 153.347C130.681 159.847 136.981 171.347 148.581 176.747C156.981 180.647 164.481 173.947 166.981 174.047C167.681 174.047 168.981 174.647 170.581 175.547C171.481 173.947 172.581 172.247 173.581 170.547C171.381 168.947 169.781 167.247 169.081 165.747Z" fill={fill2 ?? "#03134F"}/>
    <path d="M263.581 150.147C258.481 145.647 249.481 142.647 238.581 149.047C229.081 154.547 220.981 162.147 212.081 168.547C203.181 174.947 189.981 174.447 179.681 172.147C177.081 171.547 174.481 170.847 171.981 169.747L170.281 175.247C170.281 175.347 182.881 178.447 183.881 178.647C190.181 179.847 196.681 180.447 203.081 179.747C209.581 179.047 215.281 176.747 220.781 173.347C225.881 170.247 230.681 166.447 236.081 163.847C236.681 163.547 237.281 163.347 237.881 163.047C246.381 159.747 252.481 163.647 253.681 170.747C258.381 198.547 226.981 230.647 180.181 232.847C155.181 234.047 131.881 234.547 114.881 236.747C99.1809 238.747 89.5808 238.647 86.6808 232.547C84.8808 228.747 84.3809 224.447 82.2809 222.647C78.9809 219.647 75.1809 219.447 72.8809 219.647C71.8809 219.747 71.0809 220.747 71.2809 221.747C72.1809 227.547 76.5808 245.547 94.6808 244.347C116.181 242.947 201.581 236.947 242.581 242.947C271.181 247.347 281.081 165.847 263.581 150.147Z" fill={fill2 ?? "#03134F"}/>
    <path d="M171.88 169.747C171.28 171.647 170.68 173.547 170.18 175.247L171.88 169.747Z" fill={fill2 ?? "#03134F"}/>
    <path d="M186.782 142.347C185.182 141.747 184.582 139.747 184.982 138.047C185.782 134.547 185.482 130.947 184.282 127.747C183.682 126.147 184.082 124.247 185.482 123.247C186.882 122.247 189.082 123.047 189.882 125.347C191.582 129.647 191.982 134.447 190.982 139.147C190.582 141.447 188.382 142.947 186.782 142.347Z" fill={stroke ?? "#3E3E3E"}/>
    <path d="M215.68 138.247C214.08 137.647 213.48 135.647 213.88 133.947C214.68 130.447 214.38 126.847 213.18 123.647C212.58 122.047 212.98 120.147 214.38 119.147C215.78 118.147 217.98 118.947 218.78 121.247C220.48 125.547 220.88 130.347 219.88 135.047C219.38 137.347 217.28 138.847 215.68 138.247Z" fill={stroke ?? "#3E3E3E"}/>
    <path d="M139.983 89.4465C139.983 89.4465 143.883 83.4465 168.583 81.5465C193.283 79.6465 190.583 84.0465 185.683 74.8465C180.783 65.6465 154.283 68.0465 148.583 70.3465C148.583 70.3465 150.183 62.4465 179.483 63.2465C195.783 63.7465 213.883 39.1465 206.883 25.3465C199.883 11.5465 184.183 17.5465 177.283 25.5465C177.283 25.5465 168.083 3.44654 140.083 10.7465C120.383 15.8465 128.583 37.9465 128.583 37.9465C128.583 37.9465 112.183 35.0465 104.783 43.2465C97.3832 51.4465 100.583 60.6465 108.783 64.8465C116.983 69.0465 134.983 76.8465 131.983 87.0465C131.983 87.0465 132.683 78.5465 110.083 72.3465C87.4832 66.1465 92.7832 46.2465 95.1832 43.2465C97.5832 40.3465 100.383 32.5465 118.383 30.6465C118.383 30.6465 114.483 11.3465 134.383 3.34654C154.983 -4.95346 170.183 5.34654 177.683 15.1465C177.683 15.1465 189.683 6.74654 200.983 10.3465C216.383 15.2465 217.483 27.9465 216.883 34.3465C215.483 48.5465 200.383 63.7465 195.383 68.0465C190.483 72.2465 196.683 81.0465 193.883 86.7465C191.183 92.3465 183.083 85.9465 166.683 86.0465C152.383 86.1465 139.983 89.4465 139.983 89.4465Z" fill={fill ?? "#C51F2A"}/>
    <path d="M75.6805 121.747H54.4805V142.947H75.6805V121.747Z" fill={fill ?? "#C51F2A"}/>
    <path d="M94.443 95.4583L76.9961 97.7692L79.307 115.216L96.7539 112.905L94.443 95.4583Z" fill={fill ?? "#C51F2A"}/>
    <path d="M61.75 100.811L51.1484 99.3658L49.7029 109.967L60.3044 111.413L61.75 100.811Z" fill={fill ?? "#C51F2A"}/>
    <path d="M68.8828 85.2466H62.8828V91.2466H68.8828V85.2466Z" fill={fill ?? "#C51F2A"}/>
    <path d="M176.882 265.547C176.882 265.547 177.382 268.347 174.482 268.247C171.482 268.147 167.282 268.247 167.282 268.247C167.282 268.247 164.282 268.747 164.382 266.147C164.582 261.947 162.682 261.147 164.182 260.347C164.582 260.147 164.782 260.247 164.782 259.547C164.782 258.747 164.282 258.147 163.882 257.947C162.982 257.447 164.082 256.847 164.782 257.047C166.382 257.447 164.282 254.347 166.582 254.447C168.882 254.447 175.282 254.447 175.282 254.447C175.282 254.447 177.282 254.247 177.182 256.347C177.082 258.447 177.282 259.147 178.082 259.647C178.882 260.147 179.582 260.547 179.582 261.147C179.582 261.747 178.282 262.447 177.982 262.947C177.582 263.047 177.082 263.947 176.882 265.547Z" fill={fill2 ?? "#03134F"}/>
    <path d="M180.981 258.847C180.981 258.847 178.481 256.747 181.781 254.747C185.081 252.647 193.981 247.947 198.381 246.947C202.681 245.847 204.081 246.647 204.681 248.247C205.381 249.847 209.781 262.047 203.581 275.947C202.581 278.447 200.381 278.347 197.481 277.147C194.681 275.847 185.081 271.747 182.581 269.647C180.081 267.547 179.781 264.947 180.781 263.547C181.781 262.147 183.081 262.047 183.181 261.147C183.281 260.147 180.981 258.847 180.981 258.847Z" fill={fill2 ?? "#03134F"}/>
    <path d="M156.483 254.147C156.983 254.147 158.683 254.947 159.483 255.347C160.283 255.747 161.183 255.847 161.483 255.747C161.783 255.547 161.283 255.047 160.383 254.447C159.883 253.547 136.083 240.647 133.383 251.347C130.883 261.747 134.983 273.647 135.883 276.647C136.883 279.647 138.983 278.546 141.183 278.246C143.383 277.846 151.183 273.647 156.283 270.947C161.383 268.147 161.283 267.247 161.683 266.547C162.083 265.847 161.583 263.847 161.583 262.847C161.583 261.847 159.183 263.447 159.183 263.447C157.783 264.347 150.083 267.647 149.083 268.047C147.983 268.447 148.583 267.347 148.983 267.147C149.283 266.947 154.983 264.047 155.883 263.547C156.783 263.047 156.783 262.247 156.683 261.947C156.483 261.647 155.783 261.547 155.983 261.047C156.183 260.647 157.783 261.147 159.283 261.147C160.783 261.147 161.483 259.747 161.383 259.347C161.383 258.947 161.383 258.247 160.783 257.547C160.183 256.847 155.783 255.347 155.383 254.747C154.783 254.247 155.883 254.147 156.483 254.147Z" fill={fill2 ?? "#03134F"}/>
    <path d="M297.082 135.547C297.082 135.547 294.182 167.647 288.182 175.047C282.182 182.447 271.082 186.647 271.082 186.647" stroke={stroke ?? "#3E3E3E"} strokeWidth="5" strokeMiterlimit="10"/>
    <path d="M305.981 124.447C305.881 122.947 305.581 121.247 304.781 119.947C303.681 118.347 301.781 117.447 299.881 117.647C297.781 117.947 295.981 119.347 294.981 121.247C294.481 122.147 294.181 123.147 293.881 124.147C293.881 124.247 293.781 124.347 293.781 124.547C293.581 124.447 293.481 124.447 293.281 124.347C292.181 123.947 291.081 124.047 290.081 124.647C288.081 125.847 287.881 128.547 288.981 130.347C289.781 131.747 290.981 132.947 292.081 134.147C293.181 135.347 294.481 136.347 295.981 137.147C296.481 137.447 297.081 137.447 297.681 137.447C298.081 137.447 298.381 137.447 298.781 137.347C300.381 136.947 301.781 135.247 302.781 134.047C303.881 132.747 304.881 131.247 305.481 129.647C305.981 127.947 306.081 126.147 305.981 124.447Z" fill={stroke ?? "#3E3E3E"}/>
    <path d="M49.3816 245.047C48.2816 243.247 45.8816 242.347 43.8816 241.647C43.0816 241.347 42.1816 241.047 41.2816 240.947C40.8816 240.547 40.2816 240.347 39.6816 240.347C37.8816 240.247 35.9816 240.347 34.4816 241.347C32.2816 242.847 31.6816 245.347 32.2816 247.747C32.4816 248.747 32.9816 249.747 33.3816 250.647C33.6816 251.447 34.0816 252.247 34.5816 252.947C35.9816 254.847 37.9816 256.347 40.3816 256.547C41.5816 256.647 42.6816 256.247 43.6816 255.547C44.7816 254.647 45.2816 253.547 45.4816 252.147C45.4816 251.847 45.4816 251.647 45.4816 251.347C45.4816 251.247 45.4816 251.147 45.4816 251.147C45.4816 251.147 45.5816 251.147 45.5816 251.047C45.6816 251.047 45.7816 251.047 45.7816 251.047C46.1816 251.047 46.5816 250.947 46.9816 250.947C49.7816 250.547 50.7816 247.247 49.3816 245.047Z" fill={stroke ?? "#3E3E3E"}/>
    <path d="M41.4805 244.647C41.4805 244.647 44.3805 212.547 50.3805 205.147C56.3805 197.747 67.4805 193.547 67.4805 193.547" stroke={stroke ?? "#3E3E3E"} strokeWidth="5" strokeMiterlimit="10"/>
  </svg>

);

export const IconNoteEntry = ({fill}) => (
  <svg  xmlns="http://www.w3.org/2000/svg" version="1.0" width="20" height="20" viewBox="0 0 512.000000 512.000000"><g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill={"fill ?? #03134F"} stroke="none">// <path d="M2748 5034 c-3 -3 -50 -95 -104 -205 l-98 -199 -696 0 -697 0 -44 -23 c-28 -15 -54 -40 -73 -71 -26 -42 -30 -58 -34 -150 l-5 -104 -87 -4 c-81 -3 -91 -5 -127 -34 -80 -65 -94 -178 -31 -250 46 -53 76 -64 168 -64 l80 0 0 -105 0 -105 -75 0 c-85 0 -128 -14 -167 -56 -77 -83 -59 -217 37 -271 33 -18 56 -23 123 -23 l82 0 0 -105 0 -105 -72 0 c-115 -1 -180 -40 -209 -127 -25 -76 11 -162 84 -203 26 -15 63 -24 118 -27 l79 -6 0 -98 0 -99 -72 0 c-115 -1 -180 -40 -209 -127 -25 -77 16 -174 88 -208 22 -11 70 -20 116 -23 l77 -5 0 -97 0 -97 -82 -5 c-50 -3 -96 -11 -115 -21 -81 -43 -116 -152 -75 -233 38 -75 93 -103 205 -104 l67 0 0 -99 0 -98 -84 -5 c-103 -5 -152 -32 -185 -100 -40 -83 -16 -175 59 -224 35 -23 55 -28 126 -32 l84 -5 0 -88 0 -89 -80 0 c-92 0 -122 -11 -168 -64 -53 -60 -53 -154 0 -221 35 -44 89 -65 171 -65 l74 0 5 -105 c4 -93 8 -109 34 -151 19 -31 45 -56 73 -71 l44 -23 1473 0 c1016 0 1481 3 1501 11 38 14 81 56 104 101 19 36 19 77 17 1490 l-3 1453 -24 3 c-53 8 -51 77 -51 -1471 l0 -1439 -34 -34 -34 -34 -1466 0 c-1265 0 -1471 2 -1495 15 -44 22 -61 70 -61 169 l0 86 78 0 c145 1 216 62 214 187 -2 55 -23 95 -69 130 -32 24 -47 28 -127 33 l-91 5 -3 88 -3 87 71 0 c139 0 222 68 222 180 0 55 -20 98 -62 133 -39 33 -88 47 -167 47 l-63 0 0 99 0 98 83 5 c51 3 97 11 120 23 119 56 124 236 10 307 -29 17 -56 23 -125 26 l-88 4 0 98 0 97 83 5 c46 3 96 12 113 21 121 63 130 229 17 307 -29 20 -50 25 -124 28 l-89 4 0 98 0 97 85 6 c88 6 114 15 153 51 61 54 72 145 28 220 -36 62 -89 86 -190 86 l-77 0 3 103 3 102 92 5 c72 4 98 9 120 26 64 48 95 126 74 194 -27 90 -92 129 -214 130 l-78 0 3 103 3 102 91 5 c80 5 95 9 127 33 46 35 67 75 69 130 2 125 -69 186 -214 187 l-78 0 0 86 c0 96 15 142 58 171 25 17 70 18 695 21 428 2 667 -1 667 -7 0 -5 -140 -292 -311 -638 -461 -931 -460 -928 -444 -950 12 -17 40 -18 386 -23 l373 -5 120 -177 c67 -98 129 -180 139 -183 10 -4 24 -2 31 4 7 6 66 89 132 186 l119 174 363 1 c231 0 370 4 383 10 10 6 19 19 19 30 0 10 -171 364 -380 786 -209 422 -380 774 -380 781 0 11 94 13 498 13 308 0 511 -4 534 -10 20 -6 48 -24 62 -41 l26 -31 0 -257 c0 -278 3 -296 51 -289 l24 3 3 273 c2 252 1 275 -17 310 -23 45 -66 87 -104 101 -19 7 -213 11 -575 11 l-547 0 -103 205 c-89 179 -105 205 -125 205 -13 0 -26 -2 -29 -6z m-156 -1159 l-108 -850 -323 -3 c-198 -1 -321 1 -319 7 21 59 854 1727 855 1714 2 -10 -46 -400 -105 -868z m692 10 l426 -860 -317 -3 c-174 -1 -320 1 -324 5 -4 5 -55 388 -113 853 -58 465 -108 854 -111 864 -2 11 0 15 5 10 5 -5 200 -396 434 -869z m-556 -749 l-3 -383 -82 121 -83 121 83 652 82 652 3 -390 c1 -215 1 -563 0 -773z" fill={fill ?? "#03134F"}></path><path d="M4180 3821 c-6 -12 -10 -99 -10 -213 0 -211 5 -233 51 -226 l24 3 3 214 c2 149 -1 218 -9 227 -16 20 -47 17 -59 -5z" fill={fill ?? "#03134F"}></path><path d="M2547 2553 c-4 -3 -7 -71 -7 -149 0 -131 2 -144 19 -154 25 -13 27 -13 45 6 13 12 16 40 16 144 0 71 -3 135 -6 144 -6 16 -54 22 -67 9z" fill={fill ?? "#03134F"}></path><path d="M2937 2553 c-4 -3 -7 -71 -7 -149 0 -131 2 -144 19 -154 25 -13 27 -13 45 6 13 12 16 40 16 144 0 71 -3 135 -6 144 -6 16 -54 22 -67 9z" fill={fill ?? "#03134F"}></path><path d="M2741 2461 c-12 -21 -15 -250 -5 -288 7 -27 40 -39 60 -22 12 10 14 40 12 168 l-3 156 -27 3 c-18 2 -30 -3 -37 -17z" fill={fill ?? "#03134F"}></path><path d="M1786 1864 c-19 -19 -20 -36 -4 -52 9 -9 244 -12 995 -12 925 0 983 1 991 18 10 19 5 43 -12 54 -6 4 -448 8 -983 8 -870 0 -973 -2 -987 -16z" fill={fill ?? "#03134F"}></path><path d="M1778 1385 c-8 -19 -8 -28 2 -40 11 -13 122 -15 999 -13 l986 3 3 29 c2 16 -2 32 -10 37 -7 5 -453 9 -991 9 l-977 0 -12 -25z" fill={fill ?? "#03134F"}></path><path d="M1780 925 c-10 -12 -10 -21 -2 -40 l12 -25 977 0 c538 0 984 4 991 9 8 5 12 21 10 37 l-3 29 -986 3 c-877 2 -988 0 -999 -13z" fill={fill ?? "#03134F"}></path></g>
  </svg>
);

export const IconNoteSingle = ({fill}) => (
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
  width="20px" height="20px" viewBox="0 0 512.000000 512.000000"
  preserveAspectRatio="xMidYMid meet">

  <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
  fill={fill ?? "#000000"} stroke="none">
  <path d="M3843 5059 c-350 -32 -664 -268 -800 -603 -18 -45 -33 -89 -33 -98 0
  -17 -72 -18 -1368 -18 -1222 0 -1370 -2 -1390 -16 l-22 -15 0 -2123 c0 -1637
  3 -2125 12 -2134 9 -9 418 -12 1778 -12 1699 0 1768 1 1783 18 16 17 17 139
  17 1553 l0 1534 77 -3 c290 -15 591 120 783 351 73 87 161 260 190 372 12 44
  24 125 27 181 23 385 -185 744 -532 917 -164 82 -332 113 -522 96z m325 -138
  c450 -131 712 -602 585 -1051 -75 -264 -284 -480 -553 -571 -84 -29 -111 -33
  -230 -37 -113 -3 -150 -1 -223 17 -445 106 -725 536 -641 982 63 334 321 598
  659 675 89 20 309 12 403 -15z m-1185 -848 c4 -121 9 -164 31 -236 93 -309
  328 -552 634 -651 l52 -18 0 -1509 0 -1509 -1680 0 -1680 0 0 2035 0 2035
  1319 0 1319 0 5 -147z"/>
  <path d="M3896 4794 c-11 -10 -16 -34 -16 -73 l0 -57 -54 -23 c-199 -82 -260
  -326 -121 -489 44 -51 143 -102 199 -102 134 0 226 -81 226 -200 0 -111 -79
  -190 -190 -190 -114 0 -185 71 -202 200 -2 14 -14 31 -29 39 -24 13 -29 13
  -53 -2 -32 -21 -35 -68 -9 -148 24 -74 108 -160 181 -185 l52 -19 0 -57 c0
  -45 5 -63 20 -78 46 -46 87 -13 92 74 l3 58 48 18 c96 37 162 110 192 214 41
  140 -35 297 -171 358 -24 10 -78 23 -118 27 -115 13 -172 57 -197 154 -40 146
  123 284 264 223 63 -27 117 -103 117 -164 0 -41 26 -72 60 -72 62 0 74 74 29
  178 -35 82 -112 151 -191 172 l-38 11 0 62 c0 36 -5 68 -12 75 -17 17 -64 15
  -82 -4z"/>
  <path d="M919 3846 c-15 -7 -25 -22 -27 -38 -2 -15 31 -131 72 -258 42 -127
  76 -241 75 -253 0 -12 -30 -114 -67 -227 l-68 -205 -101 -5 c-91 -4 -104 -8
  -128 -30 -78 -73 -70 -183 17 -234 41 -25 201 -22 243 4 43 26 65 75 65 142 0
  37 17 102 53 213 l53 159 52 -161 c35 -109 52 -178 52 -213 0 -65 23 -114 65
  -140 47 -29 203 -29 250 0 62 38 83 126 45 187 -33 54 -64 67 -169 73 l-96 5
  -69 218 -70 217 74 228 c81 249 89 299 51 318 -51 26 -62 10 -126 -180 l-59
  -177 -61 177 c-64 190 -75 206 -126 180z m-29 -1110 c0 -39 -11 -46 -75 -46
  -70 0 -98 17 -75 45 17 21 150 22 150 1z m580 -1 c25 -30 4 -45 -63 -45 -65 0
  -87 10 -87 42 0 16 9 18 69 18 48 0 72 -4 81 -15z"/>
  <path d="M1696 3564 c-20 -20 -20 -58 0 -78 14 -14 81 -16 589 -16 l575 0 17
  26 c15 24 15 29 2 53 l-15 26 -576 3 c-514 2 -578 0 -592 -14z"/>
  <path d="M1696 3074 c-9 -8 -16 -26 -16 -39 0 -58 -45 -55 874 -55 641 0 845
  3 854 12 20 20 15 76 -7 88 -13 7 -298 10 -855 10 -745 0 -836 -2 -850 -16z"/>
  <path d="M1866 2584 c-19 -18 -21 -65 -4 -82 17 -17 1529 -17 1546 0 17 17 15
  64 -4 82 -14 14 -97 16 -769 16 -672 0 -755 -2 -769 -16z"/>
  <path d="M986 2524 c-19 -18 -21 -65 -4 -82 19 -19 183 -16 202 4 21 21 20 57
  -2 77 -26 24 -173 24 -196 1z"/>
  <path d="M662 2094 c-25 -17 -29 -51 -8 -80 14 -19 41 -19 1363 -21 1070 -2
  1353 0 1373 10 31 16 39 61 14 88 -17 19 -51 19 -1368 19 -1207 0 -1354 -2
  -1374 -16z"/>
  <path d="M660 1600 c-11 -11 -20 -29 -20 -40 0 -11 9 -29 20 -40 20 -20 33
  -20 1368 -20 1485 0 1392 -4 1392 60 0 64 93 60 -1392 60 -1335 0 -1348 0
  -1368 -20z"/>
  <path d="M680 1123 c-43 -15 -53 -73 -18 -97 20 -14 167 -16 1374 -16 1317 0
  1351 0 1368 19 25 27 17 72 -14 88 -20 10 -306 13 -1360 12 -734 0 -1342 -3
  -1350 -6z"/>
  <path d="M656 614 c-21 -21 -20 -57 2 -77 17 -16 127 -17 1375 -17 1219 0
  1357 2 1371 16 19 18 21 65 4 82 -9 9 -328 12 -1374 12 -1225 0 -1364 -2
  -1378 -16z"/>
  </g>
  </svg>

);

export const IconInventory = ({fill}) => (
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
  width="30px" height="30px" viewBox="0 0 512.000000 512.000000"
  preserveAspectRatio="xMidYMid meet">

    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
    fill={fill ?? "#000000"} stroke="none">
    <path d="M1267 4873 c-4 -3 -7 -62 -7 -130 l0 -123 -137 0 c-167 0 -207 -14
    -251 -88 l-27 -47 0 -1865 c0 -1810 1 -1866 19 -1914 25 -66 84 -128 149 -157
    l52 -24 880 -5 880 -5 283 -137 c156 -76 292 -138 303 -138 17 0 200 91 677
    337 l182 94 0 489 c0 380 -3 491 -12 497 -7 4 -157 58 -333 119 l-320 111 -5
    1299 -5 1299 -27 47 c-44 74 -84 88 -251 88 l-136 0 -3 128 -3 127 -26 3 c-34
    4 -39 -13 -39 -150 l0 -108 -275 0 -274 0 -3 128 -3 127 -25 0 -25 0 -3 -127
    -3 -128 -279 0 -279 0 -3 128 -3 127 -25 0 -25 0 -3 -127 -3 -128 -274 0 -275
    0 0 108 c0 131 -5 152 -34 152 -13 0 -26 -3 -29 -7z m-7 -388 l0 -74 -35 -17
    c-78 -36 -110 -145 -63 -213 38 -57 73 -76 133 -76 60 0 95 19 133 76 47 68
    10 186 -67 219 -31 12 -31 13 -31 86 l0 74 275 0 275 0 0 -72 0 -73 -37 -20
    c-107 -57 -112 -194 -10 -269 43 -32 124 -28 170 6 39 30 67 83 67 125 -1 51
    -35 110 -79 135 l-41 23 0 73 0 72 275 0 275 0 0 -72 0 -73 -37 -20 c-54 -29
    -83 -77 -83 -138 0 -64 28 -109 84 -136 54 -27 81 -26 136 2 60 29 95 96 85
    158 -8 48 -62 114 -101 123 -24 6 -25 9 -22 79 l3 72 278 3 277 2 0 -74 c0
    -72 0 -74 -30 -86 -80 -33 -116 -125 -81 -204 49 -111 201 -126 267 -26 55 83
    15 206 -77 235 -16 6 -19 16 -19 81 l0 74 125 0 c136 0 180 -11 209 -51 15
    -21 16 -137 16 -1310 l0 -1287 -59 20 -58 20 -444 -147 c-244 -80 -449 -151
    -456 -157 -10 -8 -13 -113 -13 -495 l0 -484 82 -39 82 -40 -785 0 c-526 0
    -797 4 -823 11 -50 14 -118 82 -134 135 -18 61 -17 3718 1 3754 7 13 28 35 46
    47 31 21 45 23 162 23 l129 0 0 -75z m79 -150 c83 -42 50 -165 -44 -165 -93 0
    -127 121 -46 165 34 18 55 18 90 0z m630 -11 c64 -54 27 -154 -56 -154 -125 1
    -122 176 4 179 12 1 35 -11 52 -25z m622 -3 c60 -61 24 -151 -61 -151 -54 0
    -90 34 -90 85 0 48 45 95 90 95 22 0 41 -9 61 -29z m627 -6 c24 -29 28 -65 10
    -98 -18 -34 -39 -46 -81 -47 -84 0 -120 100 -55 155 26 22 39 26 67 21 21 -3
    45 -16 59 -31z m265 -2454 c31 -11 64 -24 73 -29 11 -6 -85 -47 -355 -151
    l-371 -143 -92 38 c-51 21 -97 41 -101 44 -9 7 734 257 769 259 11 1 46 -8 77
    -18z m268 -92 c35 -12 67 -25 71 -28 4 -4 -160 -75 -364 -157 l-372 -151 -68
    28 c-37 15 -74 31 -82 36 -11 6 19 21 102 52 64 23 126 47 137 52 53 25 482
    188 496 188 8 1 44 -9 80 -20z m280 -98 c46 -16 92 -32 102 -36 13 -6 -84 -53
    -352 -172 l-370 -165 -117 48 c-83 34 -113 51 -103 57 30 19 715 295 735 296
    11 0 58 -12 105 -28z m-1306 -159 l70 -29 3 -171 2 -172 144 -72 c123 -61 147
    -70 160 -59 13 11 16 40 16 176 l0 163 128 -52 127 -53 3 -461 c1 -254 1 -462
    -1 -462 -2 0 -145 68 -318 151 -173 83 -356 171 -406 194 l-93 44 0 435 0 436
    48 -19 c26 -11 79 -33 117 -49z m1483 -369 l-3 -436 -380 -194 c-208 -106
    -381 -193 -382 -193 -2 0 -2 207 -1 461 l3 461 375 168 c206 93 378 169 383
    169 4 1 6 -196 5 -436z m-1244 271 l86 -36 0 -144 0 -144 -95 47 -95 48 0 132
    c0 73 4 133 9 133 5 0 48 -16 95 -36z"/>
    <path d="M1286 3729 l-26 -20 0 -325 c0 -311 1 -325 20 -344 19 -19 33 -20
    344 -20 l325 0 20 26 c20 26 21 38 21 341 l0 314 -25 24 -24 25 -314 0 c-303
    0 -315 -1 -341 -21z m634 -349 l0 -300 -193 0 c-107 0 -242 3 -300 7 l-107 6
    0 202 c0 111 3 243 6 293 l7 92 293 0 294 0 0 -300z"/>
    <path d="M1683 3430 c-67 -60 -126 -110 -131 -110 -4 0 -29 29 -55 65 -47 66
    -78 82 -91 48 -10 -25 111 -203 138 -203 12 0 254 211 288 251 13 16 15 25 8
    40 -6 10 -16 19 -23 19 -7 0 -67 -49 -134 -110z"/>
    <path d="M2294 3665 c-4 -8 -4 -22 0 -30 5 -13 60 -15 443 -13 l438 3 0 25 0
    25 -438 3 c-383 2 -438 0 -443 -13z"/>
    <path d="M2302 3408 c-17 -17 -15 -45 4 -52 20 -8 838 -8 858 0 19 7 21 35 4
    52 -17 17 -849 17 -866 0z"/>
    <path d="M2294 3135 c-4 -8 -4 -22 0 -30 5 -13 60 -15 443 -13 l438 3 0 25 0
    25 -438 3 c-383 2 -438 0 -443 -13z"/>
    <path d="M1276 2708 c-24 -34 -24 -642 0 -676 15 -22 15 -22 345 -22 316 0
    330 1 349 20 19 19 20 33 20 338 0 271 -2 321 -16 340 -15 22 -15 22 -349 22
    -334 0 -334 0 -349 -22z m644 -338 l0 -300 -297 2 -298 3 -3 165 c-2 91 0 225
    3 298 l7 132 294 0 294 0 0 -300z"/>
    <path d="M1675 2410 c-66 -60 -122 -109 -125 -109 -3 0 -27 31 -53 70 -49 71
    -69 81 -90 48 -8 -13 3 -36 54 -108 41 -58 71 -91 83 -91 27 0 309 259 302
    277 -3 8 -6 17 -6 19 0 2 -10 4 -22 4 -15 -1 -67 -41 -143 -110z"/>
    <path d="M2303 2663 c-18 -7 -16 -50 3 -57 20 -8 838 -8 858 0 19 7 21 35 4
    52 -9 9 -118 12 -433 11 -231 0 -426 -3 -432 -6z"/>
    <path d="M2294 2385 c-4 -8 -4 -22 0 -30 5 -13 60 -15 443 -13 l438 3 0 25 0
    25 -438 3 c-383 2 -438 0 -443 -13z"/>
    <path d="M2303 2133 c-18 -7 -16 -50 3 -57 28 -11 834 -7 855 4 23 13 25 46 3
    54 -19 7 -843 7 -861 -1z"/>
    <path d="M1280 1700 c-19 -19 -20 -33 -20 -344 l0 -325 26 -20 c26 -20 38 -21
    341 -21 l314 0 24 25 25 24 0 314 c0 303 -1 315 -21 341 l-20 26 -325 0 c-311
    0 -325 -1 -344 -20z m618 -46 l22 -6 0 -294 0 -294 -300 0 -300 0 0 203 c0
    111 3 246 7 300 l6 97 271 0 c149 0 281 -3 294 -6z"/>
    <path d="M1679 1400 c-68 -60 -126 -110 -129 -110 -4 0 -27 29 -51 65 -32 48
    -50 65 -67 65 -40 0 -36 -27 14 -101 70 -103 90 -122 111 -110 25 14 276 240
    286 258 10 16 -8 43 -28 43 -7 0 -68 -49 -136 -110z"/>
    </g>
  </svg>

);

export const IconConsultNoteEntry = ({fill}) => (
  <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="20" height="20" viewBox="0 0 512.000000 512.000000">
    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#03134F" stroke="none">
      <path d="M1504 4679 c-49 -14 -125 -69 -161 -117 -67 -88 -63 17 -63 -1714 l0 -1568 668 1 c630 1 664 2 612 17 -77 22 -159 104 -190 189 l-22 62 -33 -25 c-18 -14 -49 -27 -68 -31 -28 -4 -40 0 -69 25 -19 17 -43 49 -53 71 l-18 41 -68 -65 c-80 -75 -91 -78 -252 -73 -99 3 -120 6 -144 24 -55 41 -55 127 0 168 24 17 46 22 130 24 l102 4 96 93 c52 52 108 99 125 105 61 24 121 -11 153 -89 8 -17 16 -31 20 -31 4 0 29 23 56 51 28 28 68 60 90 70 39 18 41 21 114 206 l74 188 618 620 619 620 0 436 c0 253 4 459 10 490 9 44 29 94 88 212 5 10 -2397 7 -2434 -4z m1856 -534 c37 -19 50 -43 50 -95 0 -33 -6 -48 -29 -71 l-29 -29 -792 0 -792 0 -29 29 c-47 47 -37 129 19 164 25 15 98 16 800 17 670 0 777 -2 802 -15z m0 -640 c37 -19 50 -43 50 -95 0 -33 -6 -48 -29 -71 l-29 -29 -792 0 -792 0 -29 29 c-47 48 -36 135 22 167 19 11 175 13 797 14 670 0 777 -2 802 -15z m-640 -640 c37 -19 50 -43 50 -95 0 -33 -6 -48 -29 -71 l-29 -29 -472 0 -472 0 -29 29 c-47 48 -36 135 22 167 19 10 120 13 477 14 385 0 457 -2 482 -15z" fill={fill ?? "#03134F"}>
      </path>
      <path d="M4253 4669 c-67 -26 -137 -94 -171 -167 -26 -56 -27 -61 -27 -252 l0 -195 318 -3 318 -2 -3 207 c-3 196 -4 211 -27 253 -32 62 -86 117 -146 148 -70 36 -188 41 -262 11z" fill={fill ?? "#03134F"}>
      </path>
      <path d="M4405 3736 c-27 -7 -66 -20 -85 -30 -19 -10 -371 -354 -782 -764 l-748 -747 -115 -287 c-63 -159 -115 -297 -115 -309 0 -49 57 -109 104 -109 9 0 145 52 304 115 l288 115 750 753 c822 823 792 789 802 918 17 219 -193 399 -403 345z" fill={fill ?? "#03134F"}>
      </path>
      <path d="M3610 1775 c-201 -201 -233 -230 -296 -260 -105 -50 -379 -160 -496 -200 l-102 -34 212 -3 212 -3 27 -28 28 -27 5 -278 5 -277 28 -57 c31 -62 84 -116 149 -149 52 -27 164 -36 225 -20 56 15 131 67 170 119 64 84 63 79 61 795 l-3 647 -225 -225z" fill={fill ?? "#03134F"}>
      </path>
      <path d="M432 863 c3 -203 4 -209 30 -258 32 -60 87 -114 148 -146 l45 -24 1218 -3 1217 -2 -23 37 c-13 21 -35 65 -48 98 -21 55 -24 79 -29 280 l-5 220 -1278 3 -1278 2 3 -207z" fill={fill ?? "#03134F"}>
      </path>
    </g>
  </svg>
);

export const IconCalendar = ({fill}) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="data">
    <g id="Group 3465035">
      <path id="Union" fillRule="evenodd" clipRule="evenodd" d="M6.85508 3.19439C6.85508 2.50239 6.2941 1.94141 5.6021 1.94141C4.91009 1.94141 4.34911 2.50239 4.34911 3.19439L4.34911 3.80641C4.34911 3.93328 4.36796 4.05575 4.40303 4.17116C3.68228 4.61126 3.20117 5.40519 3.20117 6.31149L3.20117 11.0881C3.20117 12.4721 4.32313 13.594 5.70714 13.594L10.2952 13.594C11.6792 13.594 12.8012 12.4721 12.8012 11.0881L12.8012 6.31149C12.8012 5.40585 12.3208 4.61241 11.6009 4.17212C11.6361 4.05643 11.6551 3.93364 11.6551 3.80642L11.6551 3.19439C11.6551 2.50239 11.0941 1.94141 10.4021 1.94141C9.71009 1.94141 9.14911 2.50239 9.14911 3.19439L9.14911 3.80552L6.85508 3.80552L6.85508 3.19439ZM4.10176 6.55621L11.9018 6.55621L11.9018 11.4211C11.9018 12.1131 11.3408 12.674 10.6488 12.674L5.35474 12.674C4.66274 12.674 4.10175 12.1131 4.10176 11.4211L4.10176 6.55621Z" fill={fill ?? lightTheme.backgrounds.red2}/>
      <rect id="Rectangle 3467636" x="5.05859" y="7.47656" width="2.47742" height="2.44713" rx="1.22357" fill={fill ?? lightTheme.backgrounds.red2}/>
    </g>
    </g>
  </svg>
);

export const IconFreight = ({fill}) => (
  <svg enableBackground="new 0 0 48 48" height="20px" id="Layer_4" version="1.1" viewBox="0 0 48 48" width="20px" xmlns="http://www.w3.org/2000/svg"><path d="M42.996,19c0-10.494-8.507-19-19-19c-10.494,0-19,8.506-19,19C4.996,19.029,5,19.059,5,19.088  c-0.008,0.213-0.017,0.841,0.092,1.827c0.003,0.034,0.009,0.068,0.013,0.103c0.047,0.404,0.116,0.865,0.21,1.376  c0.053,0.291,0.111,0.579,0.177,0.864c1.188,5.314,5.187,14.91,18.5,24.732c0.001,0.004,0.002,0.006,0.003,0.01  c0.001-0.002,0.003-0.002,0.005-0.004c0.001,0.002,0.003,0.002,0.004,0.004c0.001-0.004,0.002-0.006,0.003-0.01  c13.494-9.957,17.418-19.678,18.546-24.945c0.028-0.133,0.058-0.266,0.083-0.4C43.088,20.351,42.996,19,42.996,19z M25.371,28.115  v3.105h-2.985v-2.893c-2.041-0.09-4.021-0.641-5.179-1.311l0.915-3.563c1.279,0.699,3.076,1.339,5.056,1.339  c1.739,0,2.926-0.67,2.926-1.888c0-1.158-0.976-1.889-3.229-2.65c-3.262-1.097-5.483-2.619-5.483-5.574  c0-2.682,1.886-4.783,5.146-5.423V6.365h2.985v2.679c2.043,0.093,3.415,0.52,4.417,1.006l-0.884,3.442  c-0.789-0.336-2.188-1.037-4.384-1.037c-1.982,0-2.623,0.854-2.623,1.707c0,1.004,1.067,1.646,3.657,2.62  c3.626,1.28,5.087,2.955,5.087,5.698C30.793,25.191,28.875,27.504,25.371,28.115z"/></svg>
);

export const IconComplement = ({fill}) => (
  <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path id="Subtract" fillRule="evenodd" clipRule="evenodd" d="M1.77778 0H14.2222C15.2 0 16 0.8 16 1.77778V14.2222C16 15.2 15.2 16 14.2222 16H1.77778C0.799999 16 0 15.2 0 14.2222V1.77778C0 0.8 0.799999 0 1.77778 0ZM6.89347 10.9922C6.89347 11.5215 7.3226 11.9506 7.85195 11.9506C8.3813 11.9506 8.81042 11.5215 8.81042 10.9922V9.01026H10.7923C11.2684 9.01026 11.6544 8.62428 11.6544 8.14816C11.6544 7.67204 11.2684 7.28606 10.7923 7.28606H8.81042V5.30416C8.81042 4.77481 8.3813 4.34569 7.85195 4.34569C7.3226 4.34569 6.89347 4.77481 6.89347 5.30416V7.28606H4.91158C4.43545 7.28606 4.04948 7.67204 4.04948 8.14816C4.04948 8.62428 4.43545 9.01026 4.91158 9.01026H6.89347V10.9922Z" fill={fill ?? "#03134F"}/>
  </svg>
);

export const IconDashboardDelivery = ({fillBottom, stroke}) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="8" fill={fillBottom}/>
    <path d="M7.77177 17.2526C7.77177 12.709 11.4551 9.02568 15.9987 9.02568C20.5423 9.02568 24.2256 12.709 24.2256 17.2526C24.2256 19.4984 23.3268 21.533 21.867 23.0185H10.1304C8.67058 21.533 7.77177 19.4984 7.77177 17.2526Z" stroke={stroke} strokeWidth="1.87948"/>
    <path d="M23.498 13.0898H16.2679C14.785 13.0898 13.5623 14.3955 14.0304 15.8026C15.151 19.1716 17.9451 20.2893 24.3314 20.5898" stroke={stroke} strokeWidth="1.87948"/>
  </svg>
);

export const IconDashboardWithdraw = ({fillBottom, stroke}) => (
  <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.25" width="32" height="32" rx="8" fill={fillBottom}/>
    <path d="M8.9707 16.8555V22.054C8.9707 23.438 10.0927 24.56 11.4767 24.56H21.0177C22.4018 24.56 23.5237 23.438 23.5237 22.054V16.8555" stroke={stroke} strokeWidth="1.87948" strokeLinecap="round"/>
    <path d="M16.2487 16.418C14.5989 16.418 13.733 14.8501 13.444 14.1977C13.3988 14.0956 13.2418 14.0847 13.184 14.1802C12.7961 14.8216 11.6635 16.418 9.9987 16.418C8.2708 16.418 7.40276 14.6982 7.15687 14.1114C7.10448 13.9864 7.1052 13.8485 7.14807 13.7199L9.13681 7.75364C9.15386 7.70248 9.20174 7.66797 9.25567 7.66797H23.2417C23.2957 7.66797 23.3435 7.70248 23.3606 7.75364L25.3493 13.7199C25.3922 13.8485 25.3929 13.9864 25.3405 14.1114C25.0946 14.6982 24.2266 16.418 22.4987 16.418C20.8339 16.418 19.7013 14.8216 19.3134 14.1802C19.2556 14.0847 19.0986 14.0956 19.0534 14.1977C18.7644 14.8501 17.8985 16.418 16.2487 16.418Z" stroke={stroke} strokeWidth="1.87948"/>
  </svg>
);

export const IconDashboardMakingDelivery = ({fillBottom, stroke}) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="8" fill={fillBottom}/>
    <path d="M7.77177 19.4709C7.77177 15.7711 10.7711 12.7718 14.4709 12.7718C18.1708 12.7718 21.1701 15.7711 21.1701 19.4709C21.1701 21.2762 20.457 22.9137 19.295 24.1192H9.64681C8.48479 22.9137 7.77177 21.2762 7.77177 19.4709Z" stroke={stroke} strokeWidth="1.87948"/>
    <path d="M20.7201 15.9961H15.1566C13.6737 15.9961 12.4219 17.3214 12.992 18.6903C14.0212 21.1617 16.3766 22.009 21.4145 22.2461" stroke={stroke} strokeWidth="1.87948"/>
    <path d="M19.334 9.75H25.1673" stroke={stroke} strokeWidth="1.87948" strokeLinecap="round"/>
    <path d="M22.252 12.6641L22.252 6.83073" stroke={stroke} strokeWidth="1.87948" strokeLinecap="round"/>
  </svg>
);

export const IconDashboardMenu = ({fillBottom, fill}) => (
  <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" width="32" height="32" rx="8" fill={fillBottom}/>
    <path d="M22.0008 8.89852V7.79852C22.0008 7.19852 21.7008 6.69852 21.3008 6.39852C20.8008 5.99852 20.2008 5.99852 19.6008 6.09852L11.3008 8.99852C10.6008 9.19852 10.2008 9.79852 10.2008 10.5985V11.2985H10.0008C9.10078 11.2985 8.30078 11.9985 8.30078 12.9985C8.30078 13.8985 9.10078 14.6985 10.0008 14.6985H10.2008V15.6985H10.0008C9.10078 15.6985 8.30078 16.4985 8.30078 17.3985C8.30078 18.2985 9.10078 19.0985 10.0008 19.0985H10.2008V20.0985H10.0008C9.10078 20.0985 8.30078 20.8985 8.30078 21.7985C8.30078 22.6985 9.10078 23.4985 10.0008 23.4985H10.2008V24.1985C10.2008 25.1985 11.0008 25.9985 12.0008 25.9985H21.5008C23.0008 25.9985 24.3008 24.7985 24.3008 23.1985V11.5985C24.2008 10.1985 23.2008 9.09852 22.0008 8.89852ZM10.2008 22.4985H10.0008C9.60078 22.4985 9.30078 22.1985 9.30078 21.7985C9.30078 21.3985 9.60078 21.0985 10.0008 21.0985H10.2008V22.4985ZM10.2008 18.0985H10.0008C9.60078 18.0985 9.30078 17.7985 9.30078 17.3985C9.30078 16.9985 9.60078 16.6985 10.0008 16.6985H10.2008V18.0985ZM10.2008 13.6985H10.0008C9.60078 13.6985 9.30078 13.3985 9.30078 12.9985C9.30078 12.5985 9.60078 12.2985 10.0008 12.2985H10.2008V13.6985ZM20.1008 7.59852C20.2008 7.59852 20.3008 7.59852 20.3008 7.59852C20.3008 7.59852 20.4008 7.69852 20.4008 7.79852V8.79852H16.4008L20.1008 7.59852ZM11.7008 12.2985H11.9008C12.3008 12.2985 12.6008 12.5985 12.6008 12.9985C12.6008 13.3985 12.3008 13.6985 11.9008 13.6985H11.7008V12.2985ZM11.7008 16.6985H11.9008C12.3008 16.6985 12.6008 16.9985 12.6008 17.3985C12.6008 17.7985 12.3008 18.0985 11.9008 18.0985H11.7008V16.6985ZM11.7008 21.0985H11.9008C12.3008 21.0985 12.6008 21.3985 12.6008 21.7985C12.6008 22.1985 12.3008 22.4985 11.9008 22.4985H11.7008V21.0985ZM22.7008 23.1985C22.7008 23.8985 22.1008 24.4985 21.4008 24.4985H11.9008C11.8008 24.4985 11.6008 24.3985 11.6008 24.1985V23.4985H11.8008C12.7008 23.4985 13.5008 22.6985 13.5008 21.7985C13.5008 20.8985 12.7008 20.0985 11.8008 20.0985H11.7008V19.0985H11.9008C12.8008 19.0985 13.6008 18.2985 13.6008 17.3985C13.6008 16.4985 12.8008 15.6985 11.9008 15.6985H11.7008V14.6985H11.9008C12.8008 14.6985 13.6008 13.8985 13.6008 12.9985C13.6008 12.0985 12.8008 11.2985 11.9008 11.2985H11.7008V10.5985C11.7008 10.4985 11.8008 10.2985 12.0008 10.2985H21.5008C22.2008 10.2985 22.8008 10.8985 22.8008 11.5985V23.1985H22.7008Z" fill={fill}/>
    <path d="M16.0004 13.6016C15.1004 13.6016 14.4004 14.4016 14.4004 15.5016C14.4004 16.4016 14.9004 17.1016 15.6004 17.3016V20.9016C15.6004 21.1016 15.8004 21.3016 16.0004 21.3016C16.2004 21.3016 16.4004 21.1016 16.4004 20.9016V17.3016C17.1004 17.0016 17.5004 16.3016 17.5004 15.5016C17.5004 14.4016 16.8004 13.6016 16.0004 13.6016ZM16.0004 16.6016C15.6004 16.6016 15.2004 16.1016 15.2004 15.5016C15.2004 14.9016 15.5004 14.4016 16.0004 14.4016C16.5004 14.4016 16.8004 14.9016 16.8004 15.5016C16.8004 16.1016 16.4004 16.6016 16.0004 16.6016Z" fill={fill}/>
    <path d="M20.9992 13.6016C20.7992 13.6016 20.5992 13.8016 20.5992 14.0016V15.8016C20.5992 16.2016 20.1992 16.6016 19.7992 16.6016C19.3992 16.6016 18.9992 16.3016 18.9992 15.8016V14.0016C18.9992 13.8016 18.7992 13.6016 18.5992 13.6016C18.3992 13.6016 18.1992 13.8016 18.1992 14.0016V15.8016C18.1992 16.5016 18.6992 17.1016 19.3992 17.3016V20.9016C19.3992 21.1016 19.5992 21.3016 19.7992 21.3016C19.9992 21.3016 20.1992 21.1016 20.1992 20.9016V17.3016C20.8992 17.1016 21.3992 16.5016 21.3992 15.8016V14.0016C21.3992 13.8016 21.2992 13.6016 20.9992 13.6016Z" fill={fill}/>
    <path d="M19.8023 15.9016C20.0023 15.9016 20.2023 15.7016 20.2023 15.5016V14.0016C20.2023 13.8016 20.0023 13.6016 19.8023 13.6016C19.6023 13.6016 19.4023 13.8016 19.4023 14.0016V15.5016C19.4023 15.7016 19.6023 15.9016 19.8023 15.9016Z" fill={fill}/>
  </svg>
);

export const IconTransfer = ({stroke}) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.15316 12.2023C12.1037 12.2023 15.3063 11.0377 15.3063 9.60115C15.3063 8.16457 12.1037 7 8.15316 7C4.20258 7 1 8.16457 1 9.60115C1 11.0377 4.20258 12.2023 8.15316 12.2023Z" stroke={stroke} strokeWidth="1.5" strokeMiterlimit="10"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M8.90385 12.5106V11.7606H7.40385V12.5106V15.3451C5.86451 15.6261 4.58594 16.7543 4.58594 18.2755V18.4485C4.58594 18.8627 4.92172 19.1985 5.33594 19.1985C5.75015 19.1985 6.08594 18.8627 6.08594 18.4485V18.2755C6.08594 17.7541 6.55004 17.1182 7.40385 16.8767V18.2179C7.40385 18.6321 7.73964 18.9679 8.15385 18.9679C8.56807 18.9679 8.90385 18.6321 8.90385 18.2179V16.8659C9.84706 17.103 10.3663 17.7757 10.3663 18.3908V18.4485C10.3663 18.8627 10.7021 19.1985 11.1163 19.1985C11.5305 19.1985 11.8663 18.8627 11.8663 18.4485V18.3908C11.8663 16.7521 10.5096 15.6136 8.90385 15.3405V12.5106Z" fill={stroke}/>
    <path d="M14 3.5H19" stroke={stroke} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M16.5 6L16.5 1" stroke={stroke} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export const IconPayment = ({fill}) => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.5744 17.1849C9.51982 17.1849 8.62285 17.0152 7.88345 16.6758C7.14406 16.3242 6.58042 15.8333 6.19254 15.203C5.95203 14.7918 5.78849 14.336 5.70193 13.8354C5.61808 13.3505 6.02778 12.9485 6.51982 12.9485C7.01185 12.9485 7.40255 13.3568 7.5617 13.8224C7.60076 13.9367 7.64741 14.0514 7.70163 14.1667C7.89557 14.5667 8.22285 14.9061 8.68345 15.1849C9.15618 15.4515 9.78648 15.5849 10.5744 15.5849C11.6289 15.5849 12.4168 15.3667 12.938 14.9303C13.4592 14.4818 13.7198 13.9667 13.7198 13.3849C13.7198 12.8273 13.4895 12.3667 13.0289 12.003C12.5683 11.6273 11.8895 11.397 10.9925 11.3121L9.84709 11.203C8.65921 11.0939 7.71375 10.7364 7.01072 10.1303C6.30769 9.52425 5.95618 8.66364 5.95618 7.54849C5.95618 6.77273 6.14406 6.11819 6.51982 5.58486C6.89557 5.0394 7.41678 4.62122 8.08345 4.33031C8.76224 4.0394 9.56224 3.89395 10.4835 3.89395C11.4168 3.89395 12.2168 4.05758 12.8835 4.38486C13.5501 4.70001 14.0653 5.16667 14.4289 5.78486C14.6622 6.17365 14.8206 6.61731 14.9043 7.11584C14.9857 7.60109 14.5755 8.00304 14.0835 8.00304C13.5914 8.00304 13.2086 7.59262 13.0434 7.12915C13.004 7.01849 12.9567 6.90978 12.9016 6.80304C12.7198 6.41516 12.4289 6.10001 12.0289 5.85758C11.641 5.61516 11.1259 5.49395 10.4835 5.49395C9.91375 5.49395 9.42891 5.58486 9.02891 5.76667C8.62891 5.94849 8.31982 6.19698 8.10163 6.51213C7.88345 6.81516 7.77436 7.16061 7.77436 7.54849C7.77436 8.05758 7.95618 8.50001 8.31982 8.87576C8.68345 9.2394 9.24103 9.45758 9.99254 9.53031L11.1562 9.62122C12.4774 9.74243 13.5319 10.1242 14.3198 10.7667C15.1198 11.4091 15.5198 12.2818 15.5198 13.3849C15.5198 14.1485 15.3198 14.8152 14.9198 15.3849C14.5198 15.9546 13.9501 16.397 13.2107 16.7121C12.4835 17.0273 11.6047 17.1849 10.5744 17.1849ZM10.5744 19.5121C10.1125 19.5121 9.738 19.1377 9.738 18.6758V16.8576H11.4107V18.6758C11.4107 19.1377 11.0363 19.5121 10.5744 19.5121ZM9.66527 4.78485V2.96667C9.66527 2.50476 10.0397 2.13031 10.5016 2.13031C10.9635 2.13031 11.338 2.50476 11.338 2.96667V4.78485H9.66527Z" fill={fill}/>
  </svg>
);

export const IconSangriaAndSupply = ({fill}) => (
  <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="20" height="20" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">
    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill={fill} stroke="none">
    <path d="M4325 5105 c-20 -11 -144 -169 -362 -461 -302 -403 -333 -448 -333 -483 0 -49 30 -87 78 -101 20 -5 106 -10 190 -10 l153 0 -4 -852 c-4 -940 0 -881 -69 -1098 -74 -231 -184 -407 -367 -590 -219 -219 -448 -344 -749 -411 -90 -21 -133 -23 -595 -28 l-499 -6 -29 -33 -29 -32 0 -253 c0 -272 1 -277 57 -306 35 -18 885 -15 1048 4 319 37 630 150 898 324 153 100 236 168 362 295 306 311 502 687 587 1131 21 106 22 143 25 983 l4 872 157 0 c185 0 225 9 253 53 40 65 39 68 -318 543 -181 241 -337 445 -345 452 -26 21 -80 24 -113 7z"/>
    <path d="M2245 4670 c-224 -35 -412 -94 -620 -195 -222 -108 -387 -226 -571 -409 -295 -295 -491 -653 -578 -1056 -43 -202 -46 -268 -46 -1125 l0 -815 -174 0 c-163 0 -175 -1 -207 -23 -40 -27 -58 -76 -42 -116 5 -15 159 -226 342 -469 232 -310 340 -446 359 -453 40 -15 85 -3 119 34 17 17 173 222 347 455 291 388 316 426 316 462 0 30 -7 48 -29 72 l-29 33 -181 3 -181 3 0 814 c0 760 1 820 19 927 71 412 309 773 661 1001 151 97 300 161 480 205 103 25 112 25 605 31 374 5 506 9 522 19 51 29 53 38 53 310 l0 254 -29 29 -29 29 -494 -1 c-426 -1 -509 -3 -613 -19z"/>
    <path d="M2360 3825 c-132 -22 -235 -55 -356 -114 -365 -178 -613 -498 -700 -903 -26 -117 -25 -380 0 -498 55 -257 169 -466 355 -651 149 -150 297 -243 486 -307 459 -156 948 -47 1299 288 410 392 512 996 253 1504 -189 372 -540 622 -964 685 -94 14 -278 12 -373 -4z m246 -530 c42 -17 64 -62 65 -132 l0 -48 82 -40 c97 -48 132 -89 123 -145 -3 -22 -17 -46 -36 -62 -41 -38 -88 -37 -150 1 -64 40 -135 63 -168 55 -37 -9 -80 -51 -87 -85 -4 -16 0 -39 9 -57 21 -42 87 -98 132 -112 130 -42 238 -131 290 -237 38 -75 40 -182 7 -255 -29 -64 -105 -143 -158 -164 -42 -18 -43 -19 -48 -77 -7 -81 -40 -117 -107 -117 -38 0 -51 5 -75 30 -25 26 -30 40 -33 95 l-4 64 -40 16 c-22 8 -64 31 -93 50 -42 27 -56 42 -65 73 -32 105 78 176 172 110 88 -62 177 -74 226 -33 82 69 26 173 -127 236 -42 17 -92 41 -111 54 -57 37 -126 113 -156 174 -40 77 -41 180 -3 261 32 68 91 129 152 159 44 21 47 25 47 62 0 58 22 103 61 122 42 20 51 21 95 2z"/>
    </g>
  </svg>
);

export const IconGoBack = ({fill}) => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.5925 6.09401V4.50401C7.5925 3.61401 6.5125 3.16401 5.8825 3.79401L1.2925 8.38401C0.9025 8.77401 0.9025 9.40401 1.2925 9.79401L5.8825 14.384C6.5125 15.014 7.5925 14.574 7.5925 13.684V11.994C12.5925 11.994 16.0925 13.594 18.5925 17.094C17.5925 12.094 14.5925 7.09401 7.5925 6.09401Z" fill={fill}/>
  </svg>
);

export const IconPrinter = ({fill, width, height}) => (
  <svg width={width ?? '21'} height={height ?? '20'} viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M5.30859 1H15.3086C15.8586 1 16.3086 1.45 16.3086 2V4C16.3086 4.55 15.8586 5 15.3086 5H5.30859C4.75859 5 4.30859 4.55 4.30859 4V2C4.30859 1.45 4.75859 1 5.30859 1ZM3.30859 6H17.3086C18.9686 6 20.3086 7.34 20.3086 9V13C20.3086 14.1 19.4086 15 18.3086 15H16.3086V17C16.3086 18.1 15.4086 19 14.3086 19H6.30859C5.20859 19 4.30859 18.1 4.30859 17V15H2.30859C1.20859 15 0.308594 14.1 0.308594 13V9C0.308594 7.34 1.64859 6 3.30859 6ZM7.3086 17H13.3086C13.8586 17 14.3086 16.55 14.3086 16V12H6.3086V16C6.3086 16.55 6.7586 17 7.3086 17ZM17.3086 9.99998C16.7586 9.99998 16.3086 9.54998 16.3086 8.99998C16.3086 8.44998 16.7586 7.99998 17.3086 7.99998C17.8586 7.99998 18.3086 8.44998 18.3086 8.99998C18.3086 9.54998 17.8586 9.99998 17.3086 9.99998Z" fill={fill}/>
  </svg>
);

export const IconGroupComplement = ({fill}) => (
  <svg width="20" height="20" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="icon/action/complemento_on">
        <path id="icon/image/filter_2_24px" d="M0.818182 3.27344C0.368182 3.27344 0 3.64162 0 4.09162V16.3644C0 17.2644 0.736364 18.0007 1.63636 18.0007H13.9091C14.3591 18.0007 14.7273 17.6325 14.7273 17.1825C14.7273 16.7325 14.3591 16.3644 13.9091 16.3644H2.45455C2.00455 16.3644 1.63636 15.9962 1.63636 15.5462V4.09162C1.63636 3.64162 1.26818 3.27344 0.818182 3.27344Z" fill={fill}/>
        <path id="Subtract" fillRule="evenodd" clipRule="evenodd" d="M4.9098 0H16.3643C17.2643 0 18.0007 0.736364 18.0007 1.63636V13.0909C18.0007 13.9909 17.2643 14.7273 16.3643 14.7273H4.9098C4.0098 14.7273 3.27344 13.9909 3.27344 13.0909V1.63636C3.27344 0.736364 4.0098 0 4.9098 0ZM9.61848 10.1178C9.61848 10.605 10.0135 11 10.5007 11C10.988 11 11.3829 10.605 11.3829 10.1178V8.29354H13.2072C13.6454 8.29354 14.0007 7.93826 14.0007 7.50001C14.0007 7.06176 13.6454 6.70649 13.2072 6.70649H11.3829V4.88224C11.3829 4.395 10.988 4.00001 10.5007 4.00001C10.0135 4.00001 9.61848 4.395 9.61848 4.88224V6.70649H7.79423C7.35598 6.70649 7.00071 7.06176 7.00071 7.50001C7.00071 7.93826 7.35598 8.29354 7.79423 8.29354H9.61848V10.1178Z" fill={fill}/>
    </g>
  </svg>
);

export const IconSection = ({fill}) => (
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
   width="25px" height="25px" viewBox="0 0 512.000000 512.000000"
   preserveAspectRatio="xMidYMid meet">
  
  <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
  fill={fill} stroke="none">
  <path d="M875 4777 c-35 -19 -49 -39 -106 -152 l-67 -130 -144 -21 c-79 -11
  -153 -26 -165 -32 -32 -17 -62 -59 -69 -97 -12 -67 3 -94 118 -211 l109 -111
  -22 -125 c-14 -77 -19 -138 -15 -161 13 -69 84 -127 157 -127 18 0 82 26 155
  62 l124 63 124 -63 c74 -37 137 -62 155 -62 73 0 144 58 157 127 4 23 -1 84
  -15 161 l-22 125 110 111 c86 88 111 119 116 148 14 76 -26 149 -93 168 -20 6
  -93 19 -161 29 l-123 17 -67 130 c-57 112 -71 132 -106 151 -22 13 -56 23 -75
  23 -19 0 -53 -10 -75 -23z m155 -257 c48 -96 78 -144 93 -150 12 -5 74 -16
  137 -25 63 -9 130 -18 149 -22 l33 -6 -118 -118 c-136 -136 -129 -113 -94
  -307 15 -82 19 -127 12 -134 -7 -7 -57 15 -151 63 l-140 73 -142 -73 c-94 -49
  -144 -70 -151 -63 -7 7 -3 51 12 134 35 194 42 171 -95 308 -66 66 -117 120
  -113 120 29 0 298 43 315 50 15 6 45 55 93 150 39 77 75 140 80 140 5 0 41
  -63 80 -140z"/>
  <path d="M4004 4777 c-28 -14 -63 -40 -76 -58 -40 -53 -499 -800 -514 -836
  -21 -48 -17 -103 11 -159 27 -54 60 -84 114 -102 24 -9 185 -12 566 -12 l533
  0 53 28 c43 22 59 38 82 82 25 47 28 63 24 108 -6 60 6 38 -325 572 -190 307
  -211 337 -255 364 -68 42 -143 46 -213 13z m149 -139 c35 -32 507 -804 507
  -828 0 -11 -9 -29 -20 -40 -19 -19 -33 -20 -540 -20 -507 0 -521 1 -540 20
  -11 11 -20 29 -20 40 0 24 472 796 507 828 13 12 37 22 53 22 16 0 40 -10 53
  -22z"/>
  <path d="M2405 4741 c-94 -27 -164 -69 -240 -146 -220 -220 -220 -560 0 -780
  114 -115 234 -165 395 -165 161 0 281 50 395 165 139 139 193 328 150 514 -47
  199 -208 366 -400 416 -78 20 -223 18 -300 -4z m336 -159 c141 -68 239 -222
  239 -377 0 -154 -98 -309 -239 -378 -63 -30 -72 -32 -181 -32 -103 0 -121 3
  -170 26 -112 52 -204 163 -236 283 -54 203 63 421 267 496 44 17 73 20 154 17
  88 -3 108 -7 166 -35z"/>
  <path d="M1217 3342 c-10 -10 -17 -32 -17 -48 0 -24 33 -62 212 -241 l213
  -213 -71 0 c-61 0 -74 -3 -92 -23 -28 -30 -28 -68 1 -95 22 -21 33 -22 189
  -22 l167 0 20 26 c19 25 21 40 21 189 0 156 -1 162 -23 183 -30 28 -68 28 -95
  -1 -18 -19 -22 -35 -22 -93 l0 -69 -213 213 c-184 184 -216 212 -243 212 -17
  0 -38 -8 -47 -18z"/>
  <path d="M2506 3338 c-14 -19 -16 -65 -16 -297 l0 -275 -53 52 c-44 44 -59 52
  -89 52 -27 0 -41 -6 -52 -22 -33 -46 -22 -65 106 -195 111 -112 125 -123 158
  -123 33 0 47 11 158 123 128 130 139 149 106 195 -11 16 -25 22 -52 22 -30 0
  -45 -8 -89 -52 l-53 -52 0 275 c0 313 -1 319 -70 319 -29 0 -43 -6 -54 -22z"/>
  <path d="M3612 3148 l-212 -213 0 66 c0 52 -5 72 -21 93 -26 33 -68 34 -97 3
  -21 -22 -22 -33 -22 -188 0 -221 -12 -209 209 -209 159 0 162 1 186 25 30 30
  31 54 4 89 -19 24 -27 26 -92 26 l-72 0 213 213 c184 184 212 216 212 243 0
  38 -27 64 -66 64 -25 0 -62 -33 -242 -212z"/>
  <path d="M882 2400 c-69 -42 -86 -110 -57 -224 23 -89 53 -130 200 -276 l135
  -135 0 -671 0 -671 23 -34 c49 -74 -57 -69 1377 -69 1204 0 1287 1 1319 18 19
  9 44 30 55 45 21 28 21 39 24 705 l2 676 143 146 c145 147 175 191 197 282 22
  97 3 164 -59 205 l-34 23 -631 0 c-608 0 -632 -1 -663 -20 -46 -28 -66 -64
  -74 -136 -12 -92 -39 -135 -165 -264 l-114 -115 -114 115 c-126 129 -152 169
  -165 265 -11 76 -28 108 -74 135 -31 19 -55 20 -662 20 -611 0 -631 -1 -663
  -20z m1265 -185 c17 -100 47 -150 152 -257 l95 -98 -570 0 -571 0 -125 128
  c-128 131 -163 180 -174 251 l-7 41 595 0 594 0 11 -65z m2019 24 c-11 -71
  -46 -120 -174 -251 l-125 -128 -570 0 -570 0 94 98 c104 106 135 160 152 260
  l11 62 594 0 595 0 -7 -41z m-1676 -1149 l0 -630 -595 0 -595 0 0 630 0 630
  595 0 595 0 0 -630z m1330 0 l0 -630 -595 0 -595 0 0 630 0 630 595 0 595 0 0
  -630z"/>
  <path d="M3282 997 c-28 -30 -28 -68 1 -95 22 -21 33 -22 186 -22 159 0 162 1
  186 25 30 30 31 54 4 89 l-20 26 -168 0 c-162 0 -168 -1 -189 -23z"/>
  <path d="M3142 717 c-28 -30 -28 -68 1 -95 23 -21 31 -22 256 -22 l232 0 24
  25 c30 30 31 54 4 89 l-20 26 -238 0 c-235 0 -238 0 -259 -23z"/>
  </g>
  </svg>
  
);

export const IconNcm = ({fill}) => (
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
  width="25px" height="25px" viewBox="0 0 512.000000 512.000000"
  preserveAspectRatio="xMidYMid meet">

  <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
  fill={fill ?? lightTheme.backgrounds.red2} stroke="none">
  <path d="M2045 4400 c-278 -127 -487 -228 -497 -241 -16 -18 -18 -44 -18 -179
  0 -144 2 -160 21 -184 11 -14 29 -26 40 -26 18 0 19 -9 19 -175 l0 -175 -367
  0 c-212 0 -387 -5 -412 -11 -176 -40 -316 -198 -329 -367 -4 -66 -3 -70 23
  -90 41 -33 87 -29 119 9 15 18 26 43 26 60 0 69 64 159 145 202 40 22 41 22
  859 25 917 3 890 5 968 -66 23 -20 52 -59 64 -87 l24 -50 0 -915 c0 -899 -1
  -916 -21 -960 -25 -55 -71 -105 -124 -133 -38 -21 -56 -22 -353 -27 l-314 -5
  -24 -28 c-21 -25 -24 -37 -24 -118 0 -49 -2 -89 -5 -89 -3 0 -71 53 -152 118
  l-148 117 -355 5 c-341 5 -357 6 -396 27 -45 24 -108 89 -127 131 -9 20 -13
  186 -17 610 l-5 584 -28 24 c-49 42 -108 28 -133 -31 -11 -28 -14 -127 -14
  -547 0 -282 5 -547 10 -587 18 -135 92 -253 201 -318 96 -58 138 -63 485 -63
  l312 0 212 -170 c189 -151 217 -170 249 -170 26 0 44 7 59 23 21 22 22 33 22
  169 l0 147 268 3 c246 3 271 5 320 25 79 32 158 97 203 166 72 111 69 74 69
  929 l0 768 314 0 314 0 31 26 31 26 0 208 0 208 -31 26 c-17 14 -35 26 -40 26
  -5 0 -9 108 -9 260 0 250 1 260 19 260 11 0 29 12 40 26 19 24 21 40 21 185 0
  150 -1 159 -22 182 -32 35 -967 457 -1010 456 -21 0 -214 -83 -513 -219z m950
  -152 l425 -193 0 -57 0 -58 -860 0 -860 0 0 58 0 57 423 192 c232 105 428 192
  435 192 7 1 204 -86 437 -191z m-1035 -658 l0 -170 -85 0 -85 0 0 170 0 170
  85 0 85 0 0 -170z m340 0 l0 -170 -85 0 -85 0 0 170 0 170 85 0 85 0 0 -170z
  m350 -16 l0 -186 -22 7 c-13 3 -53 12 -90 18 l-68 11 0 168 0 168 90 0 90 0 0
  -186z m340 -69 l0 -255 -85 0 -85 0 0 255 0 255 85 0 85 0 0 -255z m340 0 l0
  -255 -85 0 -85 0 0 255 0 255 85 0 85 0 0 -255z m90 -515 l0 -90 -257 2 -258
  3 -3 88 -3 87 261 0 260 0 0 -90z"/>
  <path d="M1545 2975 c-344 -64 -616 -330 -687 -674 -25 -120 -20 -287 12 -399
  109 -386 470 -648 865 -629 139 7 214 26 340 87 384 186 574 625 443 1030
  -132 411 -552 663 -973 585z m275 -169 c142 -26 259 -87 364 -190 272 -268
  270 -706 -4 -976 -80 -78 -167 -131 -275 -167 -69 -23 -97 -26 -205 -26 -108
  0 -136 3 -205 26 -111 37 -198 90 -280 172 -82 82 -135 169 -172 280 -23 69
  -26 97 -26 205 0 108 3 136 26 205 80 245 285 425 532 470 92 17 154 17 245 1z"/>
  <path d="M1664 2636 c-22 -10 -35 -25 -44 -50 -6 -20 -18 -36 -26 -36 -55 0
  -161 -98 -182 -168 -30 -98 0 -206 73 -271 54 -47 97 -63 190 -68 111 -6 123
  -9 140 -43 22 -43 19 -68 -14 -101 l-29 -29 -162 0 c-158 0 -161 -1 -185 -25
  -17 -16 -25 -35 -25 -57 1 -64 39 -88 139 -88 l71 0 14 -34 c29 -71 131 -66
  156 8 6 20 18 36 26 36 28 0 90 39 126 78 115 127 79 321 -75 398 -39 20 -71
  27 -144 31 -108 7 -131 19 -139 74 -5 29 -1 41 19 65 l25 29 172 5 c168 5 172
  5 190 30 29 37 25 76 -9 111 -27 27 -35 29 -106 29 l-76 0 -11 31 c-7 21 -22
  36 -44 45 -39 16 -31 16 -70 0z"/>
  <path d="M522 2727 c-23 -25 -29 -75 -12 -106 16 -31 65 -46 100 -31 37 15 64
  63 56 96 -16 62 -101 86 -144 41z"/>
  <path d="M3904 2640 c-43 -17 -54 -48 -54 -152 l0 -98 -363 0 -364 0 -21 -23
  c-25 -26 -29 -82 -9 -108 29 -37 47 -39 461 -39 l404 0 31 25 c26 23 30 33 33
  86 l3 60 178 -126 c97 -70 177 -130 177 -135 0 -5 -80 -65 -177 -135 l-178
  -126 -3 38 c-8 118 13 113 -482 113 l-411 0 -24 -25 c-34 -33 -34 -87 0 -120
  l24 -25 361 0 360 0 0 -89 c0 -80 3 -93 24 -117 48 -57 62 -50 387 182 362
  258 359 255 359 304 0 30 -7 44 -33 66 -67 59 -613 443 -637 448 -14 3 -35 1
  -46 -4z"/>
  <path d="M3330 1384 c-173 -124 -320 -235 -327 -247 -19 -33 -15 -63 10 -91
  12 -14 162 -125 332 -247 291 -207 312 -220 345 -215 58 9 70 34 70 147 l0 98
  366 3 366 3 25 29 c20 24 24 36 19 65 -11 73 2 71 -472 71 -409 0 -425 -1
  -444 -20 -21 -21 -28 -44 -32 -103 l-3 -37 -177 126 c-98 70 -175 130 -173
  134 6 10 342 250 349 250 3 0 6 -18 6 -39 0 -28 8 -49 26 -70 l26 -31 421 0
  c445 1 441 0 465 47 19 35 14 63 -17 94 l-29 29 -361 0 -361 0 0 93 c0 85 -2
  96 -23 115 -51 48 -66 40 -407 -204z"/>
  </g>
  </svg>
);

export const IconObsDefault = ({stroke, fill}) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 6C1 3.79086 2.79086 2 5 2H15C17.2091 2 19 3.79086 19 6V10.5C19 12.7091 17.2091 14.5 15 14.5H11L6.125 17.5V14.5H5C2.79086 14.5 1 12.7091 1 10.5V6Z" stroke={stroke} strokeWidth="1.5" strokeLinejoin="round"/>
    <circle cx="6" cy="8" r="1" fill={fill}/>
    <circle cx="10.2305" cy="8" r="1" fill={fill}/>
    <circle cx="14.4609" cy="8" r="1" fill={fill}/>
  </svg>
);

export const IconArrowUp = ({stroke}) => {
  return <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.58398 12.9165L10.0007 6.49984L16.4173 12.9165" stroke={stroke} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"/>
  </svg>
};

export const IconArrowDown = ({stroke}) => {
  return <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.416 7.0835L9.99935 13.5002L3.58268 7.08349" stroke={stroke ? stroke : lightTheme.backgrounds.red2} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"/>
  </svg>
};

export const IconEdit = ({stroke}) => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.21637 13.5876L13.0514 1.90815C13.2688 1.65001 13.5604 1.46504 13.8865 1.37834V1.37834C14.4055 1.24039 14.9591 1.36465 15.3694 1.71116L17.6769 3.6601C18.0877 4.00708 18.3036 4.53253 18.2554 5.06811V5.06811C18.2251 5.40487 18.0921 5.72418 17.8743 5.98281L8.03982 17.6615L2.72266 19.0749L3.21637 13.5876Z" stroke={stroke} strokeWidth="1.5"/>
    <path d="M11.4805 3.48047L16.4307 7.88726" stroke={stroke} strokeWidth="1.5"/>
  </svg>
);

export const IconAddCategories = ({fill}) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M15.4545 3.63636H19C19.5364 3.63636 19.9545 4.1 19.9 4.63636L18.5 18.6636C18.4091 19.4091 17.7818 20 17.0182 20H15.4727L15.4545 12.7273C15.4545 8.88182 12.6364 6.50909 9.29091 5.73636L9.18182 4.63636C9.13636 4.1 9.55454 3.63636 10.0909 3.63636H13.6364V0.909091C13.6364 0.409091 14.0455 0 14.5455 0C15.0455 0 15.4545 0.409091 15.4545 0.909091V3.63636ZM0.909091 18.1818H12.7273C13.2273 18.1818 13.6364 18.5909 13.6364 19.0909C13.6364 19.5909 13.2273 20 12.7273 20H0.909091C0.409091 20 0 19.5909 0 19.0909C0 18.5909 0.409091 18.1818 0.909091 18.1818ZM0.999999 12.7273H12.6364C13.2 12.7273 13.6455 12.2182 13.5364 11.6727C12.9455 8.73635 9.88182 7.26363 6.81818 7.26363C3.75454 7.26363 0.699999 8.73635 0.0999985 11.6727C-0.00909237 12.2182 0.445453 12.7273 0.999999 12.7273ZM0.909091 14.5455H12.7273C13.2273 14.5455 13.6364 14.9545 13.6364 15.4545C13.6364 15.9545 13.2273 16.3636 12.7273 16.3636H0.909091C0.409091 16.3636 0 15.9545 0 15.4545C0 14.9545 0.409091 14.5455 0.909091 14.5455Z" fill={fill}/>
  </svg>
);

export const IconChecked = ({fill}) => (
  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M15.8026 0.851639C15.5402 0.604792 15.1138 0.604792 14.8513 0.851639L5.33306 9.812L1.14815 5.90222C0.885678 5.65537 0.459327 5.65537 0.196854 5.90222C-0.0656181 6.14907 -0.0656181 6.54869 0.196854 6.79491L4.85941 11.1504C5.11921 11.3941 5.55156 11.3941 5.81137 11.1504L15.8026 1.74433C16.0658 1.49811 16.0658 1.09786 15.8026 0.851639C16.0658 1.09786 15.5402 0.604792 15.8026 0.851639Z" fill={fill}/>
  </svg>  
);

export const IconUpdateImg = ({stroke, fill}) => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M16 8.5V9.51C16 10.6 16.89 11.49 17.98 11.5C18.36 11.5 18.7 11.39 19 11.22V19.5C19 20.6 18.1 21.5 17 21.5H5C3.9 21.5 3 20.6 3 19.5V7.5C3 6.4 3.9 5.5 5 5.5H13.27C13.1 5.79 13 6.12 13 6.48C13 7.04 13.21 7.54 13.58 7.92C13.96 8.29 14.46 8.5 14.99 8.5H16ZM6 19.5H15.96C16.38 19.5 16.61 19.02 16.35 18.69L13.4 15.01C13.2 14.75 12.81 14.76 12.61 15.02L10 18.5L8.4 16.09C8.2 15.81 7.79 15.79 7.58 16.07L5.6 18.7C5.35 19.03 5.59 19.5 6 19.5Z" fill={fill}/>
    <path d="M15.5 6H21.5" stroke={stroke} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M18.5 3L18.5 9" stroke={stroke} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export const IconCertificate = ({fill}) => (
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
  width="40px" height="40px" viewBox="0 0 512.000000 512.000000"
  preserveAspectRatio="xMidYMid meet">
 
 <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
 fill={fill} stroke="none">
 <path d="M105 4741 c-48 -22 -69 -44 -90 -94 -13 -32 -15 -172 -15 -1165 0
 -1127 0 -1129 21 -1156 26 -33 77 -36 105 -5 18 20 19 58 24 1153 l5 1131
 2405 0 2405 0 3 -1719 c1 -1262 -1 -1722 -9 -1732 -9 -11 -58 -14 -228 -14
 l-216 0 -85 85 -85 85 43 0 c58 0 87 29 95 97 14 123 117 222 230 223 27 0 45
 7 62 25 l25 24 0 864 c0 855 0 863 -20 885 -30 32 -82 30 -109 -4 -21 -27 -21
 -32 -21 -840 0 -710 -2 -814 -15 -814 -33 0 -128 -52 -174 -95 -56 -53 -92
 -109 -111 -173 l-13 -42 -66 0 c-66 0 -67 0 -114 48 -26 26 -47 51 -47 54 0 4
 13 9 29 13 15 3 41 19 56 35 26 27 29 39 41 162 7 73 13 138 13 144 1 5 39 55
 86 110 90 104 109 145 95 195 -5 17 -48 75 -95 130 l-86 99 -11 133 c-15 201
 -34 221 -216 232 -59 3 -117 8 -128 10 -12 3 -70 45 -129 95 -101 84 -111 90
 -153 90 -50 0 -64 -9 -190 -119 l-74 -64 -138 -12 c-203 -17 -212 -26 -228
 -232 l-11 -133 -86 -99 c-131 -151 -131 -169 -1 -323 94 -111 87 -94 104 -286
 8 -93 12 -106 37 -132 15 -16 41 -32 56 -35 l29 -7 -48 -54 -47 -54 -172 0
 c-160 0 -175 -2 -193 -20 -27 -27 -26 -81 1 -106 16 -15 41 -20 116 -24 l95
 -5 -77 -83 -77 -82 -1267 0 c-972 0 -1270 3 -1279 12 -9 9 -12 124 -12 455 l0
 444 -25 24 c-31 32 -69 32 -100 0 l-25 -24 0 -457 c0 -437 1 -460 20 -499 22
 -45 57 -75 109 -93 25 -9 342 -12 1234 -12 l1200 0 -56 -59 c-65 -67 -72 -97
 -32 -136 l24 -25 228 0 229 0 109 -187 c60 -103 117 -195 127 -205 21 -21 66
 -23 90 -4 23 17 25 24 103 292 36 126 73 250 81 277 l16 47 127 0 128 0 86
 -297 c90 -310 101 -333 152 -333 39 0 63 30 175 220 l108 185 230 5 c208 5
 232 7 251 24 38 35 28 79 -30 142 l-52 54 150 0 c198 0 251 19 293 105 20 41
 20 62 20 1781 0 1666 -1 1741 -19 1779 -22 48 -44 69 -94 90 -32 13 -300 15
 -2449 15 -2320 0 -2415 -1 -2453 -19z m3599 -1966 c48 -42 96 -80 105 -85 10
 -5 73 -14 141 -20 68 -6 125 -12 127 -14 2 -1 8 -54 13 -117 6 -63 12 -123 15
 -134 2 -11 40 -63 85 -115 44 -51 80 -97 80 -101 0 -4 -36 -51 -81 -103 l-81
 -96 -9 -78 c-5 -42 -11 -103 -14 -134 -7 -66 -1 -63 -158 -74 -111 -7 -123
 -13 -238 -115 -37 -33 -72 -59 -78 -59 -6 0 -42 27 -80 60 -120 103 -129 107
 -239 115 -156 10 -150 7 -157 73 -3 31 -9 92 -14 135 l-9 77 -81 96 c-45 53
 -81 99 -81 103 0 4 36 50 80 101 45 52 83 104 85 115 3 11 9 71 15 134 5 63
 11 115 12 117 2 1 59 8 128 14 68 6 132 16 141 21 10 5 57 43 106 84 48 41 91
 75 94 75 3 0 45 -34 93 -75z m-303 -1272 c30 -25 53 -53 52 -62 -3 -23 -232
 -803 -237 -808 -5 -5 -117 184 -123 208 -3 11 24 68 63 135 74 128 82 165 45
 196 -27 21 -70 24 -93 6 -9 -7 -48 -67 -86 -133 l-69 -120 -123 -3 -122 -3 24
 30 c14 16 148 158 299 315 187 195 280 286 294 286 12 0 46 -21 76 -47z m753
 -208 c132 -137 267 -278 300 -312 l60 -63 -130 0 -129 0 -59 103 c-86 149
 -101 167 -138 167 -39 0 -78 -34 -78 -69 0 -14 33 -84 74 -154 l74 -128 -61
 -105 c-34 -57 -64 -100 -68 -96 -8 9 -242 813 -237 817 68 61 117 95 133 93
 11 -2 128 -115 259 -253z m-524 62 c0 -2 13 -48 30 -103 16 -54 30 -102 30
 -106 0 -5 -36 -8 -80 -8 -50 0 -80 4 -80 11 0 12 50 190 57 202 4 7 43 10 43
 4z"/>
 <path d="M3509 2546 c-99 -26 -183 -97 -236 -198 -25 -48 -28 -63 -28 -158 0
 -93 3 -112 27 -162 86 -183 304 -262 494 -179 67 30 147 111 180 184 25 54 29
 74 29 152 0 64 -5 103 -18 134 -74 180 -264 277 -448 227z m197 -159 c100 -51
 151 -182 111 -280 -77 -182 -327 -189 -411 -12 -28 59 -19 162 19 217 44 63
 122 101 196 95 31 -3 69 -12 85 -20z"/>
 <path d="M341 4414 c-12 -15 -21 -38 -21 -51 0 -32 42 -73 75 -73 33 0 75 42
 75 75 0 14 -11 37 -25 50 -33 34 -77 33 -104 -1z"/>
 <path d="M662 4417 c-12 -13 -22 -35 -22 -48 0 -130 -120 -249 -250 -249 -15
 0 -36 -10 -48 -23 l-22 -23 0 -1198 0 -1197 25 -24 c17 -18 35 -25 62 -25 113
 -1 216 -100 230 -223 4 -34 14 -59 29 -74 l23 -23 835 0 c599 0 842 3 860 11
 51 23 55 103 7 128 -13 8 -273 11 -814 11 l-794 0 -13 43 c-19 63 -55 119
 -111 172 -46 43 -141 95 -174 95 -13 0 -15 139 -15 1105 l0 1105 28 6 c48 12
 123 54 168 96 41 38 114 162 114 194 0 12 282 14 1780 14 1498 0 1780 -2 1780
 -14 0 -7 16 -45 35 -84 50 -99 150 -182 248 -206 l27 -6 0 -138 c1 -148 5
 -163 54 -182 31 -11 79 7 90 35 3 9 6 99 6 199 0 178 -1 183 -23 204 -13 12
 -35 22 -48 22 -130 0 -249 120 -249 250 0 15 -10 36 -23 48 l-23 22 -1875 0
 -1876 0 -21 -23z"/>
 <path d="M4675 4415 c-14 -13 -25 -36 -25 -50 0 -14 11 -37 25 -50 13 -14 36
 -25 50 -25 33 0 75 41 75 73 0 68 -78 100 -125 52z"/>
 <path d="M914 3878 c-39 -19 -44 -48 -44 -288 0 -228 0 -229 24 -257 l24 -28
 307 0 307 0 24 28 c29 34 30 56 3 90 l-20 27 -257 2 -257 3 -3 143 -3 142 756
 0 755 0 0 -145 0 -145 -355 0 c-342 0 -356 -1 -375 -20 -25 -25 -26 -71 -1
 -101 l19 -24 379 -3 c208 -2 393 0 411 3 18 3 42 15 53 26 18 18 19 35 19 264
 l0 246 -25 24 -24 25 -848 -1 c-562 0 -855 -4 -869 -11z"/>
 <path d="M2855 3866 c-32 -32 -33 -75 -2 -104 23 -22 26 -22 441 -22 l417 0
 24 25 c30 29 32 64 6 96 l-19 24 -421 3 -421 3 -25 -25z"/>
 <path d="M2852 3427 c-29 -31 -28 -72 3 -102 l24 -25 649 0 c642 0 650 0 676
 21 34 27 36 77 3 107 l-23 22 -655 0 -656 0 -21 -23z"/>
 <path d="M891 2984 c-27 -35 -26 -57 3 -91 l24 -28 829 -3 c455 -2 843 0 861
 3 38 7 72 40 72 71 0 12 -9 33 -21 48 l-20 26 -864 0 -864 0 -20 -26z"/>
 <path d="M1043 2499 c-49 -9 -89 -29 -132 -65 -25 -20 -31 -34 -31 -63 0 -74
 67 -97 134 -46 64 48 149 31 176 -36 7 -16 11 -31 9 -32 -2 -2 -35 -18 -72
 -36 -79 -38 -185 -133 -225 -200 -52 -88 -26 -212 56 -265 94 -63 213 -49 290
 33 52 55 112 219 112 307 l0 43 53 15 c90 25 87 26 123 -34 47 -80 74 -102
 133 -108 72 -7 105 17 166 122 28 47 52 85 55 85 3 0 24 -27 48 -60 120 -169
 360 -196 511 -58 41 37 43 88 5 118 -36 28 -51 27 -114 -14 -128 -82 -221 -56
 -315 90 -60 93 -85 115 -132 115 -57 0 -78 -18 -143 -126 -35 -57 -66 -104
 -70 -104 -4 0 -18 21 -33 48 -54 99 -97 115 -220 84 -72 -19 -79 -19 -84 -4
 -17 53 -48 105 -76 128 -63 54 -147 77 -224 63z m167 -424 c0 -33 -44 -146
 -69 -176 -32 -37 -72 -42 -103 -11 -18 18 -20 24 -9 50 19 44 137 151 169 152
 6 0 12 -7 12 -15z"/>
 <path d="M341 1434 c-28 -36 -26 -70 5 -101 20 -20 31 -24 57 -19 64 12 87 77
 42 121 -33 34 -77 33 -104 -1z"/>
 <path d="M4675 1435 c-45 -44 -22 -109 42 -121 26 -5 37 -1 57 19 31 31 33 65
 5 101 -27 34 -71 35 -104 1z"/>
 </g>
 </svg>
);

export const IconArrowRight = ({stroke}) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.08203 3.58203L13.4987 9.9987L7.08203 16.4154" stroke={stroke ?? lightTheme.backgrounds.red2} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"/>
  </svg>  
);

export const IconArrowLeft = ({stroke}) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.918 3.58594L6.5013 10.0026L12.918 16.4193" stroke={stroke ?? lightTheme.backgrounds.red2} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"/>
  </svg>
 
);

export const IconAddComplement = ({stroke}) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 9H17" stroke={stroke} strokeWidth="2" strokeLinecap="round"/>
    <path d="M9 1L9 17" stroke={stroke} strokeWidth="2" strokeLinecap="round"/>
  </svg>  
);

export const IconAnyLess = ({stroke}) => (
  <svg width="18" height="2" viewBox="0 0 18 2" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1H17" stroke={stroke} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const IconChangeAddress = ({stroke, fill}) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.1328 9.47266L9.37606 9.47266" stroke={stroke} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M5.875 15.3086H14.6318" stroke={stroke} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M1.51193 15.544C1.35593 15.4239 1.35593 15.1887 1.51193 15.0686L5.97418 11.6335C6.17145 11.4817 6.45718 11.6223 6.45718 11.8713L6.45718 18.7413C6.45718 18.9903 6.17145 19.1309 5.97418 18.9791L1.51193 15.544Z" fill={fill}/>
    <path d="M22.4959 9.23333C22.6519 9.35342 22.6519 9.58868 22.4959 9.70877L18.0336 13.1438C17.8364 13.2957 17.5506 13.155 17.5506 12.9061L17.5506 6.03601C17.5506 5.78706 17.8364 5.64643 18.0336 5.79829L22.4959 9.23333Z" fill={fill}/>
  </svg>
);

export const IconPromotion = ({fill}) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22.7461 11.3498L20.828 9.16357L21.0961 6.26582C21.1477 5.7502 20.7971 5.27584 20.3021 5.1624L17.4559 4.51273L15.9709 2.00684C15.7028 1.56341 15.1562 1.37779 14.6819 1.58404L12.0007 2.74933L9.32979 1.60466C8.85542 1.39842 8.29856 1.58404 8.04075 2.02747L6.54547 4.52304L3.70959 5.1624C3.20428 5.27584 2.85366 5.73989 2.90523 6.26582L3.17335 9.15326L1.25526 11.3498C0.914954 11.7416 0.914954 12.3191 1.25526 12.711L3.17335 14.8972L2.90523 17.8053C2.85366 18.3209 3.20428 18.7953 3.69927 18.9087L6.54547 19.5584L8.03044 22.0539C8.29856 22.4974 8.84511 22.683 9.32979 22.4767L12.0007 21.3115L14.6716 22.4561C15.1459 22.6624 15.7028 22.4767 15.9606 22.0333L17.4456 19.5274L20.2918 18.8778C20.7971 18.7643 21.1374 18.29 21.0858 17.7743L20.8177 14.8766L22.7358 12.6904C23.0864 12.3191 23.0864 11.7416 22.7461 11.3498Z" fill={fill}/>
    <path d="M9.86981 16.1007L12.8288 8.07075H14.0938L11.1348 16.1007H9.86981ZM9.29781 12.4487C8.87248 12.4487 8.52048 12.3534 8.24181 12.1627C7.96314 11.9647 7.75414 11.7044 7.61481 11.3817C7.48281 11.0591 7.41681 10.7071 7.41681 10.3257V10.0397C7.41681 9.62175 7.48648 9.25508 7.62581 8.93975C7.76514 8.61708 7.97414 8.36775 8.25281 8.19175C8.53881 8.00841 8.88714 7.91675 9.29781 7.91675C9.72314 7.91675 10.0751 8.00841 10.3538 8.19175C10.6325 8.36775 10.8415 8.61708 10.9808 8.93975C11.1201 9.25508 11.1898 9.62175 11.1898 10.0397V10.3257C11.1898 10.7071 11.1201 11.0591 10.9808 11.3817C10.8488 11.7044 10.6435 11.9647 10.3648 12.1627C10.0935 12.3534 9.73781 12.4487 9.29781 12.4487ZM9.29781 11.4257C9.56181 11.4257 9.75614 11.3304 9.88081 11.1397C10.0128 10.9417 10.0788 10.6264 10.0788 10.1937C10.0788 9.72441 10.0128 9.39808 9.88081 9.21475C9.74881 9.03141 9.55448 8.93975 9.29781 8.93975C9.04114 8.93975 8.84681 9.03141 8.71481 9.21475C8.59014 9.39808 8.52781 9.72075 8.52781 10.1827C8.52781 10.6154 8.59014 10.9307 8.71481 11.1287C8.84681 11.3267 9.04114 11.4257 9.29781 11.4257ZM14.6108 16.2657C14.1855 16.2657 13.8335 16.1704 13.5548 15.9797C13.2761 15.7817 13.0671 15.5214 12.9278 15.1987C12.7958 14.8761 12.7298 14.5241 12.7298 14.1427V13.8567C12.7298 13.4387 12.7995 13.0721 12.9388 12.7567C13.0781 12.4341 13.2871 12.1847 13.5658 12.0087C13.8518 11.8254 14.2001 11.7337 14.6108 11.7337C15.0361 11.7337 15.3881 11.8254 15.6668 12.0087C15.9455 12.1847 16.1545 12.4341 16.2938 12.7567C16.4331 13.0721 16.5028 13.4387 16.5028 13.8567V14.1427C16.5028 14.5241 16.4331 14.8761 16.2938 15.1987C16.1618 15.5214 15.9565 15.7817 15.6778 15.9797C15.4065 16.1704 15.0508 16.2657 14.6108 16.2657ZM14.6108 15.2427C14.8748 15.2427 15.0691 15.1474 15.1938 14.9567C15.3258 14.7587 15.3918 14.4434 15.3918 14.0107C15.3918 13.5414 15.3258 13.2151 15.1938 13.0317C15.0618 12.8484 14.8675 12.7567 14.6108 12.7567C14.3541 12.7567 14.1598 12.8484 14.0278 13.0317C13.9031 13.2151 13.8408 13.5377 13.8408 13.9997C13.8408 14.4324 13.9031 14.7477 14.0278 14.9457C14.1598 15.1437 14.3541 15.2427 14.6108 15.2427Z" fill="white"/>
  </svg>
);

export const IconCard = ({fill}) => (
  <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M15.666 0.553223H2.33268C1.40768 0.553223 0.674349 1.29489 0.674349 2.21989L0.666016 12.2199C0.666016 13.1449 1.40768 13.8866 2.33268 13.8866H15.666C16.591 13.8866 17.3327 13.1449 17.3327 12.2199V2.21989C17.3327 1.29489 16.591 0.553223 15.666 0.553223ZM14.8327 12.2199H3.16602C2.70768 12.2199 2.33268 11.8449 2.33268 11.3866V7.21989H15.666V11.3866C15.666 11.8449 15.291 12.2199 14.8327 12.2199ZM2.33268 3.88656H15.666V2.21989H2.33268V3.88656Z" fill={fill}/>
  </svg>
  
);

export const IconGraphUp = ({fill}) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.2727 5.7817L15.597 7.10598L11.1092 11.5938L8.08354 8.56821C7.91173 8.39601 7.67846 8.29923 7.4352 8.29923C7.19194 8.29923 6.95867 8.39601 6.78685 8.56821L1.269 14.0953C0.910335 14.4539 0.910335 15.0333 1.269 15.392C1.62766 15.7506 2.20703 15.7506 2.56569 15.392L7.4306 10.5179L10.4562 13.5435C10.8149 13.9021 11.3943 13.9021 11.7529 13.5435L16.8937 8.41187L18.218 9.73616C18.5031 10.0212 18.9997 9.81892 18.9997 9.41428V5.45982C19.0089 5.20232 18.8066 5 18.5491 5H14.6038C14.19 5 13.9876 5.49661 14.2727 5.7817Z" fill={fill}/>
  </svg>
);

export const IconGraphDown = ({fill}) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.273 14.8794L15.5973 13.5551L11.1093 9.06719L8.08366 12.0929C7.72499 12.4515 7.1456 12.4515 6.78694 12.0929L1.26899 6.56572C1.09678 6.3939 1 6.16063 1 5.91736C1 5.67409 1.09678 5.44082 1.26899 5.269C1.62765 4.91033 2.20704 4.91033 2.56571 5.269L7.4307 10.1432L10.4564 7.11751C10.815 6.75885 11.3944 6.75885 11.7531 7.11751L16.894 12.2492L18.2183 10.9249C18.5034 10.6398 19 10.8421 19 11.2468V15.1921C19 15.4496 18.7977 15.6519 18.5402 15.6519H14.5948C14.1902 15.6611 13.9879 15.1645 14.273 14.8794Z" fill={fill}/>
  </svg>  
);

export const IconCurrentAccount = ({fill}) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M2.58141 4.81174L9.4369 1.20176C9.94022 0.932747 10.5477 0.932747 11.051 1.20176L17.9065 4.81174C18.2623 4.99397 18.4879 5.36712 18.4879 5.7663C18.4879 6.36507 18.0019 6.85103 17.4118 6.85103H3.08473C2.48596 6.85103 2 6.36507 2 5.7663C2 5.36712 2.22562 4.99397 2.58141 4.81174ZM3.73557 9.88828V13.3594C3.73557 14.0797 4.31698 14.6611 5.03724 14.6611C5.7575 14.6611 6.33892 14.0797 6.33892 13.3594V9.88828C6.33892 9.16802 5.7575 8.58661 5.03724 8.58661C4.31698 8.58661 3.73557 9.16802 3.73557 9.88828ZM8.94226 9.88828V13.3594C8.94226 14.0797 9.52368 14.6611 10.2439 14.6611C10.9642 14.6611 11.5456 14.0797 11.5456 13.3594V9.88828C11.5456 9.16802 10.9642 8.58661 10.2439 8.58661C9.52368 8.58661 8.94226 9.16802 8.94226 9.88828ZM17.1862 19H3.30168C2.58141 19 2 18.4186 2 17.6983C2 16.978 2.58141 16.3966 3.30168 16.3966H17.1862C17.9065 16.3966 18.4879 16.978 18.4879 17.6983C18.4879 18.4186 17.9065 19 17.1862 19ZM14.149 9.88828V13.3594C14.149 14.0797 14.7304 14.6611 15.4506 14.6611C16.1709 14.6611 16.7523 14.0797 16.7523 13.3594V9.88828C16.7523 9.16802 16.1709 8.58661 15.4506 8.58661C14.7304 8.58661 14.149 9.16802 14.149 9.88828Z" fill={fill}/>
  </svg>
);

export const IconBillsToPay = ({fill}) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 16.1255C9.14706 16.1255 8.42157 15.9888 7.82353 15.7155C7.22549 15.4324 6.76961 15.037 6.45588 14.5293C6.26183 14.1989 6.12972 13.8327 6.05957 13.4307C5.99117 13.0386 6.32262 12.7134 6.72059 12.7134V12.7134V12.7134C7.11856 12.7134 7.43459 13.0437 7.56423 13.42C7.59563 13.5112 7.63305 13.6027 7.67647 13.6946C7.83333 14.0167 8.09804 14.2901 8.47059 14.5146C8.85294 14.7294 9.36275 14.8368 10 14.8368C10.8529 14.8368 11.4902 14.6611 11.9118 14.3096C12.3333 13.9484 12.5441 13.5335 12.5441 13.0649C12.5441 12.6158 12.3578 12.2448 11.9853 11.9519C11.6127 11.6492 11.0637 11.4637 10.3382 11.3954L9.41176 11.3075C8.45098 11.2197 7.68627 10.9317 7.11765 10.4435C6.54902 9.95537 6.26471 9.2622 6.26471 8.36402C6.26471 7.73919 6.41667 7.21199 6.72059 6.78243C7.02451 6.3431 7.44608 6.00628 7.98529 5.77197C8.53431 5.53766 9.18137 5.4205 9.92647 5.4205C10.6814 5.4205 11.3284 5.5523 11.8676 5.8159C12.4069 6.06973 12.8235 6.44561 13.1176 6.94351C13.3059 7.25589 13.4339 7.61225 13.5016 8.01259C13.5681 8.40498 13.2362 8.73013 12.8382 8.73013V8.73013V8.73013C12.4403 8.73013 12.1307 8.39803 11.9961 8.02353C11.9644 7.93534 11.9265 7.8487 11.8824 7.7636C11.7353 7.45118 11.5 7.19735 11.1765 7.00209C10.8627 6.80683 10.4461 6.7092 9.92647 6.7092C9.46569 6.7092 9.07353 6.78243 8.75 6.92887C8.42647 7.07531 8.17647 7.27545 8 7.52929C7.82353 7.77336 7.73529 8.0516 7.73529 8.36402C7.73529 8.77406 7.88235 9.1304 8.17647 9.43305C8.47059 9.72594 8.92157 9.90167 9.52941 9.96025L10.4706 10.0335C11.5392 10.1311 12.3922 10.4386 13.0294 10.9561C13.6765 11.4735 14 12.1764 14 13.0649C14 13.6799 13.8382 14.2169 13.5147 14.6757C13.1912 15.1346 12.7304 15.4909 12.1324 15.7448C11.5441 15.9986 10.8333 16.1255 10 16.1255ZM10 18C9.6264 18 9.32353 17.6971 9.32353 17.3235V15.8619H10.6765V17.3235C10.6765 17.6971 10.3736 18 10 18V18V18ZM9.26471 6.13807V4.67647C9.26471 4.30287 9.56757 4 9.94118 4V4V4C10.3148 4 10.6176 4.30287 10.6176 4.67647V6.13807H9.26471Z" fill={fill}/>
    <path d="M13 3.5H18" stroke="black" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export const IconBillsToReceive = ({fill}) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 16.1255C9.14706 16.1255 8.42157 15.9888 7.82353 15.7155C7.22549 15.4324 6.76961 15.037 6.45588 14.5293C6.26183 14.1989 6.12972 13.8327 6.05957 13.4307C5.99117 13.0386 6.32262 12.7134 6.72059 12.7134C7.11856 12.7134 7.43459 13.0437 7.56423 13.42C7.59563 13.5112 7.63305 13.6027 7.67647 13.6946C7.83333 14.0167 8.09804 14.2901 8.47059 14.5146C8.85294 14.7294 9.36275 14.8368 10 14.8368C10.8529 14.8368 11.4902 14.6611 11.9118 14.3096C12.3333 13.9484 12.5441 13.5335 12.5441 13.0649C12.5441 12.6158 12.3578 12.2448 11.9853 11.9519C11.6127 11.6492 11.0637 11.4637 10.3382 11.3954L9.41176 11.3075C8.45098 11.2197 7.68627 10.9317 7.11765 10.4435C6.54902 9.95537 6.26471 9.2622 6.26471 8.36402C6.26471 7.73919 6.41667 7.21199 6.72059 6.78243C7.02451 6.3431 7.44608 6.00628 7.98529 5.77197C8.53431 5.53766 9.18137 5.4205 9.92647 5.4205C10.6814 5.4205 11.3284 5.5523 11.8676 5.8159C12.4069 6.06973 12.8235 6.44561 13.1176 6.94351C13.3059 7.25589 13.4339 7.61225 13.5016 8.01259C13.5681 8.40498 13.2362 8.73013 12.8382 8.73013C12.4403 8.73013 12.1307 8.39803 11.9961 8.02353C11.9644 7.93534 11.9265 7.8487 11.8824 7.7636C11.7353 7.45118 11.5 7.19735 11.1765 7.00209C10.8627 6.80683 10.4461 6.7092 9.92647 6.7092C9.46569 6.7092 9.07353 6.78243 8.75 6.92887C8.42647 7.07531 8.17647 7.27545 8 7.52929C7.82353 7.77336 7.73529 8.0516 7.73529 8.36402C7.73529 8.77406 7.88235 9.1304 8.17647 9.43305C8.47059 9.72594 8.92157 9.90167 9.52941 9.96025L10.4706 10.0335C11.5392 10.1311 12.3922 10.4386 13.0294 10.9561C13.6765 11.4735 14 12.1764 14 13.0649C14 13.6799 13.8382 14.2169 13.5147 14.6757C13.1912 15.1346 12.7304 15.4909 12.1324 15.7448C11.5441 15.9986 10.8333 16.1255 10 16.1255ZM10 18C9.6264 18 9.32353 17.6971 9.32353 17.3235V15.8619H10.6765V17.3235C10.6765 17.6971 10.3736 18 10 18ZM9.26471 6.13807V4.67647C9.26471 4.30287 9.56757 4 9.94118 4C10.3148 4 10.6176 4.30287 10.6176 4.67647V6.13807H9.26471Z" fill={fill}/>
    <path d="M13 3.5H18" stroke={'black'} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M15.5 6L15.5 1" stroke={'black'} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
  
);

export const IconDeleteTable = ({stroke, fill}) => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.49609 2.90381H16.6707" stroke={stroke} strokeWidth="2" strokeLinecap="round"/>
    <path d="M7.72656 1.8335H11.2114" stroke={stroke} strokeWidth="2"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M3.37109 5.31836H15.5681V19.0002C15.5681 20.1047 14.6726 21.0002 13.5681 21.0002H5.3711C4.26653 21.0002 3.37109 20.1047 3.37109 19.0002V5.31836ZM6.76124 15.6963C6.46834 15.4034 6.46834 14.9285 6.76124 14.6356L8.54105 12.8558L6.76122 11.076C6.46833 10.7831 6.46833 10.3082 6.76122 10.0153C7.05411 9.7224 7.52899 9.7224 7.82188 10.0153L9.60171 11.7951L11.3815 10.0153C11.6744 9.7224 12.1493 9.7224 12.4422 10.0153C12.7351 10.3082 12.7351 10.7831 12.4422 11.076L10.6624 12.8558L12.4422 14.6356C12.7351 14.9285 12.7351 15.4034 12.4422 15.6963C12.1493 15.9892 11.6744 15.9892 11.3815 15.6963L9.60171 13.9164L7.8219 15.6963C7.529 15.9892 7.05413 15.9892 6.76124 15.6963Z" fill={fill}/>
  </svg>  
);

export const IconClose = ({stroke}) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.34375 15.6572L15.6575 4.34352" stroke={stroke} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M4.34375 4.34277L15.6575 15.6565" stroke={stroke} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export const IconEmail= ({stroke}) => (
  <svg width="23" height="20" viewBox="0 0 23 23"  fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4 7.00005L10.2 11.65C11.2667 12.45 12.7333 12.45 13.8 11.65L20 7" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  <rect x="3" y="5" width="18" height="14" rx="2" stroke={stroke} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);
export const IconOrder= ({fill}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path fillRule="evenodd" clipRule="evenodd" d="M18.4398 1.00927C18.4428 1.00921 18.4459 1.00918 18.4489 1.00918H18.4398V1.00927ZM18.4398 1.00927C18.3235 1.01157 18.2081 1.05746 18.1275 1.14694L17.402 1.87245C17.2183 2.05612 16.9336 2.05612 16.75 1.87245L16.0245 1.14694C15.8408 0.963265 15.5561 0.963265 15.3724 1.14694L14.6469 1.87245C14.4632 2.05612 14.1785 2.05612 13.9949 1.87245L13.2694 1.14694C13.0857 0.963265 12.801 0.963265 12.6173 1.14694L11.8918 1.87245C11.7081 2.05612 11.4234 2.05612 11.2398 1.87245L10.5143 1.14694C10.3306 0.963265 10.0459 0.963265 9.86221 1.14694L9.1367 1.87245C8.95303 2.05612 8.66833 2.05612 8.48466 1.87245L7.74997 1.13776C7.56629 0.954082 7.2816 0.954082 7.09793 1.13776L6.37242 1.87245C6.18874 2.05612 5.90405 2.05612 5.72038 1.87245L4.99487 1.13776C4.81119 0.954082 4.5265 0.954082 4.34282 1.13776L3.61731 1.87245C3.43364 2.05612 3.14895 2.05612 2.96527 1.87245L2.23976 1.13776C2.15711 1.0551 2.03772 1.00918 1.91833 1.00918V19C2.03772 19 2.15711 18.9541 2.23976 18.8622L2.96527 18.1367C3.14895 17.9531 3.43364 17.9531 3.61731 18.1367L4.34282 18.8622C4.5265 19.0459 4.81119 19.0459 4.99487 18.8622L5.72038 18.1367C5.90405 17.9531 6.18874 17.9531 6.37242 18.1367L7.09793 18.8622C7.2816 19.0459 7.56629 19.0459 7.74997 18.8622L8.47548 18.1367C8.65915 17.9531 8.94384 17.9531 9.12752 18.1367L9.85303 18.8622C10.0367 19.0459 10.3214 19.0459 10.5051 18.8622L11.2306 18.1367C11.4143 17.9531 11.6989 17.9531 11.8826 18.1367L12.6081 18.8622C12.7918 19.0459 13.0765 19.0459 13.2602 18.8622L13.9857 18.1367C14.1694 17.9531 14.454 17.9531 14.6377 18.1367L15.3632 18.8622C15.5469 19.0459 15.8316 19.0459 16.0153 18.8622L16.7408 18.1367C16.9245 17.9531 17.2092 17.9531 17.3928 18.1367L18.1183 18.8622C18.2102 18.9541 18.3296 19 18.4398 19V1.00927ZM5.5 5.25C5.08579 5.25 4.75 5.58579 4.75 6C4.75 6.41421 5.08579 6.75 5.5 6.75H14.5C14.9142 6.75 15.25 6.41421 15.25 6C15.25 5.58579 14.9142 5.25 14.5 5.25H5.5ZM5.5 9.25C5.08579 9.25 4.75 9.58579 4.75 10C4.75 10.4142 5.08579 10.75 5.5 10.75H14.5C14.9142 10.75 15.25 10.4142 15.25 10C15.25 9.58579 14.9142 9.25 14.5 9.25H5.5ZM5.5 13.25C5.08579 13.25 4.75 13.5858 4.75 14C4.75 14.4142 5.08579 14.75 5.5 14.75H14.5C14.9142 14.75 15.25 14.4142 15.25 14C15.25 13.5858 14.9142 13.25 14.5 13.25H5.5Z" fill={fill}/>
  </svg>
);

export const IconPerson= ({fill}) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M13.5 6.5C13.5 8.43375 11.9337 10 10 10C8.06625 10 6.5 8.43375 6.5 6.5C6.5 4.56625 8.06625 3 10 3C11.9337 3 13.5 4.56625 13.5 6.5ZM3 15.25C3 12.9225 7.66375 11.75 10 11.75C12.3363 11.75 17 12.9225 17 15.25V16.125C17 16.6063 16.6062 17 16.125 17H3.875C3.39375 17 3 16.6063 3 16.125V15.25Z" fill={fill}/>
  </svg>
  
);

export const IconAccessDenied = ({fill}) => (
  <svg xmlns="http://www.w3.org/2000/svg"  fill={fill ? fill : lightTheme.backgrounds.red2} viewBox="0 0 50 50" width="50px" height="50px">    
    <path d="M25,2C12.317,2,2,12.318,2,25s10.317,23,23,23s23-10.318,23-23S37.683,2,25,2z M7,25c0-4.062,1.371-7.8,3.65-10.815 L35.815,39.35C32.8,41.629,29.062,43,25,43C15.075,43,7,34.925,7,25z M39.35,35.815L14.185,10.65C17.2,8.371,20.938,7,25,7 c9.925,0,18,8.075,18,18C43,29.062,41.629,32.8,39.35,35.815z"/>
  </svg>
)

export const IconExclamationSign = ({fill}) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 17C11.45 17 11 16.55 11 16V12C11 11.45 11.45 11 12 11C12.55 11 13 11.45 13 12V16C13 16.55 12.55 17 12 17ZM11 9H13V7H11V9Z" fill="rgb(133, 100, 4)"/>
  </svg>
)

const StyledSvg = styled.svg`
  fill: ${(props) => props.fill ?? props.theme.backgrounds.blue};
`; 

export const IconCheck = ({fill}) => (
  <StyledSvg width="16" height="12" viewBox="0 0 16 12" xmlns="http://www.w3.org/2000/svg" fill={fill}>
    <path fillRule="evenodd" clipRule="evenodd" d="M15.8026 0.851639C15.5402 0.604792 15.1138 0.604792 14.8513 0.851639L5.33306 9.812L1.14815 5.90222C0.885678 5.65537 0.459327 5.65537 0.196854 5.90222C-0.0656181 6.14907 -0.0656181 6.54869 0.196854 6.79491L4.85941 11.1504C5.11921 11.3941 5.55156 11.3941 5.81137 11.1504L15.8026 1.74433C16.0658 1.49811 16.0658 1.09786 15.8026 0.851639C16.0658 1.09786 15.5402 0.604792 15.8026 0.851639Z" fill={fill}/>
  </StyledSvg>
)

export const IconLogoBlue = ({fill, fill2}) => (
  <svg width="122" height="24" viewBox="0 0 122 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M90.1092 5.47417V9.94965C90.5438 9.38539 91.0274 8.96834 91.5566 8.68797C92.0858 8.4111 92.6571 8.27091 93.2774 8.27091C94.101 8.27091 94.7915 8.46367 95.3487 8.85269C95.9024 9.2382 96.302 9.78844 96.5403 10.4999C96.7155 11.0221 96.8031 11.9088 96.8031 13.1599V19.4368C96.8031 19.6015 96.67 19.7382 96.5017 19.7382H94.3534C94.1887 19.7382 94.052 19.6051 94.052 19.4368V13.8118C94.052 12.438 93.9538 11.5793 93.7541 11.2359C93.4772 10.7697 93.0076 10.5384 92.3417 10.5384C91.6372 10.5384 91.0905 10.7908 90.698 11.2955C90.3055 11.8001 90.1092 12.7394 90.1092 14.1202V19.4368C90.1092 19.6015 89.976 19.7382 89.8078 19.7382H87.6594C87.4947 19.7382 87.358 19.6051 87.358 19.4368V4.57347C87.358 4.40875 87.4912 4.27206 87.6594 4.27206H88.9071C89.5695 4.27206 90.1057 4.80828 90.1057 5.47066L90.1092 5.47417Z" fill={fill}/>
    <path d="M112.01 8.53729H113.058C113.72 8.53729 114.256 9.0735 114.256 9.73589V10.181C114.607 9.58869 115.066 9.12608 115.641 8.78262C116.212 8.44267 116.829 8.27094 117.488 8.27094C118.672 8.27094 119.692 8.7721 120.544 9.77094C121.399 10.7698 121.826 12.1892 121.826 14.0291C121.826 15.9602 121.399 17.4357 120.54 18.4626C119.685 19.4859 118.665 20.0011 117.481 20.0011C116.934 20.0011 116.422 19.8819 115.952 19.6471C115.483 19.4123 114.982 18.9847 114.459 18.3644V23.6985C114.459 23.8633 114.326 23.9999 114.158 23.9999H112.01C111.845 23.9999 111.708 23.8668 111.708 23.6985V8.83519C111.708 8.67047 111.841 8.53379 112.01 8.53379V8.53729ZM114.421 13.9485C114.421 15.2172 114.652 16.153 115.115 16.7523C115.577 17.3516 116.138 17.653 116.797 17.653C117.456 17.653 117.95 17.3761 118.378 16.8224C118.805 16.2686 119.019 15.3644 119.019 14.1097C119.019 12.8551 118.798 12.0385 118.36 11.4707C117.922 10.903 117.386 10.6191 116.752 10.6191C116.086 10.6191 115.532 10.8959 115.087 11.4497C114.645 12.0034 114.421 12.8375 114.421 13.952V13.9485Z" fill={fill}/>
    <path fillRule="evenodd" clipRule="evenodd" d="M108.663 10.174C107.59 9.0875 106.213 8.54428 104.531 8.54428C103.444 8.54428 102.459 8.7826 101.576 9.26274C100.693 9.74288 100.013 10.4368 99.5329 11.3445C99.0527 12.2522 98.8109 13.195 98.8109 14.1658C98.8109 15.438 99.0527 16.5139 99.5329 17.4006C100.013 18.2873 100.717 18.9567 101.639 19.4158C102.564 19.8749 103.535 20.1027 104.552 20.1027C106.199 20.1027 107.562 19.5525 108.645 18.452C109.728 17.3515 110.271 15.9637 110.271 14.292C110.271 12.6202 109.735 11.2604 108.659 10.174H108.663ZM106.472 16.8434C105.953 17.4251 105.309 17.7195 104.541 17.7195C103.774 17.7195 103.129 17.4287 102.606 16.8434C102.084 16.2616 101.821 15.4205 101.821 14.3235C101.821 13.2265 102.084 12.3854 102.606 11.8036C103.129 11.2219 103.774 10.9275 104.541 10.9275C105.309 10.9275 105.95 11.2184 106.472 11.8036C106.991 12.3854 107.25 13.2195 107.25 14.3025C107.25 15.3854 106.991 16.2616 106.472 16.8434Z" fill={fill}/>
    <path fillRule="evenodd" clipRule="evenodd" d="M84.7888 12.7744C84.3682 12.105 83.7865 11.5758 83.047 11.1868C82.304 10.8013 81.158 10.4263 79.6089 10.0653C78.0598 9.7043 77.082 9.35734 76.6825 9.02089C76.3671 8.75804 76.2094 8.44262 76.2094 8.07463C76.2094 7.67159 76.3776 7.34565 76.714 7.10733C77.2362 6.73233 77.9617 6.54308 78.8869 6.54308C79.8122 6.54308 80.457 6.71831 80.9056 7.06878C81.2035 7.3036 81.4348 7.63654 81.5925 8.07112C81.7538 8.50921 82.1953 8.77907 82.665 8.75804L84.7818 8.66692C84.8834 8.66342 84.9605 8.5758 84.957 8.47766C84.8694 7.12836 84.3472 6.04191 83.3904 5.22182C82.5914 4.5384 81.4769 4.12835 80.0575 3.99167V3.31527C80.0575 2.99634 79.7981 2.737 79.4792 2.737H78.3051C77.9862 2.737 77.7269 2.99634 77.7269 3.31527V4.00569C77.0154 4.0863 76.3741 4.24051 75.8168 4.47532C74.9582 4.8363 74.3028 5.36551 73.8472 6.05593C73.3916 6.74635 73.1638 7.49285 73.1638 8.28491C73.1638 9.51855 73.6474 10.5665 74.6182 11.4251C75.3051 12.0349 76.5037 12.5501 78.2105 12.9672C79.5388 13.2931 80.3869 13.5209 80.7619 13.6471C81.3087 13.8398 81.6907 14.0641 81.908 14.3235C82.1252 14.5828 82.2374 14.8982 82.2374 15.2662C82.2374 15.841 81.978 16.3422 81.4559 16.7732C80.9372 17.2043 80.1626 17.4181 79.1358 17.4181C78.1685 17.4181 77.3974 17.1763 76.8262 16.6926C76.4196 16.3492 76.1077 15.862 75.8974 15.2382C75.7362 14.7651 75.2666 14.4672 74.7689 14.5162L72.7818 14.709C72.6801 14.7195 72.6065 14.8106 72.6205 14.9123C72.8519 16.5665 73.4827 17.8352 74.5131 18.7148C75.3227 19.4053 76.3951 19.8328 77.7304 20.0011V20.702C77.7304 21.0209 77.9897 21.2803 78.3087 21.2803H79.4827C79.8016 21.2803 80.061 21.0209 80.061 20.702V20.0501C81.0178 19.98 81.8449 19.8013 82.5388 19.5139C83.457 19.1354 84.1685 18.5536 84.6696 17.7721C85.1708 16.9905 85.4232 16.1529 85.4232 15.2592C85.4232 14.2744 85.2129 13.4438 84.7923 12.7744H84.7888Z" fill={fill}/>
    <path fillRule="evenodd" clipRule="evenodd" d="M69.901 15.1787H63.596C63.617 16.0444 63.8554 16.7173 64.3075 17.1974C64.7631 17.6775 65.3273 17.9194 66.0072 17.9194C66.4699 17.9194 66.8554 17.7967 67.1708 17.5479C67.4582 17.3201 67.679 16.9696 67.8402 16.4895C67.8682 16.4053 67.9488 16.3528 68.0365 16.3703L70.6089 16.7979C70.7175 16.8154 70.7841 16.931 70.7456 17.0327C70.3671 18 69.7958 18.7465 69.0318 19.2652C68.2187 19.8224 67.1988 20.0993 65.9757 20.0993C64.0411 20.0993 62.6077 19.4719 61.6755 18.2208C60.943 17.2184 60.575 15.9532 60.575 14.4252C60.575 12.5993 61.0586 11.1693 62.0224 10.1355C62.9862 9.10159 64.2058 8.5864 65.6813 8.5864C67.339 8.5864 68.6463 9.12612 69.6031 10.2091C70.3951 11.1028 70.8437 12.389 70.9524 14.0712C70.9909 14.674 70.5073 15.1857 69.8974 15.1857L69.901 15.1787ZM67.3916 11.4708C66.971 11.0327 66.4628 10.8119 65.86 10.8119C65.2187 10.8119 64.686 11.0432 64.2654 11.5058C63.8449 11.9684 63.6381 12.5993 63.6486 13.3948H68.0505C68.0294 12.5502 67.8087 11.9088 67.3916 11.4708ZM57.1544 20.0958C56.5867 20.0958 56.075 20.0012 55.6194 19.8119C55.1638 19.6226 54.8308 19.3808 54.617 19.0794C54.4032 18.7815 54.256 18.375 54.1754 17.8668C54.1088 17.5058 54.0738 16.7733 54.0738 15.6729V8.05719L54.1229 4.12494C54.1229 4.0233 54.207 3.94269 54.3086 3.94269L56.089 3.91816C56.7163 3.91115 57.2315 4.41232 57.2315 5.03265V8.49528H58.2549C58.8787 8.49528 59.3834 8.99645 59.3834 9.60976V10.9766H57.2315V15.2838C57.2315 16.2441 57.2526 16.8049 57.2946 16.9626C57.3367 17.1203 57.4278 17.2535 57.575 17.3551C57.7222 17.4603 57.8974 17.5093 58.1077 17.5093C58.36 17.5093 58.707 17.4357 59.1521 17.285C59.2642 17.2465 59.3869 17.3236 59.3974 17.4392L59.6252 19.4825C59.6357 19.5666 59.5867 19.6472 59.5096 19.6752C58.8086 19.9486 58.0236 20.0853 57.1544 20.0853V20.0958ZM48.2911 12.9392C49.8612 13.2932 50.9546 13.7243 51.5785 14.2359C52.1918 14.7546 52.5002 15.4766 52.5002 16.4053C52.5002 17.4147 52.0726 18.2839 51.221 19.0093C50.3693 19.7348 49.1077 20.0993 47.4359 20.0993C45.9184 20.0993 44.7198 19.7944 43.8331 19.1881C43.0025 18.6168 42.4418 17.8528 42.1509 16.8995C42.1193 16.7979 42.1894 16.6962 42.2946 16.6787L44.2362 16.3843C44.6742 16.3177 45.0878 16.549 45.2981 16.9345C45.4313 17.1834 45.6065 17.3867 45.8203 17.5514C46.2058 17.8458 46.742 17.993 47.4359 17.993C48.1964 17.993 48.7712 17.8563 49.1567 17.5794C49.4161 17.3867 49.5457 17.1273 49.5457 16.8014C49.5457 16.5806 49.4757 16.3983 49.3355 16.2511C49.1883 16.1145 48.8588 15.9848 48.3507 15.8656C45.9745 15.3469 44.4675 14.8738 43.8331 14.4462C42.9534 13.8504 42.5119 13.0268 42.5119 11.9684C42.5119 11.0151 42.8939 10.2126 43.6544 9.5607C44.4149 8.91233 45.596 8.5864 47.1976 8.5864C48.7992 8.5864 49.8542 8.83173 50.5936 9.32238C51.2841 9.7815 51.7747 10.4439 52.0656 11.313C52.0972 11.4112 52.0341 11.5198 51.9289 11.5373L50.1661 11.8598C49.756 11.9334 49.3214 11.7827 49.0866 11.4427C48.9745 11.278 48.8343 11.1378 48.6696 11.0257C48.3366 10.7979 47.8635 10.6822 47.2502 10.6822C46.4757 10.6822 45.9184 10.7908 45.582 11.0046C45.3577 11.1553 45.2455 11.3551 45.2455 11.5969C45.2455 11.8037 45.3436 11.9824 45.5399 12.1261C45.8063 12.3189 46.7245 12.5923 48.2911 12.9462V12.9392ZM40.6859 20.1168H38.0259C37.9277 20.1168 37.8436 20.0362 37.8436 19.9381V8.72308C37.8471 8.62495 37.9277 8.54434 38.0294 8.54434H39.7887C40.388 8.54434 40.8717 9.02799 40.8717 9.62729V19.9416C40.8682 20.0397 40.7875 20.1203 40.6859 20.1203V20.1168ZM30.4733 10.1039C32.0223 10.4649 33.1684 10.8399 33.9079 11.2254C34.6508 11.6109 35.2291 12.1401 35.6497 12.8095C36.0702 13.4789 36.2805 14.3095 36.2805 15.2944C36.2805 16.1881 36.0282 17.0257 35.527 17.8037C35.0258 18.5853 34.3144 19.1635 33.3962 19.542C32.4779 19.9205 31.3354 20.1098 29.9651 20.1098C27.9709 20.1098 26.4394 19.6542 25.374 18.743C24.3436 17.8633 23.7127 16.5981 23.4849 14.9439C23.4709 14.8423 23.5445 14.7511 23.6461 14.7406L25.6333 14.5479C26.1345 14.4988 26.6041 14.8002 26.7618 15.2698C26.9721 15.8937 27.284 16.3808 27.6905 16.7243C28.2618 17.2079 29.0293 17.4462 29.9966 17.4462C31.0235 17.4462 31.7945 17.2325 32.3132 16.8014C32.8319 16.3738 33.0913 15.8691 33.0913 15.2944C33.0913 14.9264 32.9826 14.6109 32.7618 14.3516C32.5445 14.0923 32.1625 13.868 31.6158 13.6752C31.2443 13.549 30.3927 13.3212 29.0679 12.9953C27.3611 12.5782 26.1625 12.063 25.4756 11.4532C24.5083 10.5946 24.0247 9.55019 24.0247 8.31303C24.0247 7.51747 24.2525 6.77448 24.7081 6.08405C25.1637 5.39363 25.819 4.86443 26.6777 4.50344C27.5328 4.14246 28.5702 3.96022 29.7793 3.96022C31.7595 3.96022 33.249 4.38779 34.2478 5.24644C35.2046 6.06653 35.7268 7.15299 35.8144 8.50229C35.8214 8.60042 35.7408 8.68803 35.6392 8.69154L33.5223 8.78266C33.0527 8.80369 32.6111 8.53032 32.4499 8.09574C32.2887 7.66116 32.0609 7.32822 31.763 7.0934C31.3144 6.74294 30.6415 6.5677 29.7478 6.5677C28.8541 6.5677 28.0971 6.75696 27.5749 7.13196C27.2384 7.37378 27.0702 7.69621 27.0702 8.09925C27.0702 8.46724 27.2279 8.78266 27.5434 9.04552C27.9464 9.37846 28.9207 9.72542 30.4698 10.0899L30.4733 10.1039Z" fill={fill}/>
    <path fillRule="evenodd" clipRule="evenodd" d="M39.3646 7.24059C38.3378 7.24059 37.5037 6.40998 37.5037 5.39363C37.5037 4.37727 38.3378 3.54666 39.3646 3.54666C40.3915 3.54666 41.2256 4.37727 41.2256 5.39363C41.2256 6.40998 40.3915 7.24059 39.3646 7.24059ZM39.3646 4.75227C39.0072 4.75227 38.7198 5.03965 38.7198 5.39363C38.7198 5.7476 39.0107 6.03498 39.3646 6.03498C39.7186 6.03498 40.0095 5.7476 40.0095 5.39363C40.0095 5.03965 39.7186 4.75227 39.3646 4.75227Z" fill={fill}/>
    <path d="M12.2631 14.2465C12.0494 14.2359 11.8426 14.3516 11.7515 14.5444C11.3975 15.3084 10.63 15.8411 9.73277 15.8411C8.71641 15.8411 7.86477 15.1542 7.59491 14.2254C8.13814 13.9836 8.52366 13.4474 8.53767 12.82C8.5552 11.9684 7.86127 11.2359 7.00963 11.2114C6.15799 11.1869 5.38696 11.9018 5.38696 12.785C5.38696 13.4894 5.85659 14.0817 6.49795 14.2815C6.80986 15.7815 8.14165 16.91 9.73277 16.91C11.047 16.91 12.186 16.139 12.7153 15.0245C12.8835 14.674 12.6487 14.264 12.2596 14.2429L12.2631 14.2465ZM6.96407 12.2803C7.24444 12.2803 7.46874 12.5081 7.46874 12.785C7.46874 13.0619 7.24094 13.2897 6.96407 13.2897C6.6872 13.2897 6.45939 13.0619 6.45939 12.785C6.45939 12.5081 6.6872 12.2803 6.96407 12.2803Z" fill={fill2 ?? "#0B02C1"}/>
    <path d="M15.4523 23.993H4.01306C2.86352 23.993 1.76656 23.5093 1.00604 22.6612C0.266553 21.8376 -0.0944285 20.7406 0.0212261 19.6472L1.25137 7.95203C1.44062 6.14712 2.8495 4.7137 4.67544 4.45786C5.11353 4.39828 5.52007 4.70319 5.57965 5.14127C5.63923 5.57936 5.33433 5.9859 4.89624 6.04548C3.80278 6.19618 2.95815 7.05133 2.846 8.11675L1.61586 19.8119C1.54576 20.4602 1.75254 21.0911 2.19764 21.5817C2.65675 22.0899 3.31563 22.3808 4.01306 22.3808H15.4523C16.1463 22.3808 16.8051 22.0899 17.2643 21.5852C17.7059 21.0946 17.9161 20.4708 17.8495 19.8224L16.6755 8.12726C16.5668 7.04432 15.6801 6.16464 14.5657 6.03497C14.1241 5.9859 13.8086 5.58637 13.8612 5.14828C13.9138 4.7102 14.2993 4.39127 14.7479 4.44384C16.6054 4.65763 18.0879 6.14011 18.2701 7.96955L19.4442 19.6647C19.5528 20.7546 19.1918 21.8481 18.4524 22.6647C17.6918 23.5058 16.5984 23.9895 15.4523 23.9895V23.993Z" fill={fill2 ?? "#0B02C1"}/>
    <path d="M12.2455 6.52572C11.8039 6.52572 11.4429 6.16824 11.4429 5.72315V3.31193C11.4429 2.36917 10.6754 1.60164 9.73612 1.60164C8.79686 1.60164 8.02934 2.36917 8.02934 3.31193V5.72315C8.02934 6.16474 7.66835 6.52572 7.22676 6.52572C6.78517 6.52572 6.42419 6.16824 6.42419 5.72315V3.31193C6.42419 1.48599 7.91018 0 9.73612 0C11.5621 0 13.048 1.48599 13.048 3.31193V5.72315C13.048 6.16474 12.6871 6.52572 12.2455 6.52572Z" fill={fill2 ?? "#0B02C1"}/>
    <path d="M12.9009 13.3773C13.226 13.3773 13.4896 13.1137 13.4896 12.7885C13.4896 12.4633 13.226 12.1997 12.9009 12.1997C12.5757 12.1997 12.3121 12.4633 12.3121 12.7885C12.3121 13.1137 12.5757 13.3773 12.9009 13.3773Z" fill={fill2 ?? "#0B02C1"}/>
  </svg>
)

export const IconLogoRed = ({fill, fill2}) => (
  <svg width="104" height="40" viewBox="0 0 104 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.5223 10.6592C13.029 10.5498 13.6443 10.5498 14.151 10.5498C14.9834 10.5498 15.8521 10.6592 16.6845 10.8414C17.1912 10.9508 17.6979 11.0966 18.1323 11.3518C18.3132 11.4611 18.458 11.5705 18.6752 11.6069C19.1457 11.6798 19.3266 11.2788 19.3628 10.8779C19.399 10.2218 19.3266 9.45628 19.58 9.31047C19.8333 9.16467 21.1363 8.54499 21.643 7.92532C22.1859 7.30564 22.765 6.83178 22.6926 5.59243C22.6202 4.38953 21.7154 3.5147 21.3897 3.25954C21.0639 3.00438 20.2315 2.63986 19.58 2.63986C19.1095 2.63986 18.7114 2.71277 18.277 2.85857H18.2408L18.2046 2.82212C17.8427 1.43697 16.395 0.525683 15.0196 0.489232C12.6309 0.452781 11.8708 1.47342 11.5813 2.02019C11.2917 2.56696 11.2917 2.85857 11.2917 2.89502C11.2917 2.93148 11.2917 2.93148 11.2194 2.93148C11.147 2.93148 9.77162 2.63986 8.72202 3.18664C7.67241 3.73341 7.49145 4.64469 7.52764 5.33727C7.56383 6.02985 8.10673 7.15984 9.01156 7.92532C9.9164 8.6908 10.3869 8.90951 10.5679 9.71144C10.7488 10.5134 10.8212 10.2218 10.8212 10.1853C10.8212 9.74789 10.8574 9.34692 10.7488 8.94596C10.6041 8.43564 10.3145 7.96177 9.95259 7.59726C9.44588 7.05048 8.75821 6.61307 8.50486 5.92049C8.36009 5.55598 8.39628 5.15501 8.50486 4.7905C8.64963 4.42598 8.90299 4.13437 9.22872 3.95212C9.73543 3.6605 10.3507 3.69696 10.8936 3.76986C11.2917 3.84276 11.7261 3.91566 12.0518 4.17082C12.088 4.20727 12.1604 4.20727 12.1604 4.17082C12.1604 4.17082 12.1604 4.13437 12.1604 4.09792C11.9794 3.5876 11.907 3.11373 12.1242 2.56696C12.3052 2.09309 12.6671 1.69213 13.1014 1.43697C14.1872 0.817295 15.7435 1.07245 16.6845 1.91084C16.9379 2.12955 17.336 2.53051 17.5532 3.04083C17.7703 3.55115 17.8789 3.91566 17.8789 4.09792C17.8789 4.28018 17.9513 4.24373 17.9875 4.20727C18.277 3.76986 18.639 3.5147 19.1819 3.4418C19.761 3.33244 20.4124 3.47825 20.8829 3.84276C22.1135 4.7905 21.9687 6.75887 20.702 7.59726C20.0143 8.03467 19.3628 8.14403 18.7837 8.14403C18.2046 8.14403 16.1416 7.74306 15.6349 7.70661C15.092 7.67016 14.3682 7.70661 14.0424 7.77951C13.97 7.81596 13.9338 7.85242 14.1872 7.85242C14.4406 7.85242 16.4674 8.03467 17.4446 8.6179C18.4218 9.20112 18.639 9.78434 18.6752 10.076C18.6752 10.3311 18.7114 10.3311 18.5304 10.3311C18.3494 10.3311 15.9969 9.93015 14.6939 9.93015C13.3909 9.93015 12.848 10.1489 12.5585 10.2947C12.3052 10.4769 12.3413 10.5134 12.3775 10.5134C12.4499 10.6956 12.5223 10.6592 12.5223 10.6592Z" fill={fill}/>
<path d="M12.668 3.369C12.7404 2.78578 13.0661 2.23901 13.5728 1.98385C13.8623 1.83804 14.2243 1.76514 14.5862 1.76514C14.8758 1.76514 15.2015 1.80159 15.491 1.91094C15.5634 1.94739 15.5996 1.94739 15.6358 1.98385C15.6358 1.98385 15.672 2.0203 15.6358 2.0203H15.5996C15.2377 2.0203 14.8758 1.98385 14.5138 2.05675C14.1519 2.0932 13.79 2.20255 13.4642 2.38481C13.1385 2.56707 12.8851 2.85868 12.7765 3.22319C12.7765 3.2961 12.7404 3.33255 12.7042 3.40545C12.7042 3.40545 12.7042 3.4419 12.668 3.4419C12.7042 3.4419 12.7042 3.40545 12.668 3.369C12.668 3.40545 12.668 3.40545 12.668 3.369Z" fill={fill}/>
<path d="M0.831746 18.7878C0.831746 18.7878 0.43362 23.3442 0.5422 25.3126C0.5422 25.7135 0.469814 28.7026 5.10255 28.7026C9.77148 28.7026 13.1013 27.5726 13.4994 27.4997C13.8975 27.4268 15.3814 26.8071 15.7796 26.7706C16.2139 26.7706 16.5034 26.8071 17.1187 27.0622C17.734 27.3174 18.1683 27.4632 18.856 27.1351C19.5075 26.8071 22.0772 25.2397 22.0772 25.2397C22.0772 25.2397 22.3305 25.0574 22.222 24.8752C22.1134 24.7294 21.7514 24.8752 21.6791 24.9116C21.6067 24.9481 19.3265 26.1145 19.2179 26.151C19.1093 26.1874 18.675 26.3332 18.5302 26.1145C18.3855 25.8958 18.6026 25.5313 18.7836 25.4584C18.9646 25.3855 21.7152 24.219 21.7876 24.1826C21.86 24.1461 21.9686 24.0003 21.8962 23.891C21.8238 23.7452 21.6429 23.7816 21.4981 23.8545C21.3533 23.891 18.9284 24.7294 18.7836 24.7658C18.6388 24.8023 18.0959 24.9481 18.0235 24.5836C17.9511 24.219 18.6388 24.0368 18.8198 24.0003C19.0008 23.9639 21.1723 23.3807 21.3533 23.3078C21.4981 23.2348 21.6067 23.1255 21.5343 23.0161C21.4981 22.8703 21.2447 22.9068 20.919 22.9797C20.6294 23.0161 18.0597 23.4171 17.915 23.4536C17.7702 23.49 17.0825 23.6358 16.793 24.1097C16.4672 24.5836 16.2501 25.5313 15.8157 25.75C15.3814 26.0052 14.4042 26.3697 13.8251 26.479C13.246 26.5884 10.7487 27.281 9.12 27.3174C7.45511 27.3539 5.97119 27.3539 4.95778 26.5155C3.94436 25.7135 3.69101 24.8387 3.72721 23.8545C3.7634 22.8703 3.72721 21.1571 5.42829 18.97C7.12937 16.7829 9.40954 15.5436 10.4591 15.252C11.5088 14.9604 13.2098 14.523 16.5034 14.5959C19.797 14.6323 22.9096 14.9968 23.163 14.9968C23.4163 14.9968 24.285 15.252 25.1898 14.8875C26.0584 14.4865 23.1992 14.0855 22.5839 14.0126C21.9686 13.9397 18.1321 13.5023 14.368 13.5388C10.6401 13.5752 6.91221 13.7939 6.91221 13.7939V16.1997H3.7634V18.7878H0.831746Z" fill={fill}/>
<path d="M3.04023 14.9971H0V18.059H3.04023V14.9971Z" fill={fill}/>
<path d="M6.22597 12.8828H3.65625V15.4709H6.22597V12.8828Z" fill={fill}/>
<path d="M4.59727 11.1694H3.65625V12.1172H4.59727V11.1694Z" fill={fill}/>
<path d="M3.07505 12.3359H1.41016V14.0127H3.07505V12.3359Z" fill={fill}/>
<path d="M15.4549 37.6698C15.4549 37.6698 15.5634 38.1072 15.0929 38.1072C14.6224 38.1072 13.9709 38.1072 13.9709 38.1072C13.9709 38.1072 13.5004 38.1801 13.5366 37.7427C13.5728 37.0501 13.2833 36.9408 13.5366 36.795C13.609 36.7585 13.609 36.795 13.609 36.6492C13.609 36.5398 13.5366 36.4305 13.4642 36.394C13.3557 36.3211 13.5004 36.2117 13.609 36.2482C13.8624 36.3211 13.5366 35.8108 13.8624 35.8108C14.1881 35.8108 15.1653 35.8108 15.1653 35.8108C15.1653 35.8108 15.4549 35.7743 15.4549 36.1024C15.4549 36.4305 15.4911 36.5398 15.5996 36.6127C15.7082 36.6856 15.8168 36.7585 15.8168 36.8679C15.8168 36.9772 15.6358 37.0866 15.5634 37.1595C15.5273 37.2688 15.4549 37.4146 15.4549 37.6698Z" fill={fill2 ?? "#03134F"}/>
<path d="M16.0323 36.5763C16.0323 36.5763 15.6342 36.2482 16.1047 35.9202C16.5752 35.5557 17.842 34.7173 18.4211 34.4621C19.0001 34.207 19.2173 34.3163 19.3259 34.5715C19.4345 34.8266 20.3393 36.6857 19.6878 39.055C19.5792 39.4924 19.2173 39.5289 18.7468 39.3831C18.2763 39.2373 16.72 38.6905 16.3218 38.3624C15.9237 38.0344 15.8513 37.5969 15.9961 37.3782C16.1409 37.1595 16.3218 37.1231 16.3218 36.9773C16.3942 36.7586 16.0323 36.5763 16.0323 36.5763Z" fill={fill2 ?? "#03134F"}/>
<path d="M12.3787 35.8109C12.451 35.8109 12.7044 35.9567 12.813 36.0296C12.9216 36.1025 13.0663 36.1389 13.1025 36.1025C13.1387 36.066 13.0663 35.9931 12.9578 35.8838C12.8492 35.7744 9.62798 33.4051 9.08508 35.0089C8.54218 36.6128 8.86792 38.6176 8.9403 39.128C9.01269 39.6383 9.41082 39.4925 9.73656 39.4925C10.0985 39.4925 11.4014 38.9457 12.2339 38.5083C13.0301 38.1073 13.0301 37.9615 13.1025 37.8522C13.1749 37.7428 13.1025 37.4147 13.1025 37.2325C13.1025 37.0502 12.7406 37.3054 12.7406 37.3054C12.5234 37.4512 11.3291 37.8886 11.1481 37.9615C10.9671 37.998 11.0757 37.8522 11.1481 37.8157C11.2205 37.7792 12.0891 37.3783 12.2339 37.3054C12.3787 37.2325 12.3787 37.1231 12.3425 37.0502C12.3063 36.9773 12.1977 36.9773 12.2339 36.9044C12.2701 36.8315 12.5234 36.9409 12.7406 36.9409C12.9578 36.9409 13.0663 36.7222 13.0663 36.6493C13.0663 36.5764 13.0663 36.467 12.9939 36.3576C12.9216 36.2483 12.2701 35.9567 12.2339 35.8473C12.1615 35.8109 12.3063 35.8109 12.3787 35.8109Z" fill={fill2 ?? "#03134F"}/>
<path d="M28.5938 30.1606C28.5938 30.1242 28.5938 30.0877 28.5938 30.0513C28.63 29.9419 28.63 29.7961 28.63 29.6867C28.63 29.6503 28.63 29.5774 28.63 29.5409C28.8109 24.3284 28.6662 22.4329 28.63 21.7768C28.5938 21.1207 28.8833 17.3297 23.1286 17.6578C17.3739 18.0223 13.5374 19.5532 13.5374 19.5532C13.5374 19.5532 12.9221 19.8084 12.4154 19.6262C11.9087 19.4439 10.8953 18.9336 9.80948 19.5897C8.72368 20.2094 7.99981 21.0478 7.67408 21.7039C7.34834 22.36 7.63788 23.0161 7.67408 23.089C7.71027 23.1619 8.10839 23.8181 9.23038 23.7816C10.3524 23.7452 11.2572 23.5629 11.8363 23.1619C12.4154 22.7245 12.8497 22.3236 13.1393 21.3758C13.4288 20.4281 13.7545 20.3552 14.0441 20.2823C14.2974 20.2094 16.2519 19.4803 19.6178 19.0794C22.9838 18.6784 24.1782 19.4439 24.3592 19.5532C24.5401 19.6626 25.8793 20.3552 25.8069 22.1777C25.7707 24.0368 25.3364 29.1764 18.3149 31.1083C16.8672 31.5093 14.1165 31.6551 11.3658 31.6916C11.0762 31.6916 10.7867 31.6916 10.5333 31.6916V31.728C7.16737 31.728 3.98236 31.5822 3.54805 31.4364C2.7156 31.1448 2.49844 30.7074 2.35367 29.869C2.1727 29.0306 1.95554 28.7755 1.52122 28.5203C1.0869 28.2651 0.507812 28.0464 0.507812 28.3016V28.9577V29.4316C0.507812 29.9783 0.616392 30.4887 0.905938 30.9261C1.26787 31.5458 2.02793 32.2019 3.43947 32.3841C4.52526 32.5664 7.27595 32.6758 10.4971 32.6758C10.6781 32.6758 10.8953 32.6758 11.1124 32.6758C11.1486 32.6758 11.1848 32.6758 11.1848 32.6758C11.2572 32.6758 11.2934 32.6758 11.3658 32.6758C11.4744 32.6758 11.5468 32.6758 11.6553 32.6758C16.0709 32.6758 24.5401 32.6029 25.6983 32.3841C27.1098 32.2019 27.8699 31.5458 28.2318 30.9261C28.3404 30.7803 28.4128 30.598 28.449 30.4522C28.449 30.4158 28.449 30.4158 28.4852 30.3793C28.5214 30.3064 28.5576 30.2335 28.5938 30.1606ZM11.8725 20.0636C11.8001 20.0636 10.5333 19.6991 9.55612 20.2458C9.26658 20.3916 8.97703 20.7197 8.94084 20.6468C8.94084 20.5739 8.94084 20.5374 8.94084 20.5374C8.94084 20.5374 9.73709 19.5532 10.8591 19.5532C11.5106 19.5532 11.8363 19.7355 11.9087 19.772C12.0173 19.8813 12.0173 20.0636 11.8725 20.0636Z" fill={fill2 ?? "#03134F"}/>
<path d="M41.6581 19.2613C42.1286 19.0791 42.5629 18.7146 42.9972 18.423C43.7935 17.8762 44.4088 17.1472 45.1326 16.5275C45.567 16.163 45.8927 15.762 46.0375 15.1788C45.8565 14.0852 44.9879 13.6114 44.264 13.0646C43.1782 12.9552 43.1782 12.9552 42.3458 13.3562C41.4771 13.7936 40.6085 14.2675 39.8122 14.8507C39.5589 15.0694 39.2331 15.2517 39.016 15.4704C38.3645 16.1994 37.6768 16.9285 37.1339 17.7304C36.1567 19.152 35.5052 20.7194 34.8176 22.2504C34.4918 22.9794 34.528 23.7813 34.709 24.5468C34.8176 25.13 35.1071 25.6403 35.65 25.9684C35.831 26.0778 35.9758 26.2236 36.1567 26.3329C36.772 26.5152 37.4235 26.8068 38.075 26.8797C38.7264 26.9161 39.3417 26.989 39.9932 27.0619C40.6809 27.0984 41.26 27.3536 41.6943 27.9003C41.7305 28.6294 41.4409 29.2855 41.079 29.9052C40.4275 31.0351 39.6313 32.0193 38.6902 32.9306C38.4731 33.1493 38.2921 33.368 38.075 33.5867L38.0388 33.5503C38.1473 33.6596 38.1835 33.769 38.1112 33.9513C37.3873 34.498 36.5548 35.0083 35.6862 35.4093C34.7814 35.8467 33.8765 36.2842 32.8993 36.758C32.646 36.6487 32.284 36.6487 31.8859 36.6487C31.343 36.6851 30.9087 36.5393 30.4744 36.1748C30.4382 36.8309 30.9811 37.0496 31.3792 37.3412C31.7773 37.4141 32.1393 37.487 32.5374 37.5599C34.2385 37.1954 35.9757 36.7216 37.5321 35.8832C39.5951 34.7532 41.1514 33.1129 42.2372 31.0716C42.9972 29.6864 42.9972 28.2648 41.8391 27.0255C41.6943 26.8432 41.5133 26.661 41.3685 26.4787C40.6809 25.7132 39.8484 25.2758 38.7988 25.13C38.0026 25.0207 37.2063 24.8384 36.4101 24.6926C36.1567 24.6561 35.9034 24.5468 35.7224 24.3281C35.6138 24 35.7224 23.7084 35.8672 23.4533C36.5186 21.9952 37.2063 20.5371 38.1473 19.2613C38.7626 18.423 39.4503 17.621 40.2827 16.9649C40.8256 16.5639 41.3685 16.1265 41.9476 15.762C42.5991 15.3246 43.2868 14.9601 44.083 14.8143C44.2278 14.7778 44.3726 14.8143 44.4088 15.033C43.5763 16.4181 42.3096 17.4752 41.4047 18.7146C41.4047 19.1155 41.4771 19.1884 41.6581 19.2613Z" fill={fill2 ?? "#03134F"}/>
<path d="M45.9638 31.3633C46 31.1081 46.0362 30.8165 46.1086 30.452C45.7828 29.7959 45.7466 29.1033 45.819 28.4107C46.1086 25.9685 46.5429 23.5627 47.7011 21.3027C47.882 20.9746 47.9906 20.6466 47.8097 20.2456C47.3391 19.8446 46.8324 19.4437 46.0362 19.4072C45.6381 20.355 45.2037 21.2662 44.9866 22.2504C44.5523 24.0366 44.2627 25.8227 44.1541 27.6088C44.0817 28.5201 44.1541 29.4678 44.5161 30.3062C44.697 30.7436 44.9504 31.1446 45.4209 31.3633C45.5657 31.4362 45.7466 31.582 45.9638 31.3633Z" fill={fill2 ?? "#03134F"}/>
<path d="M46.544 18.3137C46.6525 18.4231 46.7973 18.496 47.0145 18.4595C47.5574 17.9492 48.1365 17.366 48.426 16.637C48.5708 16.1631 48.8603 15.6892 48.6432 15.1789C48.0279 14.6321 47.9917 14.6321 47.2678 14.4863C46.6163 15.9444 46.3268 17.366 46.544 18.3137Z" fill={fill2 ?? "#03134F"}/>
<path d="M51.2495 27.4267C50.417 26.7706 49.6208 25.8593 49.295 25.1303C49.5122 24.4741 49.8017 23.818 50.3084 23.3077C50.6704 22.9067 51.0685 22.5422 51.4304 22.1777C51.7924 21.8496 51.9371 21.4487 51.7562 21.0113C51.1771 20.428 51.1771 20.428 50.5618 20.2822C49.8017 20.9748 49.0779 21.5945 48.535 22.4329C47.8835 23.49 47.7749 24.7657 48.6436 25.9322C49.2588 26.7706 50.0551 27.4267 50.8152 28.1557C50.0189 28.7754 49.2588 29.4315 48.4626 30.0512C47.8111 30.5251 47.2682 31.0354 46.7253 31.6186C46.0376 32.3841 45.4224 33.2225 45.1328 34.2067C45.6395 35.7376 45.7119 35.7376 47.1234 36.2479C47.7387 36.2844 48.2454 35.9928 48.8245 35.7741C49.4036 35.5554 49.7655 35.2273 50.0913 34.717C50.7066 33.7692 51.2857 32.7851 51.72 31.7644C52.1543 30.6709 52.3715 29.5409 51.7924 28.4109C51.72 28.3015 51.72 28.1557 51.72 28.1193C51.8286 27.5725 52.4077 27.4632 52.5886 26.9528C52.2991 26.9528 52.1181 27.0986 51.9371 27.1715C51.72 27.2444 51.539 27.4632 51.2495 27.4267ZM50.417 30.1606C50.0189 31.1812 49.5122 32.1289 48.9331 33.0767C48.8969 33.1496 48.8245 33.2589 48.7883 33.2954C48.1007 33.9515 47.3406 34.4254 46.1824 34.6805C47.1234 32.8215 48.2454 31.3635 49.5484 30.0877C49.8379 29.796 50.0913 29.4315 50.5618 29.3222C50.6704 29.6502 50.5256 29.9418 50.417 30.1606Z" fill={fill2 ?? "#03134F"}/>
<path d="M54 27.9375C54.0377 27.9375 54.0377 27.9375 54 27.9375C54.0377 27.9004 54.0377 27.9004 54 27.9375Z" fill={fill}/>
<path d="M60.9497 26.8072C60.5516 27.2446 60.1534 27.6456 59.7915 28.083C58.4885 29.6868 56.9684 31.1084 55.4483 32.4936C55.3035 32.6394 55.1588 32.7852 54.9054 32.6759C54.7606 31.9468 54.7606 31.2178 55.0864 30.4888C55.7017 29.1036 56.317 27.7549 56.9684 26.4062C57.6199 25.0211 58.3438 23.6724 58.8867 22.2508C59.2486 21.3759 59.6829 20.5375 60.1534 19.7356C60.8773 19.5169 61.565 19.5169 62.2164 19.5169C62.9765 19.5169 63.7004 19.5534 64.4604 19.5534C65.2929 19.5534 66.1615 19.5169 66.994 19.6992C67.1749 19.7356 67.3921 19.6627 67.573 19.6263C67.6092 19.6263 67.6454 19.5169 67.6816 19.4804C67.6816 19.2982 67.5731 19.1524 67.4283 19.0795C67.3559 19.1159 67.3197 19.1524 67.2111 19.1888C66.9578 19.0795 66.7044 18.8608 66.4149 18.8243C65.3653 18.6421 64.2795 18.4963 63.1937 18.314C62.4698 18.5692 61.7459 18.1317 60.9497 18.2411C61.0945 18.0588 61.203 17.9859 61.2754 17.8766C61.2392 17.6943 61.203 17.5485 61.1668 17.3663C61.4564 16.7101 61.7459 16.054 61.9993 15.3979C61.9631 14.1585 61.7097 13.6847 60.8773 13.3931C60.3706 14.9605 59.5743 16.3456 58.8505 17.6943C58.5247 17.9495 58.2352 17.9859 57.9818 17.9859C57.077 18.0588 56.1722 18.1317 55.2312 18.2411C54.3625 18.3505 53.4939 18.4963 52.6252 18.6421C52.2995 18.715 51.9738 18.8608 51.6842 19.0066C51.4309 19.1159 51.2861 19.3711 51.3585 19.7356C51.648 20.173 51.9738 20.574 52.5167 20.7562C53.3853 20.6469 54.1816 20.4282 55.014 20.2459C55.8826 20.0637 56.7513 19.9908 57.5837 19.8814C57.6923 20.2095 57.5113 20.3917 57.4389 20.6104C56.8237 21.9227 56.2084 23.2714 55.5569 24.5836C55.1226 25.4949 54.7244 26.4427 54.073 27.2446C54.0368 27.281 54.073 27.3904 54.0368 27.4269C54.1092 27.5727 54.2177 27.7185 54.0368 27.8643C53.9282 28.411 53.7834 28.9214 53.711 29.4681C53.5301 30.7804 53.5663 32.0562 54.1092 33.2591C54.4349 33.9881 54.8692 34.6078 55.7017 34.79C56.4979 34.6078 57.1132 34.2068 57.5113 33.5142C57.7285 33.1497 57.9456 32.8217 58.1628 32.4936C58.8143 31.3636 59.3572 30.1607 60.1172 29.1036C60.3344 28.3746 60.5878 27.5727 60.9497 26.8072Z" fill={fill2 ?? "#03134F"}/>
<path d="M68.2617 29.6138C67.5378 30.2334 66.8864 30.8896 66.1625 31.5092C65.4024 32.1289 64.6786 32.785 63.7737 33.2225C63.3032 33.4412 62.8327 33.5505 62.326 33.3683C61.7831 32.8215 61.566 32.2018 61.6021 31.4728C61.6383 30.6709 61.8193 29.9418 62.1089 29.2128C62.145 29.1035 62.2536 28.9941 62.3984 28.9577C63.3756 29.2857 64.0995 29.2857 64.8234 28.8118C66.3797 27.7912 67.4293 26.479 67.5016 24.6199C66.9588 23.6357 65.9815 23.1983 64.9681 22.7974C64.6786 22.8703 64.389 22.9067 64.1719 22.9796C63.1947 23.6357 62.4346 24.3648 61.8917 25.2032C61.566 25.7135 61.2764 26.2238 61.0231 26.7706C61.0954 26.6977 61.204 26.5519 61.3488 26.6248C61.385 26.9164 61.204 27.1351 61.0592 27.3538C60.8059 27.7548 60.5525 28.1557 60.4078 28.6296C60.3716 28.7754 60.2992 28.9577 60.2268 29.1035L60.1906 29.1399C60.1544 29.2857 60.1182 29.4315 60.082 29.5773C59.9011 30.4522 60.082 31.327 60.4802 32.1289C60.8421 32.8944 61.4574 33.5505 62.145 34.1337C62.6518 34.5712 63.267 34.8263 63.9909 34.6805C64.4614 34.3889 64.8234 34.0244 65.1853 33.6599C65.8006 33.0402 66.3435 32.3476 66.9949 31.7644C67.8274 30.9989 68.4065 30.0876 69.058 29.2493C69.0942 29.2128 69.0941 29.1764 69.0941 29.1399C69.0941 29.1035 69.058 29.067 69.058 29.0306C68.696 29.1035 68.4789 29.3951 68.2617 29.6138ZM66.1263 24.3283C66.633 25.677 64.0995 28.7754 62.3622 28.4109C63.1947 26.6977 64.1357 25.1303 66.1263 24.3283Z" fill={fill2 ?? "#03134F"}/>
<path d="M80.1695 14.2311C80.0609 14.1582 79.9523 14.1947 79.8438 14.2676C79.9523 14.2311 80.0609 14.2311 80.1695 14.2311Z" fill={fill}/>
<path d="M79.843 14.231C79.8068 14.231 79.8068 14.231 79.7706 14.231L79.7344 14.2674H79.7706C79.8068 14.2674 79.843 14.231 79.843 14.231Z" fill={fill}/>
<path d="M79.1195 24.2553C79.0109 23.9637 78.7938 23.7815 78.5042 23.6721C77.3099 23.7086 76.3326 24.4011 75.2468 24.875C74.9935 24.6563 74.6678 25.0573 74.3782 24.8021C75.1383 22.3234 75.9707 19.8812 76.8393 17.4754C77.3461 16.9286 78.0337 16.7828 78.649 16.5641C79.952 16.1267 81.2911 15.8715 82.6303 15.7986C84.1142 15.6893 85.6343 15.4705 87.0096 16.2725C87.2268 16.3818 87.263 16.3454 87.7335 16.1631C87.4802 15.6893 87.2268 15.2518 86.7563 14.9967C86.1048 14.6686 85.4171 14.3405 84.6209 14.3041C84.1866 14.3041 83.7523 14.2312 83.2817 14.2312C82.1236 14.2312 80.9654 14.2312 79.8434 14.5957C79.4453 14.7415 79.0109 14.778 78.5766 14.8509C78.5766 14.7051 78.7938 14.5957 78.7214 14.4499C78.5042 14.4499 78.2509 14.4499 78.0337 14.4499C77.4184 13.5022 76.9117 13.1377 75.9345 12.9189C75.7535 13.8302 75.6812 14.8144 75.1745 15.6528C74.2334 16.1267 73.3286 16.6005 72.3876 17.0744C71.4104 17.5483 70.4331 18.0221 69.5645 18.6054C69.4559 19.1157 69.5645 19.5531 69.7455 19.9541C69.8902 20.2457 70.0712 20.4644 70.4693 20.5737C70.7227 20.5008 71.0122 20.4279 71.338 20.3186C72.0618 19.5531 73.0752 19.1886 73.9439 18.6054C74.0525 18.5325 74.1972 18.5325 74.342 18.7512C73.5458 21.1934 72.7133 23.7086 71.9171 26.1873C70.8675 26.9892 69.854 27.7182 68.9492 28.5566C68.9492 28.7389 68.9492 28.8847 69.0216 29.0305H69.0578C69.0578 29.0305 69.0578 29.0305 69.0578 28.994V29.0305C69.0578 29.0669 69.0578 29.1034 69.0578 29.1398C69.094 29.2856 69.1664 29.395 69.2388 29.5408C69.9264 30.0147 69.9264 30.0147 70.6865 29.9417C71.3018 29.6501 71.6999 29.0669 72.3514 28.7753C72.4962 29.6137 72.1342 30.2698 71.7723 30.9624C71.7723 31.5821 71.6275 32.2382 71.3742 32.8943C71.2656 33.1495 71.2294 33.4046 71.1932 33.6962C71.1932 33.8056 71.1932 33.9879 71.4104 33.915C71.4466 33.8421 71.5189 33.8056 71.5189 33.7327C71.9171 32.2382 72.3514 30.7437 72.7495 29.2127C72.9667 28.3743 73.401 27.7182 74.1249 27.2808C74.9211 26.8069 75.7174 26.2602 76.586 25.8592C77.1289 25.604 77.6356 25.3853 78.1423 25.0937C78.4318 24.9479 78.7576 24.8021 78.9747 24.5105C79.0833 24.4376 79.0833 24.3282 79.1195 24.2553ZM81.1463 14.9967C81.6169 15.0331 82.0512 14.8509 82.5217 14.8144C82.956 14.7415 83.3903 14.8144 83.8246 14.778C84.1866 14.7415 84.5485 14.8873 84.838 15.106C83.3903 15.2154 81.9426 15.3247 80.4949 15.4341C80.6396 15.0696 80.9292 14.9602 81.1463 14.9967ZM77.3822 14.9967C77.4546 14.9238 77.527 14.9602 77.7442 14.9238C77.5994 15.2518 77.4184 15.2883 77.2013 15.2518C77.1289 15.0331 77.3099 15.0331 77.3822 14.9967ZM73.582 25.0573C73.5096 25.2031 73.401 25.3124 73.1838 25.3853C73.0391 24.875 73.1838 24.3647 73.3286 23.8544C73.6543 23.5628 73.6543 23.0889 73.8715 22.7973C74.0525 22.7244 74.161 22.7608 74.2334 22.9066C74.2334 23.6721 73.7991 24.3282 73.582 25.0573Z" fill={fill}/>
<path d="M70.3229 32.2749C70.3229 32.6759 69.9248 33.0039 70.1058 33.6236C70.4315 33.0039 70.4677 33.0039 70.3229 32.2749Z" fill={fill}/>
<path d="M71.12 34.7167C71.1924 34.6074 71.2286 34.5345 71.2648 34.4251C71.0114 34.3887 71.0838 34.5709 71.12 34.7167Z" fill={fill}/>
<path d="M70.6843 30.5252C70.5757 30.8897 70.3585 31.2542 70.4671 31.7281C70.6119 31.6552 70.7204 31.6187 70.8652 31.5822C70.7928 31.2542 71.0824 30.999 71.1186 30.7074C71.01 30.5616 70.9376 30.4523 70.6843 30.5252Z" fill={fill}/>
<path d="M69.9609 35.8833V35.921C69.9992 35.921 69.9992 35.921 69.9609 35.8833C69.9992 35.8833 69.9992 35.8833 69.9609 35.8833Z" fill={fill}/>
<path d="M69.926 34.0244C69.745 34.5712 69.5641 35.0815 69.7089 35.6647C69.7812 35.7376 69.8898 35.7741 69.9984 35.847C69.8898 35.3002 70.1432 34.6805 69.926 34.0244Z" fill={fill}/>
<path d="M71.0462 35.4458C70.7566 35.4458 70.6481 35.6645 70.4671 35.8103C70.3223 35.9197 70.1775 35.9561 69.9966 35.9561C69.888 36.0655 69.7432 36.1384 69.707 36.3935C69.8156 36.7945 70.1413 37.159 70.4671 37.4871C70.5757 37.5964 70.7566 37.6329 70.9738 37.4506C70.9738 37.0132 71.0824 36.5029 71.191 36.029C71.1548 35.7739 71.2995 35.5552 71.0462 35.4458Z" fill={fill}/>
<path d="M79.7702 14.2676C79.553 14.2676 79.3359 14.304 79.1187 14.304C78.9739 14.304 78.8654 14.3405 78.793 14.4498C79.1549 14.4863 79.4806 14.5592 79.7702 14.2676Z" fill={fill}/>
<path d="M85.9212 24.0368C85.7764 23.3442 85.2335 23.0526 84.6544 22.8703C84.2925 22.761 83.9668 22.6516 83.641 22.3964C83.4963 22.2871 83.3153 22.1777 82.9896 22.2142C82.5914 22.4693 82.2295 22.8703 81.9399 23.3077C80.7456 25.0209 79.7683 26.8435 79.2255 28.8848C78.8273 30.4157 78.8997 31.9103 79.5512 33.3683C79.8045 33.8786 80.0941 34.3525 80.7456 34.6077C80.9989 34.6441 81.2523 34.6441 81.5056 34.4983C81.7952 34.2431 82.1209 33.8786 82.3381 33.4777C82.6276 32.8944 82.9172 32.3112 83.1705 31.6915C83.8944 29.869 84.6544 28.0464 85.3421 26.1874C85.5955 25.4948 85.885 24.7658 85.9212 24.0368ZM85.0888 25.2761C84.5459 26.5519 84.0392 27.8277 83.4963 29.1035C82.9895 30.2335 82.3381 31.327 81.4694 32.2748C81.1799 32.6028 80.9265 32.9673 80.456 33.0767C80.2027 32.5299 80.2389 31.9832 80.3474 31.4364C80.637 29.869 81.1437 28.338 82.0123 26.9529C82.3019 26.479 82.5914 26.0051 82.881 25.5313C83.0619 25.2396 83.2429 24.9845 83.4601 24.7293C83.7134 24.4377 83.9668 24.219 84.2201 24.0003C84.5821 23.8545 84.9078 23.7816 85.2335 23.8909C85.4145 24.1097 85.3783 24.3648 85.3421 24.5835C85.2697 24.7658 85.1973 25.0209 85.0888 25.2761Z" fill={fill}/>
<path d="M92.1126 24.1461C91.9678 23.4535 91.4249 23.1619 90.8458 22.9797C90.4839 22.8703 90.1582 22.761 89.8324 22.5058C89.6877 22.3965 89.5067 22.2871 89.181 22.3236C88.7828 22.5787 88.4209 22.9797 88.1314 23.4171C86.937 25.1303 85.9598 26.9529 85.4169 28.9942C85.0187 30.5251 85.0911 32.0196 85.7426 33.4777C85.9959 33.988 86.2855 34.4619 86.937 34.717C87.1903 34.7535 87.4075 34.7535 87.697 34.6077C87.9866 34.3525 88.3123 33.988 88.5295 33.587C88.819 33.0038 89.1086 32.4206 89.3619 31.8009C90.0858 29.9783 90.8458 28.1558 91.5335 26.2968C91.7869 25.6042 92.0764 24.9116 92.1126 24.1461ZM91.2802 25.3855C90.7373 26.6613 90.2306 27.9371 89.6877 29.2129C89.181 30.3429 88.5295 31.4364 87.6608 32.3841C87.3713 32.7122 87.1179 33.0767 86.6474 33.1861C86.3941 32.6393 86.4303 32.0925 86.5389 31.5458C86.8284 29.9784 87.3351 28.4474 88.2037 27.0622C88.4933 26.5884 88.7828 26.1145 89.0724 25.6406C89.2533 25.349 89.4343 25.0939 89.6515 24.8387C89.9048 24.5471 90.1582 24.3284 90.4115 24.1097C90.7735 23.9639 91.0992 23.891 91.4249 24.0003C91.6059 24.219 91.5697 24.4742 91.5335 24.6929C91.4611 24.8752 91.3887 25.1303 91.2802 25.3855Z" fill={fill}/>
<path d="M101.773 30.6343C100.941 32.0924 99.8548 33.3682 98.8052 34.6804C98.6966 34.8262 98.588 34.9356 98.4071 34.9356C98.4071 34.0972 98.6242 33.2588 98.8052 32.4569C99.0947 31.1082 99.4567 29.796 99.9634 28.4837C100.253 27.7182 100.615 26.9892 100.904 26.2237C101.375 24.9844 101.882 23.745 102.352 22.4692C102.859 21.1205 103.402 19.7718 103.908 18.4231C103.547 17.6212 103.402 16.6734 102.497 16.3818C102.28 16.4912 102.207 16.637 102.171 16.8193C102.135 17.1838 102.135 17.5483 102.026 17.8763C101.556 19.225 101.194 20.5737 100.542 21.8495C100.144 22.6515 99.7462 23.417 99.4567 24.2553C99.2033 24.9115 98.8052 25.4218 98.3347 25.8957C97.5384 25.3124 96.8507 24.6199 96.0183 24.2553C95.1497 24.146 94.5344 24.547 94.0639 25.2031C93.4848 26.005 92.9419 26.8069 92.5799 27.7547C92.3628 28.3743 91.3132 30.5614 91.5665 30.6343C91.458 31.3998 91.6751 32.1653 91.8199 32.9308C92.037 34.1701 92.6161 35.0085 93.8467 35.373C94.2448 35.373 94.7153 35.4824 95.1497 35.1179C95.1135 34.7533 95.2582 34.3524 95.4392 33.9879C95.9459 33.113 96.3802 32.1653 96.7422 31.2176C96.8146 30.9988 96.9593 30.7801 97.0679 30.5614C97.0679 30.525 97.1403 30.525 97.2127 30.525C96.9955 31.3998 96.9955 32.3111 96.9593 33.2224C96.9231 34.243 97.2851 35.0814 98.0813 35.7011C98.3347 35.8833 98.4794 36.1749 98.8052 36.2843C99.4929 36.4666 99.8548 35.9927 100.181 35.4824C100.361 35.1543 100.506 34.7898 100.687 34.4617C101.375 33.113 102.063 31.7643 102.533 30.3427C102.605 30.1605 102.75 29.9782 102.605 29.7595C102.207 29.9053 101.99 30.2698 101.773 30.6343ZM99.0585 26.5882C99.0947 26.5153 99.0947 26.4789 99.1309 26.3695C99.1671 26.4789 99.0947 26.5518 99.0585 26.5882ZM95.4754 31.4363C95.1135 32.0195 94.6792 32.5298 94.281 33.0401C93.9553 33.4046 93.8105 33.4775 93.1952 33.6963C92.8333 33.0037 92.7971 32.3476 93.0867 31.6914C93.6296 30.4156 94.0639 29.1398 94.7515 27.9369C95.3306 26.9527 96.0545 26.2602 97.0679 25.8592C97.2127 25.8592 97.3575 25.9321 97.4298 26.0415C97.4298 26.0415 97.466 26.0779 97.466 26.1144C97.5384 26.8069 97.7556 27.536 97.3575 28.1921C96.7422 29.2492 96.1269 30.3792 95.4754 31.4363ZM97.2127 30.4521C97.1765 30.2334 97.1765 30.0147 97.3575 29.8324C97.3936 30.0511 97.3575 30.2698 97.2127 30.4521ZM97.6108 29.5043C97.5384 29.6137 97.5384 29.7595 97.3936 29.7595C97.3936 29.395 97.466 29.0669 97.647 28.7753C97.9365 28.265 98.2261 27.7182 98.2623 27.0986C98.2623 26.9527 98.3347 26.7705 98.588 26.734C98.6242 27.2444 98.3709 27.6818 98.4433 28.2285C97.9727 28.5202 97.9004 29.1034 97.6108 29.5043Z" fill={fill}/>
  </svg>

)

export const IconLupa = ({fill}) => (
  <StyledSvg version="1.0" xmlns="http://www.w3.org/2000/svg"
    width="20px" height="20px" viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
    fill={fill}
  >

    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">
    <path d="M1760 5114 c-331 -41 -579 -122 -818 -266 -493 -296 -823 -783 -919
    -1358 -21 -128 -24 -435 -5 -555 50 -307 145 -556 309 -803 445 -669 1254
    -986 2048 -800 254 59 534 198 750 371 l70 57 875 -874 c767 -766 880 -875
    912 -881 79 -15 148 54 133 133 -6 32 -115 145 -881 912 l-874 875 57 70 c278
    346 423 760 423 1206 0 515 -194 983 -560 1350 -293 294 -644 474 -1060 544
    -92 16 -389 28 -460 19z m445 -248 c362 -66 665 -224 917 -478 257 -259 413
    -570 474 -943 23 -134 20 -382 -5 -527 -37 -214 -142 -484 -252 -645 -272
    -401 -672 -663 -1137 -744 -149 -26 -392 -28 -537 -4 -549 89 -1011 428 -1259
    923 -109 219 -162 431 -173 692 -23 607 282 1175 809 1502 189 117 420 200
    649 232 126 18 395 14 514 -8z"/>
    </g>
  </StyledSvg>
)

export const IconCfop = ({fill}) => (
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
    width="20px" height="20px" viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet">

    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill={fill} stroke="none">
      <path d="M1225 4180 l-1060 -618 -3 -96 c-3 -96 -2 -97 27 -126 l29 -30 171 0
      171 0 0 -970 0 -970 -64 0 c-125 0 -156 -30 -156 -150 0 -90 17 -125 68 -140
      25 -7 228 -10 637 -8 l600 3 3 180 2 180 -35 28 -35 28 0 -61 0 -60 -300 0
      -300 0 0 970 0 970 300 0 300 0 0 -755 0 -756 38 30 c20 17 82 46 137 66 55
      20 135 49 178 66 l77 31 0 659 0 659 295 0 295 0 0 -526 0 -526 97 52 c53 29
      149 83 212 120 l116 67 3 407 2 406 671 0 c727 0 712 -1 737 55 7 14 12 64 12
      110 l0 83 -102 60 c-57 33 -422 245 -813 472 -390 227 -825 480 -965 562 -140
      81 -262 148 -270 147 -8 0 -492 -279 -1075 -619z m1190 286 c282 -75 424 -379
      300 -641 -53 -111 -169 -208 -289 -240 -100 -27 -222 -18 -309 23 -94 44 -178
      126 -224 220 -33 66 -38 85 -41 167 -8 187 71 336 228 428 91 53 231 71 335
      43z"/>
      <path d="M2253 4375 c-11 -8 -23 -25 -27 -37 -3 -13 -23 -33 -43 -46 -104 -64
      -122 -199 -36 -279 34 -32 34 -33 10 -33 -13 0 -36 -9 -51 -21 -56 -44 -19
      -146 75 -208 27 -17 49 -38 49 -45 0 -21 36 -47 67 -48 39 -1 72 18 79 46 3
      14 22 31 49 44 93 45 129 145 86 235 -27 57 -82 93 -169 114 -37 9 -74 22 -82
      30 -13 13 -13 16 4 29 40 29 68 18 118 -44 13 -16 29 -22 56 -22 59 0 93 50
      72 106 -14 35 -65 90 -102 110 -16 8 -28 21 -28 29 0 46 -82 72 -127 40z m44
      -430 c22 -3 49 -13 60 -21 17 -14 17 -14 -1 -29 -27 -20 -82 -19 -101 3 -9 9
      -27 32 -41 49 l-25 33 33 -14 c18 -8 52 -17 75 -21z"/>
      <path d="M4015 3139 c-176 -11 -182 -12 -202 -54 -30 -63 12 -115 94 -115 l36
      0 -104 -86 c-568 -469 -1257 -860 -1974 -1119 -71 -26 -140 -56 -152 -68 -49
      -45 -13 -127 55 -127 18 0 105 28 195 61 754 286 1410 660 1975 1128 61 50
      112 91 114 91 1 0 1 -22 0 -50 -3 -42 0 -53 22 -75 31 -31 67 -32 102 -2 24
      21 28 37 50 178 29 189 29 182 2 213 -30 33 -47 35 -213 25z"/>
      <path d="M3827 2362 c-15 -16 -17 -45 -17 -196 0 -165 1 -178 18 -173 93 31
      168 48 227 53 127 10 115 -6 115 152 0 191 9 182 -179 182 -131 0 -150 -2
      -164 -18z"/>
      <path d="M3156 2018 c-14 -20 -16 -102 -16 -694 l0 -673 26 -20 c22 -17 41
      -21 105 -21 44 0 79 2 79 4 0 2 -18 42 -40 88 -57 120 -81 220 -87 368 -4 101
      -1 144 15 222 33 161 110 318 210 428 l52 58 0 115 c0 152 7 147 -183 147
      -139 0 -147 -1 -161 -22z"/>
      <path d="M4084 1889 c-262 -24 -499 -190 -620 -434 -64 -132 -79 -195 -79
      -355 0 -114 4 -147 23 -210 88 -279 292 -478 567 -551 110 -29 279 -29 389 0
      277 73 496 291 572 571 25 90 25 300 0 390 -45 166 -156 333 -282 428 -171
      128 -355 180 -570 161z m251 -156 c101 -25 212 -89 290 -168 123 -124 183
      -256 192 -425 18 -341 -221 -630 -564 -680 -203 -30 -418 49 -562 206 -271
      296 -211 765 125 984 152 99 337 129 519 83z"/>
      <path d="M4098 1590 c-163 -28 -287 -117 -361 -258 -45 -87 -61 -160 -55 -258
      15 -236 182 -416 423 -455 235 -39 477 126 540 368 51 197 -38 420 -215 533
      -90 57 -231 87 -332 70z m130 -76 c12 -14 22 -33 22 -43 0 -11 9 -21 23 -25
      38 -9 113 -82 131 -126 18 -46 10 -79 -26 -104 -46 -32 -64 -24 -145 65 -32
      37 -128 25 -144 -17 -14 -39 14 -61 99 -80 130 -28 195 -70 227 -146 44 -107
      -11 -230 -121 -270 -24 -9 -40 -23 -49 -45 -17 -41 -57 -67 -90 -59 -32 8 -65
      44 -65 71 0 15 -10 25 -36 34 -112 41 -184 188 -118 240 15 12 37 21 49 21 30
      0 69 -32 84 -68 7 -16 24 -36 38 -43 56 -30 163 -4 163 40 0 30 -31 48 -120
      70 -103 26 -167 63 -198 116 -19 34 -22 52 -20 112 3 62 7 76 34 110 17 21 51
      49 77 63 33 17 47 31 47 46 0 21 32 57 60 67 24 8 53 -3 78 -29z"/>
      <path d="M2513 1660 c-12 -5 -26 -18 -32 -29 -7 -13 -11 -178 -11 -496 l0
      -476 25 -25 c25 -25 27 -25 164 -22 98 2 143 7 154 17 15 12 17 61 17 511 0
      450 -2 499 -17 511 -19 17 -265 24 -300 9z"/>
      <path d="M1822 1288 c-9 -9 -12 -92 -12 -329 0 -282 2 -318 17 -330 12 -10 53
      -14 159 -14 124 0 146 2 161 18 16 16 18 45 21 315 2 227 -1 303 -11 322 -12
      25 -14 25 -168 28 -112 2 -158 -1 -167 -10z"/>
    </g>
  </svg>
)

export const IconTeleSales = ({fill}) => (
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
  width="25px" height="25px" viewBox="0 0 512.000000 512.000000"
  preserveAspectRatio="xMidYMid meet">
    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
    fill={fill} stroke="none">
    <path d="M2360 4470 c-287 -36 -567 -136 -799 -287 -468 -304 -769 -796 -830
    -1355 -6 -54 -11 -117 -11 -141 l0 -45 -55 -7 c-75 -9 -183 -65 -235 -121 -23
    -25 -56 -75 -73 -112 l-32 -67 0 -256 0 -255 37 -76 c45 -91 103 -147 196
    -191 66 -32 69 -32 246 -35 221 -5 251 2 321 72 32 32 55 66 63 92 9 30 12
    177 12 535 0 278 5 532 10 579 56 459 343 862 755 1060 119 57 198 85 325 113
    127 28 393 30 522 4 552 -111 972 -530 1085 -1085 16 -79 18 -157 18 -818 l0
    -730 -37 -76 c-45 -91 -103 -147 -196 -191 l-67 -32 -370 -3 -371 -3 -22 48
    c-32 72 -73 116 -144 154 -58 31 -70 34 -148 34 -70 0 -94 -5 -135 -25 -236
    -116 -246 -443 -17 -568 159 -87 348 -31 430 128 l34 65 381 5 c379 6 382 6
    448 31 97 38 149 71 219 141 103 104 160 248 160 404 l0 62 208 4 207 3 67 32
    c93 44 151 100 196 191 l37 76 0 255 0 256 -32 67 c-17 37 -50 87 -73 112 -52
    56 -160 112 -235 121 l-55 7 0 45 c0 24 -5 87 -11 141 -61 559 -361 1050 -830
    1356 -194 126 -451 227 -677 267 -134 23 -404 33 -522 19z m375 -160 c498 -56
    941 -322 1214 -730 175 -261 265 -526 287 -842 l7 -98 -80 0 -80 0 -7 95 c-52
    744 -618 1334 -1358 1416 -128 14 -303 7 -428 -16 -323 -61 -596 -209 -826
    -448 -249 -258 -395 -588 -420 -951 l-7 -96 -80 0 -80 0 7 102 c21 307 111
    574 279 828 342 517 961 808 1572 740z m-1695 -2205 l0 -376 -25 -24 c-23 -24
    -28 -25 -176 -25 -90 0 -168 5 -193 12 -55 16 -138 99 -154 154 -16 56 -16
    412 0 468 15 51 99 137 148 153 20 6 115 11 218 12 l182 1 0 -375z m3434 363
    c55 -16 138 -99 154 -154 16 -56 16 -412 0 -468 -16 -55 -99 -138 -154 -154
    -26 -7 -108 -12 -218 -12 l-176 0 0 400 0 400 176 0 c110 0 192 -5 218 -12z
    m-1848 -1364 c103 -49 125 -175 45 -255 -66 -66 -159 -65 -223 2 -122 128 19
    328 178 253z"/>
    </g>
  </svg>


)

export const IconProductSeparation = ({fill}) => (
  <StyledSvg xmlns="http://www.w3.org/2000/svg" version="1.0" width="25px" height="25px" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet" fill={fill}>

    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"  stroke="none">
    <path d="M3785 4791 c-26 -11 -817 -490 -828 -500 -5 -5 192 -123 438 -264 l446 -255 441 252 c242 138 440 256 441 261 0 5 -186 122 -413 259 -357 215 -419 250 -459 253 -25 1 -55 -1 -66 -6z"/>
    <path d="M741 4310 c-188 -93 -341 -172 -341 -175 0 -3 162 -86 360 -185 l360 -180 360 180 c198 99 360 182 360 185 0 3 -153 82 -341 175 -265 133 -349 170 -379 170 -30 0 -114 -37 -379 -170z"/>
    <path d="M2880 3985 l0 -145 -480 0 -480 0 0 75 0 75 -360 -180 -360 -180 0 -376 0 -376 62 35 c35 19 180 96 323 172 143 76 271 147 284 159 39 34 51 77 51 181 l0 95 480 0 480 0 0 -95 c0 -104 12 -147 51 -181 13 -11 182 -119 374 -239 193 -120 374 -234 403 -252 l52 -34 0 458 0 458 -434 248 c-238 136 -436 247 -440 247 -3 0 -6 -65 -6 -145z"/>
    <path d="M4353 3882 l-432 -247 -1 -458 0 -457 83 51 c45 29 226 142 402 252 176 110 331 209 344 221 50 44 51 57 51 486 0 220 -3 400 -7 399 -5 0 -202 -111 -440 -247z"/>
    <path d="M320 3660 c0 -354 2 -373 51 -416 13 -11 146 -85 294 -164 149 -78 294 -156 323 -172 l52 -29 0 375 0 376 -360 180 -360 180 0 -330z"/>
    <path d="M2365 2864 c-269 -41 -508 -164 -706 -363 -196 -196 -318 -432 -364 -703 l-6 -38 -84 0 -85 0 0 400 0 400 -160 0 -161 0 3 -509 c3 -497 4 -510 24 -537 49 -67 57 -69 269 -72 l194 -3 7 -37 c45 -270 167 -507 363 -703 153 -154 303 -247 504 -314 447 -149 947 -33 1285 298 199 195 314 411 372 699 l11 57 194 3 c212 3 220 5 269 72 20 27 21 40 24 537 l3 509 -161 0 -160 0 0 -400 0 -400 -84 0 -85 0 -11 58 c-59 294 -175 510 -382 708 -284 273 -682 398 -1073 338z m305 -309 c19 -7 205 -97 413 -200 316 -156 382 -192 405 -223 l27 -35 0 -521 0 -521 -28 -57 c-15 -32 -48 -74 -71 -95 -24 -21 -224 -134 -450 -254 l-406 -217 -413 220 c-263 140 -426 233 -450 256 -21 20 -50 62 -65 92 l-27 55 -3 495 c-2 272 0 509 3 527 12 69 40 86 442 283 367 181 418 204 473 213 34 6 107 -3 150 -18z"/>
    <path d="M2181 2230 c-188 -93 -341 -172 -341 -175 0 -3 162 -86 360 -185 l360 -180 360 180 c198 99 360 182 360 185 0 3 -153 82 -341 175 -265 133 -349 170 -379 170 -30 0 -114 -37 -379 -170z"/>
    <path d="M1760 1500 c0 -440 1 -452 51 -496 13 -11 146 -85 294 -164 149 -78 294 -156 323 -172 l52 -29 0 455 0 456 -360 180 -360 180 0 -410z"/>
    <path d="M2998 1729 l-358 -179 0 -456 0 -456 63 35 c34 19 182 98 329 177 276 146 312 172 323 233 3 18 4 210 3 428 l-3 397 -357 -179z"/>
    </g>
  </StyledSvg>
)

export const IconProductValidation = ({fill}) => (
  <StyledSvg xmlns="http://www.w3.org/2000/svg" version="1.0" width="25px" height="25px" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet" fill={fill}>
  <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">
  <path d="M1140 4464 c-234 -50 -436 -254 -485 -489 -22 -105 -22 -2725 0 -2830 50 -237 252 -439 491 -490 103 -22 2724 -22 2829 0 181 38 349 168 433 335 75 151 72 67 72 1570 0 1503 3 1419 -72 1570 -84 167 -252 297 -433 335 -102 21 -2736 21 -2835 -1z m2138 -1280 c112 -47 165 -181 112 -288 -13 -27 -176 -196 -477 -497 -487 -485 -480 -479 -575 -479 -73 0 -124 40 -369 287 -259 261 -265 269 -257 374 10 142 160 230 295 174 23 -10 99 -77 190 -168 l153 -152 368 367 c228 228 380 373 402 382 46 20 111 20 158 0z"/>
  </g>
  </StyledSvg>
)

export const IconLabel = ({fill}) => (
  <StyledSvg version="1.0" xmlns="http://www.w3.org/2000/svg"
    width="20px" height="20px" viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet">

    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
    fill={fill} stroke="none">
    <path d="M2790 5097 c-157 -47 -95 10 -1452 -1346 -1382 -1382 -1304 -1296
    -1330 -1450 -15 -87 -1 -169 43 -261 29 -60 110 -144 978 -1011 867 -868 951
    -949 1011 -978 92 -44 174 -58 261 -43 153 26 69 -51 1445 1324 1371 1370
    1308 1301 1353 1468 20 73 21 98 21 996 0 575 -4 942 -10 975 -32 169 -170
    307 -340 339 -33 6 -396 10 -979 9 l-926 0 -75 -22z m1170 -849 c200 -60 329
    -262 300 -469 -26 -182 -177 -333 -359 -359 -279 -39 -520 202 -481 481 36
    252 297 420 540 347z"/>
    </g>
  </StyledSvg>

)

export const IconDiscount = ({fill}) => (
  <StyledSvg xmlns="http://www.w3.org/2000/svg" version="1.0" width="20px" height="20px" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">
    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill={fill} stroke="none">
    <path d="M1994 4831 c-71 -32 -119 -94 -204 -261 -43 -85 -88 -164 -99 -174 -24 -22 -61 -19 -234 20 -196 45 -298 34 -376 -39 -66 -63 -78 -115 -85 -362 -2 -82 -9 -162 -15 -176 -11 -31 -46 -45 -221 -85 -205 -47 -295 -106 -326 -211 -25 -87 -12 -142 82 -345 39 -83 64 -150 64 -170 0 -39 -25 -66 -150 -164 -158 -123 -214 -203 -214 -304 0 -101 56 -181 214 -304 125 -98 150 -125 150 -164 0 -20 -25 -87 -64 -170 -94 -203 -107 -258 -82 -345 31 -105 121 -164 326 -211 174 -40 210 -54 221 -84 6 -15 12 -99 15 -187 2 -88 7 -178 10 -200 15 -93 70 -167 149 -201 61 -26 167 -21 326 15 164 37 189 38 216 8 11 -12 55 -89 96 -172 108 -214 174 -274 297 -275 70 0 140 32 239 108 149 116 204 152 230 152 33 0 62 -18 191 -120 131 -103 205 -140 280 -140 124 1 189 61 297 275 41 83 85 160 96 172 27 30 50 29 215 -8 233 -53 333 -41 411 47 54 62 69 129 75 334 2 91 9 177 14 191 12 31 45 43 222 85 207 48 295 105 326 211 25 87 12 142 -82 345 -40 86 -64 149 -64 171 0 38 21 59 198 202 223 179 223 351 0 530 -177 143 -198 164 -198 202 0 22 24 85 64 171 94 203 107 258 82 345 -31 106 -112 160 -314 208 -193 46 -222 57 -233 88 -6 14 -12 94 -15 176 -6 245 -19 299 -85 362 -78 73 -180 84 -376 39 -173 -39 -210 -42 -234 -20 -11 10 -56 89 -99 174 -111 219 -176 279 -300 280 -75 0 -149 -37 -280 -140 -129 -102 -158 -120 -191 -120 -26 0 -81 36 -230 152 -137 105 -239 132 -335 89z m172 -1392 c76 -29 156 -105 196 -187 30 -60 33 -75 33 -157 0 -80 -4 -97 -31 -155 -39 -83 -101 -145 -184 -184 -58 -27 -75 -31 -155 -31 -82 0 -97 3 -157 33 -153 75 -240 242 -207 400 49 237 279 365 505 281z m1215 -58 c33 -33 39 -84 15 -129 -18 -33 -1502 -1515 -1533 -1531 -12 -6 -38 -11 -58 -11 -75 0 -119 86 -81 158 17 30 1500 1514 1531 1531 40 21 94 13 126 -18z m-126 -1020 c150 -74 236 -243 205 -399 -32 -157 -144 -269 -302 -301 -158 -33 -325 54 -400 207 -30 60 -33 75 -33 157 0 80 3 97 31 155 69 145 200 224 358 216 62 -3 91 -11 141 -35z"/>
    <path d="M1952 3233 c-49 -24 -75 -68 -80 -132 -5 -71 22 -116 90 -149 63 -31 115 -24 169 25 65 59 73 148 18 217 -43 55 -130 73 -197 39z"/>
    <path d="M3044 2179 c-45 -13 -100 -78 -109 -128 -15 -88 63 -181 152 -181 95 0 154 55 161 149 5 70 -22 115 -88 149 -47 24 -67 25 -116 11z"/>
    </g>
  </StyledSvg>

)

export const TopActionsWrapper = styled.div`
    width: 100%;
    padding: 12px;
`;

export const ListProductsWrapper = styled(TopActionsWrapper)`
    height: auto;
    display: flex;
    flex-direction: column;
    font-weight: ${({ theme }) => theme.font_weight.large};
    font-size: ${({ theme }) => theme.font_size.small};
    line-height: ${({ theme }) => theme.lines_height.medium} ;
    color: ${({ theme }) => theme.colors.gray} ;
    gap: ${({ theme }) => theme.gaps.medium};
    
`;

export const MoreInfoWrapper = styled.div`
    width: 100%;
    display:flex;
    flex-direction: column;
    gap:${({ theme }) => theme.gaps.large};
    padding: 24px 0 ;
    font-weight: ${({ theme }) => theme.font_weight.medium};
    font-size: ${({ theme }) => theme.font_size.small};
    line-height: ${({ theme }) => theme.lines_height.medium};
    color: ${({ theme }) => theme.colors.gray2};
    align-items:center;
    margin-bottom: 90px;

    h2{
        font-weight: ${({ theme }) => theme.font_weight.large};
        font-size: ${({ theme }) => theme.font_size.large};
        line-height: 23px;
        color: ${({ theme }) => theme.colors.gray} ;
    }

`;

export const EditWrapper = styled.div`
  display: flex;
  font-weight: ${({ theme }) => theme.font_weight.large} ;
  font-size: ${({ theme }) => theme.font_size.small};
  line-height: ${({ theme }) => theme.lines_height.medium};
  text-decoration-line: underline;
  color: ${({ theme }) => theme.colors.red2};
  cursor: pointer;
`;

export const InfoContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  gap:${({ theme }) => theme.gaps.large};

  @media(max-width: 500px){
    flex-wrap: wrap;
  }
`;

export const InputsWrapper = styled.div`
    display:flex;
    flex-direction: column;
    gap:${({ theme }) => theme.gaps.small};
    align-items:center;
`;

export const InputInfo = styled.div`
    display: flex;
    justify-content: center;
    padding: 10px 16px;
    width: auto;
    gap: ${({ theme }) => theme.gaps.small};
    min-width: 167px;
    height: 38px;
    background: ${({ theme }) => theme.backgrounds.gray7};
    border: 1.5px solid #999999;
    border-radius: 20px;
`;

export const AncorPosition = styled.div`
  min-width: 100%;
  position:relative;
  height:100%;
`;

export const TopActions = styled.div`
    width: 100%;
    height: 68px;
    border-bottom: ${({ theme }) => theme.border.very_small_gray5};
`;

export const ContainerSales = styled.div`
  display:flex;
  justify-content:center;
  align-items: center;
  width: 100%;
  height: 68px;
  border-bottom: ${({ theme }) => theme.border.very_small_gray5};

  P{
    display: -webkit-box;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;

export const ListProductEstruct = styled.div`
    background: ${({ theme }) => theme.backgrounds.white} ;
    border: ${({ theme }) => theme.border.small_gray4};
    border-radius: ${({ theme }) => theme.border_radius.more_less_big};
    padding: 12px 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 12px;
`;

export const ListProduct = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
`;

export const ProductWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap:${({ theme }) => theme.gaps.very_small};

`;

export const ProductWrapperScroll = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap:${({ theme }) => theme.gaps.very_small};
  overflow-x:auto;

`;

export const Item = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 8px 0 8px;
    font-weight: ${({ theme }) => theme.font_weight.medium};
    font-size: ${({ theme }) => theme.font_size.small};
    line-height: ${({ theme }) => theme.lines_height.medium};
    color: ${({ theme }) => theme.colors.gray};
    img{
      margin-right:8px; 
    }

    span{
        font-weight: ${({ theme }) => theme.font_weight.large};
    }
`;


export const ItemNameQtd = styled.div`
    display: flex;
    gap:38px;
    align-items: center;
    width: 60%;
    .text-overflow{
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    @media(max-width: 500px){
        gap:15px;
    }
`;

export const ItemValueActions = styled.div`
  display: flex;
  gap:20px;
  align-items: center;
  justify-content: space-between ;
  width: 40%;

  .spinner-border {
    width:20px;
    height:20px;
  }

  div{
    cursor: pointer;
    display: flex;
    gap:20px;

  }

  .item-qtd{
    text-align: right;
    min-width: 60px
  }

  .price-buy {
    text-align: right;
    min-width: 100px;
  }

  .isvisible-dropdown{
      display: none;
  }

  .end-item{
    text-align: right;
    min-width: 100px;
  }

  @media(max-width:600px){
      gap: 15px;
      .display-none{
          display: none;
      }

      .isvisible-dropdown{
          display: flex;
          justify-content: center;
      }
  }

  @media(max-width:320px){
      gap: 0;
  }
`;

export const SubTotal = styled.div`
    display: flex;
    padding: 16px 0px 0px;
    margin-top:10px;
    height: 34px;
    align-items: center;
    font-weight: ${({ theme }) => theme.font_weight.large};
    font-size: ${({ theme }) => theme.font_size.small};
    line-height: ${({ theme }) => theme.lines_height.medium};
    color: ${({ theme }) => theme.colors.gray};
    justify-content: space-between;
    border-top: ${({ theme }) => theme.border.very_small_gray5};
`;

export const Actions =styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media(min-width: 1550px){
        #Adicionar-produto{
          display: ${props => props.display ?? 'none'};
        }

    }
`;

export const RedirectButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: ${({ theme }) => theme.paddings.small};
    gap: ${({ theme }) => theme.gaps.small};
    width: ${props=>props.width};
    height: ${props=>props.height};
    border-radius: ${({ theme }) => theme.border_radius.small};
    line-height: ${({ theme }) => theme.lines_height.medium};
    border: ${props=>props.variant === 1? props.theme.border.small_red2 : 'none'};
    background-color:${props=> props.variant === 1 ? props.theme.backgrounds.white :  props.theme.backgrounds.red2 } ;
    font-weight: ${props=>props.fontWeight};
    font-size: ${props=>props.fontSize};
    color:${props=> props.variant === 1 ? props.theme.colors.red2 : props.theme.colors.white };

    @media(max-width: 500px){
      width:auto;
      span{
        display: none;
      }
    }
`;

export const WrapperTooltip = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    gap: ${({ theme }) => theme.gaps.small};
    width: ${props=>props.width};
    border-radius: ${({ theme }) => theme.border_radius.small};
    line-height: ${({ theme }) => theme.lines_height.medium};
    border: ${props=>props.variant === 1? props.theme.border.small_red2 : 'none'};
    background-color:${props=> props.variant === 1 ? props.theme.backgrounds.white :  props.theme.backgrounds.red2 } ;
    font-weight: ${props=>props.fontWeight};
    font-size: ${props=>props.fontSize};
    color:${props=> props.variant === 1 ? props.theme.colors.red2 : props.theme.colors.white };
    height:${props=> props.height ?? props.theme.height._48};

    .my-css{
      outline: none;
      box-shadow: none;   
      display: ${({ theme }) => theme.display.flex};
      align-items: ${({ theme }) => theme.align_items.center};
      justify-content: ${({ theme }) => theme.justify_content.space_between};
      width: 100%;
      height:100%;
    }

    .dropdown-menu {
      display: flex;
      flex-direction: column;
      overflow-y: auto;
      min-width: ${props => props.min_width !== '' ? props.min_width : '220px' };
      border: ${({ theme }) => theme.border.very_small_gray5};
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      border-radius: ${({ theme }) => theme.border_radius.medium};
      font-size: ${({ theme }) => theme.font_size.small};
      line-height: ${({ theme }) => theme.lines_height.medium};
      /* width: 100%; */
      min-width: 100%;
      background-color: ${({ theme }) => theme.backgrounds.white};
    }

    .dropdown button{
      font-weight: ${props=>props.theme.font_weight.large};
      color: ${({theme}) => theme.colors.red2};
      font-size: ${props=> props.theme.font_size.medium};
      width:100%;
    }

    .dropdown-item {
      color: ${({ theme }) => theme.colors.black};
      width:100%;
    }

    .dropdown-item:hover, .dropdown-item:focus{
      background-color: ${props => props.theme.backgrounds.gray7};
    }
`;


export const  WrapperToggles = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;  
    padding: 0 0 24px 0;
    font-weight: ${({ theme }) => theme.font_weight.large};
    font-size: ${({ theme }) => theme.font_size.medium};
    line-height: ${({ theme }) => theme.lines_height.large};
    color: ${({ theme }) => theme.colors.gray};
    border-bottom: ${({ theme }) => theme.border.very_small_gray5};
    margin-bottom: 12px;

    @media(max-width: 520px){
      flex-wrap: wrap;
    }
`;


